/* eslint-disable no-loss-of-precision */
import { generateAir } from './dataGenerator';
import { airFlow, airPressure, airVolume } from './airWaves';

function renderGraph(wave) {
  return [...wave];
}

const airLatest = [
  {
    timeStamp: '2025-08-14T20:55:50.169Z',
    ppeak: 21,
    peep: 6,
    rrate: 13,
    spo2: 99,
    vte: 465,
    vmi: 9,
    vme: 10.7,
    vti: 512,
    pplat: 21,
    pmean: 14,
    ri: 0.9,
    re: 1,
    cdyn: 64,
    cstat: 68,
    peep_total: 10.87,
    o2_concentration: 80,
    leakage: 0.19,
    vee: 12,
    vme_spont: 5,
    ti: 0.7,
    ti_per_ttotal: 0.27,
    vme_spont_per_vme: 0.6,
  },
  {
    timeStamp: '2025-08-14T20:55:56.169Z',
    ppeak: 22,
    peep: 7,
    rrate: 14,
    spo2: 97,
    vte: 485,
    vmi: 6,
    vme: 11.8,
    vti: 434,
    pplat: 19,
    pmean: 11,
    ri: 1,
    re: 0.9,
    cdyn: 51,
    cstat: 66,
    peep_total: 11.92,
    o2_concentration: 81,
    leakage: 0.19,
    vee: 10,
    vme_spont: 5,
    ti: 0.6,
    ti_per_ttotal: 0.29,
    vme_spont_per_vme: 0.7,
  },
  {
    timeStamp: '2025-08-14T20:56:02.169Z',
    ppeak: 23,
    peep: 5,
    rrate: 17,
    spo2: 98,
    vte: 402,
    vmi: 8,
    vme: 11.4,
    vti: 479,
    pplat: 20,
    pmean: 14,
    ri: 0.9,
    re: 0.8,
    cdyn: 60,
    cstat: 60,
    peep_total: 11.84,
    o2_concentration: 81,
    leakage: 0.19,
    vee: 12,
    vme_spont: 5,
    ti: 0.6,
    ti_per_ttotal: 0.21,
    vme_spont_per_vme: 0.7,
  },
  {
    timeStamp: '2025-08-14T20:56:08.169Z',
    ppeak: 17,
    peep: 5,
    rrate: 13,
    spo2: 99,
    vte: 462,
    vmi: 8,
    vme: 10.3,
    vti: 548,
    pplat: 17,
    pmean: 13,
    ri: 0.8,
    re: 0.6,
    cdyn: 44,
    cstat: 73,
    peep_total: 11.16,
    o2_concentration: 82,
    leakage: 0.19,
    vee: 12,
    vme_spont: 5,
    ti: 0.6,
    ti_per_ttotal: 0.22,
    vme_spont_per_vme: 0.6,
  },
  {
    timeStamp: '2025-08-14T20:56:14.169Z',
    ppeak: 22,
    peep: 6,
    rrate: 13,
    spo2: 98,
    vte: 488,
    vmi: 7,
    vme: 10.3,
    vti: 500,
    pplat: 16,
    pmean: 13,
    ri: 0.8,
    re: 1,
    cdyn: 60,
    cstat: 72,
    peep_total: 11.72,
    o2_concentration: 81,
    leakage: 0.17,
    vee: 10,
    vme_spont: 6,
    ti: 0.7,
    ti_per_ttotal: 0.19,
    vme_spont_per_vme: 0.7,
  },
  {
    timeStamp: '2025-08-14T20:56:20.169Z',
    ppeak: 21,
    peep: 8,
    rrate: 13,
    spo2: 100,
    vte: 487,
    vmi: 7,
    vme: 10.8,
    vti: 508,
    pplat: 20,
    pmean: 10,
    ri: 0.7,
    re: 0.9,
    cdyn: 67,
    cstat: 56,
    peep_total: 11.27,
    o2_concentration: 81,
    leakage: 0.18,
    vee: 12,
    vme_spont: 6,
    ti: 0.7,
    ti_per_ttotal: 0.11,
    vme_spont_per_vme: 0.7,
  },
  {
    timeStamp: '2025-08-14T20:56:26.169Z',
    ppeak: 24,
    peep: 7,
    rrate: 13,
    spo2: 96,
    vte: 551,
    vmi: 7,
    vme: 11.6,
    vti: 444,
    pplat: 20,
    pmean: 10,
    ri: 1,
    re: 0.8,
    cdyn: 68,
    cstat: 66,
    peep_total: 11.18,
    o2_concentration: 83,
    leakage: 0.18,
    vee: 10,
    vme_spont: 5,
    ti: 0.5,
    ti_per_ttotal: 0.16,
    vme_spont_per_vme: 0.5,
  },
  {
    timeStamp: '2025-08-14T20:56:32.169Z',
    ppeak: 23,
    peep: 5,
    rrate: 12,
    spo2: 97,
    vte: 543,
    vmi: 8,
    vme: 11.5,
    vti: 587,
    pplat: 16,
    pmean: 10,
    ri: 0.8,
    re: 0.8,
    cdyn: 66,
    cstat: 74,
    peep_total: 11.16,
    o2_concentration: 84,
    leakage: 0.19,
    vee: 12,
    vme_spont: 5,
    ti: 0.6,
    ti_per_ttotal: 0.24,
    vme_spont_per_vme: 0.8,
  },
  {
    timeStamp: '2025-08-14T20:56:38.169Z',
    ppeak: 18,
    peep: 6,
    rrate: 15,
    spo2: 99,
    vte: 498,
    vmi: 7,
    vme: 11.2,
    vti: 545,
    pplat: 16,
    pmean: 13,
    ri: 0.7,
    re: 0.8,
    cdyn: 53,
    cstat: 75,
    peep_total: 11.05,
    o2_concentration: 81,
    leakage: 0.18,
    vee: 11,
    vme_spont: 6,
    ti: 0.6,
    ti_per_ttotal: 0.21,
    vme_spont_per_vme: 0.7,
  },
  {
    timeStamp: '2025-08-14T20:56:44.169Z',
    ppeak: 20,
    peep: 6,
    rrate: 12,
    spo2: 97,
    vte: 529,
    vmi: 7,
    vme: 11.6,
    vti: 599,
    pplat: 18,
    pmean: 12,
    ri: 0.9,
    re: 0.9,
    cdyn: 59,
    cstat: 56,
    peep_total: 11.3,
    o2_concentration: 83,
    leakage: 0.19,
    vee: 10,
    vme_spont: 5,
    ti: 0.5,
    ti_per_ttotal: 0.16,
    vme_spont_per_vme: 0.7,
  },
  {
    timeStamp: '2025-08-14T20:56:50.169Z',
    ppeak: 21,
    peep: 7,
    rrate: 13,
    spo2: 97,
    vte: 545,
    vmi: 9,
    vme: 12,
    vti: 541,
    pplat: 19,
    pmean: 14,
    ri: 0.6,
    re: 0.9,
    cdyn: 45,
    cstat: 62,
    peep_total: 11.45,
    o2_concentration: 82,
    leakage: 0.18,
    vee: 10,
    vme_spont: 5,
    ti: 0.7,
    ti_per_ttotal: 0.12,
    vme_spont_per_vme: 0.8,
  },
  {
    timeStamp: '2025-08-14T20:56:56.169Z',
    ppeak: 25,
    peep: 6,
    rrate: 16,
    spo2: 96,
    vte: 473,
    vmi: 8,
    vme: 11.4,
    vti: 572,
    pplat: 20,
    pmean: 10,
    ri: 0.8,
    re: 0.9,
    cdyn: 45,
    cstat: 57,
    peep_total: 11.37,
    o2_concentration: 81,
    leakage: 0.17,
    vee: 11,
    vme_spont: 5,
    ti: 0.8,
    ti_per_ttotal: 0.28,
    vme_spont_per_vme: 0.6,
  },
  {
    timeStamp: '2025-08-14T20:57:02.169Z',
    ppeak: 18,
    peep: 6,
    rrate: 13,
    spo2: 99,
    vte: 573,
    vmi: 9,
    vme: 11.8,
    vti: 402,
    pplat: 15,
    pmean: 11,
    ri: 0.9,
    re: 1,
    cdyn: 58,
    cstat: 74,
    peep_total: 11.86,
    o2_concentration: 83,
    leakage: 0.19,
    vee: 12,
    vme_spont: 5,
    ti: 0.6,
    ti_per_ttotal: 0.28,
    vme_spont_per_vme: 0.8,
  },
  {
    timeStamp: '2025-08-14T20:57:08.169Z',
    ppeak: 19,
    peep: 6,
    rrate: 16,
    spo2: 96,
    vte: 442,
    vmi: 9,
    vme: 10.2,
    vti: 545,
    pplat: 19,
    pmean: 14,
    ri: 0.9,
    re: 0.9,
    cdyn: 56,
    cstat: 69,
    peep_total: 10.89,
    o2_concentration: 82,
    leakage: 0.17,
    vee: 11,
    vme_spont: 6,
    ti: 0.8,
    ti_per_ttotal: 0.21,
    vme_spont_per_vme: 0.7,
  },
  {
    timeStamp: '2025-08-14T20:57:14.169Z',
    ppeak: 21,
    peep: 6,
    rrate: 14,
    spo2: 97,
    vte: 492,
    vmi: 8,
    vme: 11.9,
    vti: 429,
    pplat: 17,
    pmean: 13,
    ri: 0.9,
    re: 0.9,
    cdyn: 57,
    cstat: 74,
    peep_total: 11.86,
    o2_concentration: 83,
    leakage: 0.19,
    vee: 12,
    vme_spont: 5,
    ti: 0.5,
    ti_per_ttotal: 0.21,
    vme_spont_per_vme: 0.7,
  },
  {
    timeStamp: '2025-08-14T20:57:20.169Z',
    ppeak: 23,
    peep: 7,
    rrate: 17,
    spo2: 99,
    vte: 508,
    vmi: 7,
    vme: 11.4,
    vti: 557,
    pplat: 19,
    pmean: 11,
    ri: 0.9,
    re: 0.7,
    cdyn: 60,
    cstat: 80,
    peep_total: 11.61,
    o2_concentration: 84,
    leakage: 0.17,
    vee: 10,
    vme_spont: 6,
    ti: 0.7,
    ti_per_ttotal: 0.29,
    vme_spont_per_vme: 0.7,
  },
  {
    timeStamp: '2025-08-14T20:57:26.169Z',
    ppeak: 15,
    peep: 8,
    rrate: 15,
    spo2: 98,
    vte: 584,
    vmi: 8,
    vme: 11.6,
    vti: 480,
    pplat: 17,
    pmean: 10,
    ri: 0.9,
    re: 0.7,
    cdyn: 57,
    cstat: 78,
    peep_total: 11.01,
    o2_concentration: 81,
    leakage: 0.18,
    vee: 10,
    vme_spont: 5,
    ti: 0.8,
    ti_per_ttotal: 0.22,
    vme_spont_per_vme: 0.7,
  },
  {
    timeStamp: '2025-08-14T20:57:32.169Z',
    ppeak: 17,
    peep: 8,
    rrate: 16,
    spo2: 97,
    vte: 567,
    vmi: 8,
    vme: 11,
    vti: 417,
    pplat: 18,
    pmean: 15,
    ri: 0.8,
    re: 0.7,
    cdyn: 49,
    cstat: 69,
    peep_total: 10.96,
    o2_concentration: 85,
    leakage: 0.19,
    vee: 11,
    vme_spont: 5,
    ti: 0.8,
    ti_per_ttotal: 0.29,
    vme_spont_per_vme: 0.6,
  },
  {
    timeStamp: '2025-08-14T20:57:38.169Z',
    ppeak: 22,
    peep: 7,
    rrate: 18,
    spo2: 97,
    vte: 542,
    vmi: 9,
    vme: 11.7,
    vti: 444,
    pplat: 15,
    pmean: 15,
    ri: 0.6,
    re: 1,
    cdyn: 45,
    cstat: 67,
    peep_total: 11.79,
    o2_concentration: 82,
    leakage: 0.18,
    vee: 10,
    vme_spont: 5,
    ti: 0.7,
    ti_per_ttotal: 0.11,
    vme_spont_per_vme: 0.8,
  },
  {
    timeStamp: '2025-08-14T20:57:44.169Z',
    ppeak: 25,
    peep: 5,
    rrate: 12,
    spo2: 100,
    vte: 457,
    vmi: 8,
    vme: 11.5,
    vti: 410,
    pplat: 20,
    pmean: 13,
    ri: 0.9,
    re: 0.7,
    cdyn: 61,
    cstat: 61,
    peep_total: 11.74,
    o2_concentration: 81,
    leakage: 0.2,
    vee: 11,
    vme_spont: 5,
    ti: 0.7,
    ti_per_ttotal: 0.24,
    vme_spont_per_vme: 0.7,
  },
  {
    timeStamp: '2025-08-14T20:57:50.169Z',
    ppeak: 15,
    peep: 6,
    rrate: 13,
    spo2: 97,
    vte: 587,
    vmi: 7,
    vme: 11.5,
    vti: 525,
    pplat: 16,
    pmean: 11,
    ri: 0.9,
    re: 0.8,
    cdyn: 47,
    cstat: 52,
    peep_total: 11.67,
    o2_concentration: 84,
    leakage: 0.19,
    vee: 12,
    vme_spont: 5,
    ti: 0.6,
    ti_per_ttotal: 0.12,
    vme_spont_per_vme: 0.8,
  },
  {
    timeStamp: '2025-08-14T20:57:56.169Z',
    ppeak: 23,
    peep: 6,
    rrate: 14,
    spo2: 98,
    vte: 447,
    vmi: 8,
    vme: 11.1,
    vti: 455,
    pplat: 22,
    pmean: 14,
    ri: 0.7,
    re: 0.8,
    cdyn: 40,
    cstat: 54,
    peep_total: 10.9,
    o2_concentration: 83,
    leakage: 0.19,
    vee: 12,
    vme_spont: 6,
    ti: 0.7,
    ti_per_ttotal: 0.31,
    vme_spont_per_vme: 0.6,
  },
  {
    timeStamp: '2025-08-14T20:58:02.169Z',
    ppeak: 16,
    peep: 6,
    rrate: 14,
    spo2: 98,
    vte: 536,
    vmi: 9,
    vme: 11.1,
    vti: 528,
    pplat: 15,
    pmean: 13,
    ri: 1,
    re: 1,
    cdyn: 53,
    cstat: 77,
    peep_total: 11.53,
    o2_concentration: 81,
    leakage: 0.2,
    vee: 12,
    vme_spont: 6,
    ti: 0.7,
    ti_per_ttotal: 0.22,
    vme_spont_per_vme: 0.7,
  },
  {
    timeStamp: '2025-08-14T20:58:08.169Z',
    ppeak: 22,
    peep: 6,
    rrate: 14,
    spo2: 97,
    vte: 591,
    vmi: 9,
    vme: 10.5,
    vti: 505,
    pplat: 17,
    pmean: 11,
    ri: 1,
    re: 0.7,
    cdyn: 49,
    cstat: 64,
    peep_total: 11.16,
    o2_concentration: 81,
    leakage: 0.18,
    vee: 11,
    vme_spont: 6,
    ti: 0.6,
    ti_per_ttotal: 0.22,
    vme_spont_per_vme: 0.7,
  },
  {
    timeStamp: '2025-08-14T20:58:14.169Z',
    ppeak: 23,
    peep: 7,
    rrate: 14,
    spo2: 100,
    vte: 480,
    vmi: 6,
    vme: 11,
    vti: 500,
    pplat: 16,
    pmean: 12,
    ri: 1,
    re: 0.8,
    cdyn: 41,
    cstat: 68,
    peep_total: 11.24,
    o2_concentration: 80,
    leakage: 0.19,
    vee: 11,
    vme_spont: 6,
    ti: 0.7,
    ti_per_ttotal: 0.29,
    vme_spont_per_vme: 0.7,
  },
  {
    timeStamp: '2025-08-14T20:58:20.169Z',
    ppeak: 19,
    peep: 7,
    rrate: 13,
    spo2: 100,
    vte: 539,
    vmi: 9,
    vme: 11.8,
    vti: 475,
    pplat: 19,
    pmean: 11,
    ri: 0.8,
    re: 0.7,
    cdyn: 41,
    cstat: 52,
    peep_total: 11.97,
    o2_concentration: 80,
    leakage: 0.2,
    vee: 11,
    vme_spont: 5,
    ti: 0.6,
    ti_per_ttotal: 0.27,
    vme_spont_per_vme: 0.7,
  },
  {
    timeStamp: '2025-08-14T20:58:26.169Z',
    ppeak: 20,
    peep: 6,
    rrate: 18,
    spo2: 100,
    vte: 421,
    vmi: 8,
    vme: 10.8,
    vti: 507,
    pplat: 15,
    pmean: 12,
    ri: 0.9,
    re: 0.8,
    cdyn: 57,
    cstat: 59,
    peep_total: 10.96,
    o2_concentration: 82,
    leakage: 0.19,
    vee: 11,
    vme_spont: 5,
    ti: 0.7,
    ti_per_ttotal: 0.12,
    vme_spont_per_vme: 0.6,
  },
  {
    timeStamp: '2025-08-14T20:58:32.169Z',
    ppeak: 19,
    peep: 7,
    rrate: 17,
    spo2: 97,
    vte: 494,
    vmi: 8,
    vme: 10.5,
    vti: 535,
    pplat: 21,
    pmean: 11,
    ri: 0.8,
    re: 0.9,
    cdyn: 49,
    cstat: 53,
    peep_total: 11.79,
    o2_concentration: 80,
    leakage: 0.18,
    vee: 11,
    vme_spont: 6,
    ti: 0.8,
    ti_per_ttotal: 0.33,
    vme_spont_per_vme: 0.8,
  },
  {
    timeStamp: '2025-08-14T20:58:38.169Z',
    ppeak: 23,
    peep: 6,
    rrate: 17,
    spo2: 99,
    vte: 549,
    vmi: 8,
    vme: 12,
    vti: 505,
    pplat: 21,
    pmean: 15,
    ri: 0.9,
    re: 0.6,
    cdyn: 46,
    cstat: 64,
    peep_total: 11.49,
    o2_concentration: 82,
    leakage: 0.18,
    vee: 10,
    vme_spont: 5,
    ti: 0.5,
    ti_per_ttotal: 0.15,
    vme_spont_per_vme: 0.7,
  },
  {
    timeStamp: '2025-08-14T20:58:44.169Z',
    ppeak: 22,
    peep: 7,
    rrate: 17,
    spo2: 97,
    vte: 445,
    vmi: 6,
    vme: 10.5,
    vti: 562,
    pplat: 22,
    pmean: 14,
    ri: 0.8,
    re: 0.8,
    cdyn: 47,
    cstat: 69,
    peep_total: 11.64,
    o2_concentration: 81,
    leakage: 0.2,
    vee: 11,
    vme_spont: 6,
    ti: 0.5,
    ti_per_ttotal: 0.29,
    vme_spont_per_vme: 0.8,
  },
];

export const air = {
  GetAirDashboard: () => ({
    getAirDashboard: {
      ventMode: 'VS_PRVC',
      flowTrigger: 'ASSISTED',
      flowControl: 'VOLUME',
      automode: null,
      trigger: null,
      dashboard: [
        {
          name: 'cstat',
          value: [
            {
              value: '100',
              timeStamp: '2022-10-11T02:05:56.922Z',
              __typename: 'AirParam',
            },
            {
              value: '78',
              timeStamp: '2022-10-11T02:06:56.927Z',
              __typename: 'AirParam',
            },
            {
              value: '57',
              timeStamp: '2022-10-11T02:07:56.937Z',
              __typename: 'AirParam',
            },
            {
              value: '50',
              timeStamp: '2022-10-11T02:08:56.941Z',
              __typename: 'AirParam',
            },
            {
              value: '60',
              timeStamp: '2022-10-11T02:09:56.946Z',
              __typename: 'AirParam',
            },
            {
              value: '82',
              timeStamp: '2022-10-11T02:10:56.951Z',
              __typename: 'AirParam',
            },
            {
              value: '103',
              timeStamp: '2022-10-11T02:11:56.958Z',
              __typename: 'AirParam',
            },
            {
              value: '110',
              timeStamp: '2022-10-11T02:12:56.963Z',
              __typename: 'AirParam',
            },
            {
              value: '100',
              timeStamp: '2022-10-11T02:13:56.973Z',
              __typename: 'AirParam',
            },
            {
              value: '78',
              timeStamp: '2022-10-11T02:14:56.977Z',
              __typename: 'AirParam',
            },
            {
              value: '57',
              timeStamp: '2022-10-11T02:15:56.985Z',
              __typename: 'AirParam',
            },
            {
              value: '50',
              timeStamp: '2022-10-11T02:16:56.990Z',
              __typename: 'AirParam',
            },
            {
              value: '60',
              timeStamp: '2022-10-11T02:17:56.997Z',
              __typename: 'AirParam',
            },
            {
              value: '82',
              timeStamp: '2022-10-11T02:18:57.003Z',
              __typename: 'AirParam',
            },
            {
              value: '103',
              timeStamp: '2022-10-11T02:19:57.009Z',
              __typename: 'AirParam',
            },
            {
              value: '110',
              timeStamp: '2022-10-11T02:20:57.016Z',
              __typename: 'AirParam',
            },
            {
              value: '100',
              timeStamp: '2022-10-11T02:21:57.023Z',
              __typename: 'AirParam',
            },
            {
              value: '78',
              timeStamp: '2022-10-11T02:22:57.029Z',
              __typename: 'AirParam',
            },
            {
              value: '57',
              timeStamp: '2022-10-11T02:23:57.041Z',
              __typename: 'AirParam',
            },
            {
              value: '50',
              timeStamp: '2022-10-11T02:24:57.040Z',
              __typename: 'AirParam',
            },
            {
              value: '60',
              timeStamp: '2022-10-11T02:25:57.048Z',
              __typename: 'AirParam',
            },
            {
              value: '82',
              timeStamp: '2022-10-11T02:26:57.054Z',
              __typename: 'AirParam',
            },
            {
              value: '103',
              timeStamp: '2022-10-11T02:27:57.061Z',
              __typename: 'AirParam',
            },
            {
              value: '110',
              timeStamp: '2022-10-11T02:28:57.068Z',
              __typename: 'AirParam',
            },
            {
              value: '100',
              timeStamp: '2022-10-11T02:29:57.072Z',
              __typename: 'AirParam',
            },
            {
              value: '78',
              timeStamp: '2022-10-11T02:30:57.078Z',
              __typename: 'AirParam',
            },
            {
              value: '57',
              timeStamp: '2022-10-11T02:31:57.085Z',
              __typename: 'AirParam',
            },
            {
              value: '50',
              timeStamp: '2022-10-11T02:32:57.092Z',
              __typename: 'AirParam',
            },
            {
              value: '60',
              timeStamp: '2022-10-11T02:33:57.098Z',
              __typename: 'AirParam',
            },
            {
              value: '109',
              timeStamp: '2022-10-11T02:34:35.280Z',
              __typename: 'AirParam',
            },
          ],
          __typename: 'AirDashboardItem',
        },
        {
          name: 'vte',
          value: [
            {
              value: '19',
              timeStamp: '2022-10-11T02:05:56.922Z',
              __typename: 'AirParam',
            },
            {
              value: '17',
              timeStamp: '2022-10-11T02:06:56.927Z',
              __typename: 'AirParam',
            },
            {
              value: '16',
              timeStamp: '2022-10-11T02:07:56.937Z',
              __typename: 'AirParam',
            },
            {
              value: '15',
              timeStamp: '2022-10-11T02:08:56.941Z',
              __typename: 'AirParam',
            },
            {
              value: '16',
              timeStamp: '2022-10-11T02:09:56.946Z',
              __typename: 'AirParam',
            },
            {
              value: '18',
              timeStamp: '2022-10-11T02:10:56.951Z',
              __typename: 'AirParam',
            },
            {
              value: '19',
              timeStamp: '2022-10-11T02:11:56.958Z',
              __typename: 'AirParam',
            },
            {
              value: '20',
              timeStamp: '2022-10-11T02:12:56.963Z',
              __typename: 'AirParam',
            },
            {
              value: '19',
              timeStamp: '2022-10-11T02:13:56.973Z',
              __typename: 'AirParam',
            },
            {
              value: '17',
              timeStamp: '2022-10-11T02:14:56.977Z',
              __typename: 'AirParam',
            },
            {
              value: '16',
              timeStamp: '2022-10-11T02:15:56.985Z',
              __typename: 'AirParam',
            },
            {
              value: '15',
              timeStamp: '2022-10-11T02:16:56.990Z',
              __typename: 'AirParam',
            },
            {
              value: '16',
              timeStamp: '2022-10-11T02:17:56.997Z',
              __typename: 'AirParam',
            },
            {
              value: '18',
              timeStamp: '2022-10-11T02:18:57.003Z',
              __typename: 'AirParam',
            },
            {
              value: '19',
              timeStamp: '2022-10-11T02:19:57.009Z',
              __typename: 'AirParam',
            },
            {
              value: '20',
              timeStamp: '2022-10-11T02:20:57.016Z',
              __typename: 'AirParam',
            },
            {
              value: '19',
              timeStamp: '2022-10-11T02:21:57.023Z',
              __typename: 'AirParam',
            },
            {
              value: '17',
              timeStamp: '2022-10-11T02:22:57.029Z',
              __typename: 'AirParam',
            },
            {
              value: '16',
              timeStamp: '2022-10-11T02:23:57.041Z',
              __typename: 'AirParam',
            },
            {
              value: '15',
              timeStamp: '2022-10-11T02:24:57.040Z',
              __typename: 'AirParam',
            },
            {
              value: '16',
              timeStamp: '2022-10-11T02:25:57.048Z',
              __typename: 'AirParam',
            },
            {
              value: '18',
              timeStamp: '2022-10-11T02:26:57.054Z',
              __typename: 'AirParam',
            },
            {
              value: '19',
              timeStamp: '2022-10-11T02:27:57.061Z',
              __typename: 'AirParam',
            },
            {
              value: '20',
              timeStamp: '2022-10-11T02:28:57.068Z',
              __typename: 'AirParam',
            },
            {
              value: '19',
              timeStamp: '2022-10-11T02:29:57.072Z',
              __typename: 'AirParam',
            },
            {
              value: '17',
              timeStamp: '2022-10-11T02:30:57.078Z',
              __typename: 'AirParam',
            },
            {
              value: '16',
              timeStamp: '2022-10-11T02:31:57.085Z',
              __typename: 'AirParam',
            },
            {
              value: '15',
              timeStamp: '2022-10-11T02:32:57.092Z',
              __typename: 'AirParam',
            },
            {
              value: '16',
              timeStamp: '2022-10-11T02:33:57.098Z',
              __typename: 'AirParam',
            },
            {
              value: '20',
              timeStamp: '2022-10-11T02:34:35.280Z',
              __typename: 'AirParam',
            },
          ],
          __typename: 'AirDashboardItem',
        },
        {
          name: 'pplat',
          value: [
            {
              value: '141',
              timeStamp: '2022-10-11T02:05:56.922Z',
              __typename: 'AirParam',
            },
            {
              value: '123',
              timeStamp: '2022-10-11T02:06:56.927Z',
              __typename: 'AirParam',
            },
            {
              value: '106',
              timeStamp: '2022-10-11T02:07:56.937Z',
              __typename: 'AirParam',
            },
            {
              value: '100',
              timeStamp: '2022-10-11T02:08:56.941Z',
              __typename: 'AirParam',
            },
            {
              value: '109',
              timeStamp: '2022-10-11T02:09:56.946Z',
              __typename: 'AirParam',
            },
            {
              value: '127',
              timeStamp: '2022-10-11T02:10:56.951Z',
              __typename: 'AirParam',
            },
            {
              value: '144',
              timeStamp: '2022-10-11T02:11:56.958Z',
              __typename: 'AirParam',
            },
            {
              value: '150',
              timeStamp: '2022-10-11T02:12:56.963Z',
              __typename: 'AirParam',
            },
            {
              value: '141',
              timeStamp: '2022-10-11T02:13:56.973Z',
              __typename: 'AirParam',
            },
            {
              value: '123',
              timeStamp: '2022-10-11T02:14:56.977Z',
              __typename: 'AirParam',
            },
            {
              value: '106',
              timeStamp: '2022-10-11T02:15:56.985Z',
              __typename: 'AirParam',
            },
            {
              value: '100',
              timeStamp: '2022-10-11T02:16:56.990Z',
              __typename: 'AirParam',
            },
            {
              value: '109',
              timeStamp: '2022-10-11T02:17:56.997Z',
              __typename: 'AirParam',
            },
            {
              value: '127',
              timeStamp: '2022-10-11T02:18:57.003Z',
              __typename: 'AirParam',
            },
            {
              value: '144',
              timeStamp: '2022-10-11T02:19:57.009Z',
              __typename: 'AirParam',
            },
            {
              value: '150',
              timeStamp: '2022-10-11T02:20:57.016Z',
              __typename: 'AirParam',
            },
            {
              value: '141',
              timeStamp: '2022-10-11T02:21:57.023Z',
              __typename: 'AirParam',
            },
            {
              value: '123',
              timeStamp: '2022-10-11T02:22:57.029Z',
              __typename: 'AirParam',
            },
            {
              value: '106',
              timeStamp: '2022-10-11T02:23:57.041Z',
              __typename: 'AirParam',
            },
            {
              value: '100',
              timeStamp: '2022-10-11T02:24:57.040Z',
              __typename: 'AirParam',
            },
            {
              value: '109',
              timeStamp: '2022-10-11T02:25:57.048Z',
              __typename: 'AirParam',
            },
            {
              value: '127',
              timeStamp: '2022-10-11T02:26:57.054Z',
              __typename: 'AirParam',
            },
            {
              value: '144',
              timeStamp: '2022-10-11T02:27:57.061Z',
              __typename: 'AirParam',
            },
            {
              value: '150',
              timeStamp: '2022-10-11T02:28:57.068Z',
              __typename: 'AirParam',
            },
            {
              value: '141',
              timeStamp: '2022-10-11T02:29:57.072Z',
              __typename: 'AirParam',
            },
            {
              value: '123',
              timeStamp: '2022-10-11T02:30:57.078Z',
              __typename: 'AirParam',
            },
            {
              value: '106',
              timeStamp: '2022-10-11T02:31:57.085Z',
              __typename: 'AirParam',
            },
            {
              value: '100',
              timeStamp: '2022-10-11T02:32:57.092Z',
              __typename: 'AirParam',
            },
            {
              value: '109',
              timeStamp: '2022-10-11T02:33:57.098Z',
              __typename: 'AirParam',
            },
            {
              value: '150',
              timeStamp: '2022-10-11T02:34:35.280Z',
              __typename: 'AirParam',
            },
          ],
          __typename: 'AirDashboardItem',
        },
        {
          name: 'ppeak',
          value: [
            {
              value: '18',
              timeStamp: '2022-10-11T02:05:56.922Z',
              __typename: 'AirParam',
            },
            {
              value: '15',
              timeStamp: '2022-10-11T02:06:56.927Z',
              __typename: 'AirParam',
            },
            {
              value: '11',
              timeStamp: '2022-10-11T02:07:56.937Z',
              __typename: 'AirParam',
            },
            {
              value: '10',
              timeStamp: '2022-10-11T02:08:56.941Z',
              __typename: 'AirParam',
            },
            {
              value: '12',
              timeStamp: '2022-10-11T02:09:56.946Z',
              __typename: 'AirParam',
            },
            {
              value: '15',
              timeStamp: '2022-10-11T02:10:56.951Z',
              __typename: 'AirParam',
            },
            {
              value: '19',
              timeStamp: '2022-10-11T02:11:56.958Z',
              __typename: 'AirParam',
            },
            {
              value: '20',
              timeStamp: '2022-10-11T02:12:56.963Z',
              __typename: 'AirParam',
            },
            {
              value: '18',
              timeStamp: '2022-10-11T02:13:56.973Z',
              __typename: 'AirParam',
            },
            {
              value: '15',
              timeStamp: '2022-10-11T02:14:56.977Z',
              __typename: 'AirParam',
            },
            {
              value: '11',
              timeStamp: '2022-10-11T02:15:56.985Z',
              __typename: 'AirParam',
            },
            {
              value: '10',
              timeStamp: '2022-10-11T02:16:56.990Z',
              __typename: 'AirParam',
            },
            {
              value: '12',
              timeStamp: '2022-10-11T02:17:56.997Z',
              __typename: 'AirParam',
            },
            {
              value: '15',
              timeStamp: '2022-10-11T02:18:57.003Z',
              __typename: 'AirParam',
            },
            {
              value: '19',
              timeStamp: '2022-10-11T02:19:57.009Z',
              __typename: 'AirParam',
            },
            {
              value: '20',
              timeStamp: '2022-10-11T02:20:57.016Z',
              __typename: 'AirParam',
            },
            {
              value: '18',
              timeStamp: '2022-10-11T02:21:57.023Z',
              __typename: 'AirParam',
            },
            {
              value: '15',
              timeStamp: '2022-10-11T02:22:57.029Z',
              __typename: 'AirParam',
            },
            {
              value: '11',
              timeStamp: '2022-10-11T02:23:57.041Z',
              __typename: 'AirParam',
            },
            {
              value: '10',
              timeStamp: '2022-10-11T02:24:57.040Z',
              __typename: 'AirParam',
            },
            {
              value: '12',
              timeStamp: '2022-10-11T02:25:57.048Z',
              __typename: 'AirParam',
            },
            {
              value: '15',
              timeStamp: '2022-10-11T02:26:57.054Z',
              __typename: 'AirParam',
            },
            {
              value: '19',
              timeStamp: '2022-10-11T02:27:57.061Z',
              __typename: 'AirParam',
            },
            {
              value: '20',
              timeStamp: '2022-10-11T02:28:57.068Z',
              __typename: 'AirParam',
            },
            {
              value: '18',
              timeStamp: '2022-10-11T02:29:57.072Z',
              __typename: 'AirParam',
            },
            {
              value: '15',
              timeStamp: '2022-10-11T02:30:57.078Z',
              __typename: 'AirParam',
            },
            {
              value: '11',
              timeStamp: '2022-10-11T02:31:57.085Z',
              __typename: 'AirParam',
            },
            {
              value: '10',
              timeStamp: '2022-10-11T02:32:57.092Z',
              __typename: 'AirParam',
            },
            {
              value: '12',
              timeStamp: '2022-10-11T02:33:57.098Z',
              __typename: 'AirParam',
            },
            {
              value: '20',
              timeStamp: '2022-10-11T02:34:35.280Z',
              __typename: 'AirParam',
            },
          ],
          __typename: 'AirDashboardItem',
        },
        {
          name: 'pins',
          value: [
            {
              value: '13',
              timeStamp: '2022-10-11T02:05:56.922Z',
              __typename: 'AirParam',
            },
            {
              value: '10',
              timeStamp: '2022-10-11T02:06:56.927Z',
              __typename: 'AirParam',
            },
            {
              value: '6',
              timeStamp: '2022-10-11T02:07:56.937Z',
              __typename: 'AirParam',
            },
            {
              value: '5',
              timeStamp: '2022-10-11T02:08:56.941Z',
              __typename: 'AirParam',
            },
            {
              value: '7',
              timeStamp: '2022-10-11T02:09:56.946Z',
              __typename: 'AirParam',
            },
            {
              value: '10',
              timeStamp: '2022-10-11T02:10:56.951Z',
              __typename: 'AirParam',
            },
            {
              value: '14',
              timeStamp: '2022-10-11T02:11:56.958Z',
              __typename: 'AirParam',
            },
            {
              value: '15',
              timeStamp: '2022-10-11T02:12:56.963Z',
              __typename: 'AirParam',
            },
            {
              value: '13',
              timeStamp: '2022-10-11T02:13:56.973Z',
              __typename: 'AirParam',
            },
            {
              value: '10',
              timeStamp: '2022-10-11T02:14:56.977Z',
              __typename: 'AirParam',
            },
            {
              value: '6',
              timeStamp: '2022-10-11T02:15:56.985Z',
              __typename: 'AirParam',
            },
            {
              value: '5',
              timeStamp: '2022-10-11T02:16:56.990Z',
              __typename: 'AirParam',
            },
            {
              value: '7',
              timeStamp: '2022-10-11T02:17:56.997Z',
              __typename: 'AirParam',
            },
            {
              value: '10',
              timeStamp: '2022-10-11T02:18:57.003Z',
              __typename: 'AirParam',
            },
            {
              value: '14',
              timeStamp: '2022-10-11T02:19:57.009Z',
              __typename: 'AirParam',
            },
            {
              value: '15',
              timeStamp: '2022-10-11T02:20:57.016Z',
              __typename: 'AirParam',
            },
            {
              value: '13',
              timeStamp: '2022-10-11T02:21:57.023Z',
              __typename: 'AirParam',
            },
            {
              value: '10',
              timeStamp: '2022-10-11T02:22:57.029Z',
              __typename: 'AirParam',
            },
            {
              value: '6',
              timeStamp: '2022-10-11T02:23:57.041Z',
              __typename: 'AirParam',
            },
            {
              value: '5',
              timeStamp: '2022-10-11T02:24:57.040Z',
              __typename: 'AirParam',
            },
            {
              value: '7',
              timeStamp: '2022-10-11T02:25:57.048Z',
              __typename: 'AirParam',
            },
            {
              value: '10',
              timeStamp: '2022-10-11T02:26:57.054Z',
              __typename: 'AirParam',
            },
            {
              value: '14',
              timeStamp: '2022-10-11T02:27:57.061Z',
              __typename: 'AirParam',
            },
            {
              value: '15',
              timeStamp: '2022-10-11T02:28:57.068Z',
              __typename: 'AirParam',
            },
            {
              value: '13',
              timeStamp: '2022-10-11T02:29:57.072Z',
              __typename: 'AirParam',
            },
            {
              value: '10',
              timeStamp: '2022-10-11T02:30:57.078Z',
              __typename: 'AirParam',
            },
            {
              value: '6',
              timeStamp: '2022-10-11T02:31:57.085Z',
              __typename: 'AirParam',
            },
            {
              value: '5',
              timeStamp: '2022-10-11T02:32:57.092Z',
              __typename: 'AirParam',
            },
            {
              value: '7',
              timeStamp: '2022-10-11T02:33:57.098Z',
              __typename: 'AirParam',
            },
            {
              value: '15',
              timeStamp: '2022-10-11T02:34:35.280Z',
              __typename: 'AirParam',
            },
          ],
          __typename: 'AirDashboardItem',
        },
        {
          name: 're',
          value: [
            {
              value: '13',
              timeStamp: '2022-10-11T02:05:56.922Z',
              __typename: 'AirParam',
            },
            {
              value: '8',
              timeStamp: '2022-10-11T02:06:56.927Z',
              __typename: 'AirParam',
            },
            {
              value: '4',
              timeStamp: '2022-10-11T02:07:56.937Z',
              __typename: 'AirParam',
            },
            {
              value: '2',
              timeStamp: '2022-10-11T02:08:56.941Z',
              __typename: 'AirParam',
            },
            {
              value: '4',
              timeStamp: '2022-10-11T02:09:56.946Z',
              __typename: 'AirParam',
            },
            {
              value: '9',
              timeStamp: '2022-10-11T02:10:56.951Z',
              __typename: 'AirParam',
            },
            {
              value: '13',
              timeStamp: '2022-10-11T02:11:56.958Z',
              __typename: 'AirParam',
            },
            {
              value: '15',
              timeStamp: '2022-10-11T02:12:56.963Z',
              __typename: 'AirParam',
            },
            {
              value: '13',
              timeStamp: '2022-10-11T02:13:56.973Z',
              __typename: 'AirParam',
            },
            {
              value: '8',
              timeStamp: '2022-10-11T02:14:56.977Z',
              __typename: 'AirParam',
            },
            {
              value: '4',
              timeStamp: '2022-10-11T02:15:56.985Z',
              __typename: 'AirParam',
            },
            {
              value: '2',
              timeStamp: '2022-10-11T02:16:56.990Z',
              __typename: 'AirParam',
            },
            {
              value: '4',
              timeStamp: '2022-10-11T02:17:56.997Z',
              __typename: 'AirParam',
            },
            {
              value: '9',
              timeStamp: '2022-10-11T02:18:57.003Z',
              __typename: 'AirParam',
            },
            {
              value: '13',
              timeStamp: '2022-10-11T02:19:57.009Z',
              __typename: 'AirParam',
            },
            {
              value: '15',
              timeStamp: '2022-10-11T02:20:57.016Z',
              __typename: 'AirParam',
            },
            {
              value: '13',
              timeStamp: '2022-10-11T02:21:57.023Z',
              __typename: 'AirParam',
            },
            {
              value: '8',
              timeStamp: '2022-10-11T02:22:57.029Z',
              __typename: 'AirParam',
            },
            {
              value: '4',
              timeStamp: '2022-10-11T02:23:57.041Z',
              __typename: 'AirParam',
            },
            {
              value: '2',
              timeStamp: '2022-10-11T02:24:57.040Z',
              __typename: 'AirParam',
            },
            {
              value: '4',
              timeStamp: '2022-10-11T02:25:57.048Z',
              __typename: 'AirParam',
            },
            {
              value: '9',
              timeStamp: '2022-10-11T02:26:57.054Z',
              __typename: 'AirParam',
            },
            {
              value: '13',
              timeStamp: '2022-10-11T02:27:57.061Z',
              __typename: 'AirParam',
            },
            {
              value: '15',
              timeStamp: '2022-10-11T02:28:57.068Z',
              __typename: 'AirParam',
            },
            {
              value: '13',
              timeStamp: '2022-10-11T02:29:57.072Z',
              __typename: 'AirParam',
            },
            {
              value: '8',
              timeStamp: '2022-10-11T02:30:57.078Z',
              __typename: 'AirParam',
            },
            {
              value: '4',
              timeStamp: '2022-10-11T02:31:57.085Z',
              __typename: 'AirParam',
            },
            {
              value: '2',
              timeStamp: '2022-10-11T02:32:57.092Z',
              __typename: 'AirParam',
            },
            {
              value: '4',
              timeStamp: '2022-10-11T02:33:57.098Z',
              __typename: 'AirParam',
            },
            {
              value: '15',
              timeStamp: '2022-10-11T02:34:35.280Z',
              __typename: 'AirParam',
            },
          ],
          __typename: 'AirDashboardItem',
        },
        {
          name: 'ri',
          value: [
            {
              value: '13',
              timeStamp: '2022-10-11T02:05:56.922Z',
              __typename: 'AirParam',
            },
            {
              value: '8',
              timeStamp: '2022-10-11T02:06:56.927Z',
              __typename: 'AirParam',
            },
            {
              value: '4',
              timeStamp: '2022-10-11T02:07:56.937Z',
              __typename: 'AirParam',
            },
            {
              value: '2',
              timeStamp: '2022-10-11T02:08:56.941Z',
              __typename: 'AirParam',
            },
            {
              value: '4',
              timeStamp: '2022-10-11T02:09:56.946Z',
              __typename: 'AirParam',
            },
            {
              value: '9',
              timeStamp: '2022-10-11T02:10:56.951Z',
              __typename: 'AirParam',
            },
            {
              value: '13',
              timeStamp: '2022-10-11T02:11:56.958Z',
              __typename: 'AirParam',
            },
            {
              value: '15',
              timeStamp: '2022-10-11T02:12:56.963Z',
              __typename: 'AirParam',
            },
            {
              value: '13',
              timeStamp: '2022-10-11T02:13:56.973Z',
              __typename: 'AirParam',
            },
            {
              value: '8',
              timeStamp: '2022-10-11T02:14:56.977Z',
              __typename: 'AirParam',
            },
            {
              value: '4',
              timeStamp: '2022-10-11T02:15:56.985Z',
              __typename: 'AirParam',
            },
            {
              value: '2',
              timeStamp: '2022-10-11T02:16:56.990Z',
              __typename: 'AirParam',
            },
            {
              value: '4',
              timeStamp: '2022-10-11T02:17:56.997Z',
              __typename: 'AirParam',
            },
            {
              value: '9',
              timeStamp: '2022-10-11T02:18:57.003Z',
              __typename: 'AirParam',
            },
            {
              value: '13',
              timeStamp: '2022-10-11T02:19:57.009Z',
              __typename: 'AirParam',
            },
            {
              value: '15',
              timeStamp: '2022-10-11T02:20:57.016Z',
              __typename: 'AirParam',
            },
            {
              value: '13',
              timeStamp: '2022-10-11T02:21:57.023Z',
              __typename: 'AirParam',
            },
            {
              value: '8',
              timeStamp: '2022-10-11T02:22:57.029Z',
              __typename: 'AirParam',
            },
            {
              value: '4',
              timeStamp: '2022-10-11T02:23:57.041Z',
              __typename: 'AirParam',
            },
            {
              value: '2',
              timeStamp: '2022-10-11T02:24:57.040Z',
              __typename: 'AirParam',
            },
            {
              value: '4',
              timeStamp: '2022-10-11T02:25:57.048Z',
              __typename: 'AirParam',
            },
            {
              value: '9',
              timeStamp: '2022-10-11T02:26:57.054Z',
              __typename: 'AirParam',
            },
            {
              value: '13',
              timeStamp: '2022-10-11T02:27:57.061Z',
              __typename: 'AirParam',
            },
            {
              value: '15',
              timeStamp: '2022-10-11T02:28:57.068Z',
              __typename: 'AirParam',
            },
            {
              value: '13',
              timeStamp: '2022-10-11T02:29:57.072Z',
              __typename: 'AirParam',
            },
            {
              value: '8',
              timeStamp: '2022-10-11T02:30:57.078Z',
              __typename: 'AirParam',
            },
            {
              value: '4',
              timeStamp: '2022-10-11T02:31:57.085Z',
              __typename: 'AirParam',
            },
            {
              value: '2',
              timeStamp: '2022-10-11T02:32:57.092Z',
              __typename: 'AirParam',
            },
            {
              value: '4',
              timeStamp: '2022-10-11T02:33:57.098Z',
              __typename: 'AirParam',
            },
            {
              value: '15',
              timeStamp: '2022-10-11T02:34:35.280Z',
              __typename: 'AirParam',
            },
          ],
          __typename: 'AirDashboardItem',
        },
        {
          name: 'peep',
          value: [
            {
              value: '9',
              timeStamp: '2022-10-11T02:05:56.922Z',
              __typename: 'AirParam',
            },
            {
              value: '7',
              timeStamp: '2022-10-11T02:06:56.927Z',
              __typename: 'AirParam',
            },
            {
              value: '5',
              timeStamp: '2022-10-11T02:07:56.937Z',
              __typename: 'AirParam',
            },
            {
              value: '4',
              timeStamp: '2022-10-11T02:08:56.941Z',
              __typename: 'AirParam',
            },
            {
              value: '5',
              timeStamp: '2022-10-11T02:09:56.946Z',
              __typename: 'AirParam',
            },
            {
              value: '7',
              timeStamp: '2022-10-11T02:10:56.951Z',
              __typename: 'AirParam',
            },
            {
              value: '9',
              timeStamp: '2022-10-11T02:11:56.958Z',
              __typename: 'AirParam',
            },
            {
              value: '10',
              timeStamp: '2022-10-11T02:12:56.963Z',
              __typename: 'AirParam',
            },
            {
              value: '9',
              timeStamp: '2022-10-11T02:13:56.973Z',
              __typename: 'AirParam',
            },
            {
              value: '7',
              timeStamp: '2022-10-11T02:14:56.977Z',
              __typename: 'AirParam',
            },
            {
              value: '5',
              timeStamp: '2022-10-11T02:15:56.985Z',
              __typename: 'AirParam',
            },
            {
              value: '4',
              timeStamp: '2022-10-11T02:16:56.990Z',
              __typename: 'AirParam',
            },
            {
              value: '5',
              timeStamp: '2022-10-11T02:17:56.997Z',
              __typename: 'AirParam',
            },
            {
              value: '7',
              timeStamp: '2022-10-11T02:18:57.003Z',
              __typename: 'AirParam',
            },
            {
              value: '9',
              timeStamp: '2022-10-11T02:19:57.009Z',
              __typename: 'AirParam',
            },
            {
              value: '10',
              timeStamp: '2022-10-11T02:20:57.016Z',
              __typename: 'AirParam',
            },
            {
              value: '9',
              timeStamp: '2022-10-11T02:21:57.023Z',
              __typename: 'AirParam',
            },
            {
              value: '7',
              timeStamp: '2022-10-11T02:22:57.029Z',
              __typename: 'AirParam',
            },
            {
              value: '5',
              timeStamp: '2022-10-11T02:23:57.041Z',
              __typename: 'AirParam',
            },
            {
              value: '4',
              timeStamp: '2022-10-11T02:24:57.040Z',
              __typename: 'AirParam',
            },
            {
              value: '5',
              timeStamp: '2022-10-11T02:25:57.048Z',
              __typename: 'AirParam',
            },
            {
              value: '7',
              timeStamp: '2022-10-11T02:26:57.054Z',
              __typename: 'AirParam',
            },
            {
              value: '9',
              timeStamp: '2022-10-11T02:27:57.061Z',
              __typename: 'AirParam',
            },
            {
              value: '10',
              timeStamp: '2022-10-11T02:28:57.068Z',
              __typename: 'AirParam',
            },
            {
              value: '9',
              timeStamp: '2022-10-11T02:29:57.072Z',
              __typename: 'AirParam',
            },
            {
              value: '7',
              timeStamp: '2022-10-11T02:30:57.078Z',
              __typename: 'AirParam',
            },
            {
              value: '5',
              timeStamp: '2022-10-11T02:31:57.085Z',
              __typename: 'AirParam',
            },
            {
              value: '4',
              timeStamp: '2022-10-11T02:32:57.092Z',
              __typename: 'AirParam',
            },
            {
              value: '5',
              timeStamp: '2022-10-11T02:33:57.098Z',
              __typename: 'AirParam',
            },
            {
              value: '10',
              timeStamp: '2022-10-11T02:34:35.280Z',
              __typename: 'AirParam',
            },
          ],
          __typename: 'AirDashboardItem',
        },
        {
          name: 'cdyn',
          value: [
            {
              value: '13',
              timeStamp: '2022-10-11T02:05:56.922Z',
              __typename: 'AirParam',
            },
            {
              value: '10',
              timeStamp: '2022-10-11T02:06:56.927Z',
              __typename: 'AirParam',
            },
            {
              value: '6',
              timeStamp: '2022-10-11T02:07:56.937Z',
              __typename: 'AirParam',
            },
            {
              value: '5',
              timeStamp: '2022-10-11T02:08:56.941Z',
              __typename: 'AirParam',
            },
            {
              value: '7',
              timeStamp: '2022-10-11T02:09:56.946Z',
              __typename: 'AirParam',
            },
            {
              value: '10',
              timeStamp: '2022-10-11T02:10:56.951Z',
              __typename: 'AirParam',
            },
            {
              value: '14',
              timeStamp: '2022-10-11T02:11:56.958Z',
              __typename: 'AirParam',
            },
            {
              value: '15',
              timeStamp: '2022-10-11T02:12:56.963Z',
              __typename: 'AirParam',
            },
            {
              value: '13',
              timeStamp: '2022-10-11T02:13:56.973Z',
              __typename: 'AirParam',
            },
            {
              value: '10',
              timeStamp: '2022-10-11T02:14:56.977Z',
              __typename: 'AirParam',
            },
            {
              value: '6',
              timeStamp: '2022-10-11T02:15:56.985Z',
              __typename: 'AirParam',
            },
            {
              value: '5',
              timeStamp: '2022-10-11T02:16:56.990Z',
              __typename: 'AirParam',
            },
            {
              value: '7',
              timeStamp: '2022-10-11T02:17:56.997Z',
              __typename: 'AirParam',
            },
            {
              value: '10',
              timeStamp: '2022-10-11T02:18:57.003Z',
              __typename: 'AirParam',
            },
            {
              value: '14',
              timeStamp: '2022-10-11T02:19:57.009Z',
              __typename: 'AirParam',
            },
            {
              value: '15',
              timeStamp: '2022-10-11T02:20:57.016Z',
              __typename: 'AirParam',
            },
            {
              value: '13',
              timeStamp: '2022-10-11T02:21:57.023Z',
              __typename: 'AirParam',
            },
            {
              value: '10',
              timeStamp: '2022-10-11T02:22:57.029Z',
              __typename: 'AirParam',
            },
            {
              value: '6',
              timeStamp: '2022-10-11T02:23:57.041Z',
              __typename: 'AirParam',
            },
            {
              value: '5',
              timeStamp: '2022-10-11T02:24:57.040Z',
              __typename: 'AirParam',
            },
            {
              value: '7',
              timeStamp: '2022-10-11T02:25:57.048Z',
              __typename: 'AirParam',
            },
            {
              value: '10',
              timeStamp: '2022-10-11T02:26:57.054Z',
              __typename: 'AirParam',
            },
            {
              value: '14',
              timeStamp: '2022-10-11T02:27:57.061Z',
              __typename: 'AirParam',
            },
            {
              value: '15',
              timeStamp: '2022-10-11T02:28:57.068Z',
              __typename: 'AirParam',
            },
            {
              value: '13',
              timeStamp: '2022-10-11T02:29:57.072Z',
              __typename: 'AirParam',
            },
            {
              value: '10',
              timeStamp: '2022-10-11T02:30:57.078Z',
              __typename: 'AirParam',
            },
            {
              value: '6',
              timeStamp: '2022-10-11T02:31:57.085Z',
              __typename: 'AirParam',
            },
            {
              value: '5',
              timeStamp: '2022-10-11T02:32:57.092Z',
              __typename: 'AirParam',
            },
            {
              value: '7',
              timeStamp: '2022-10-11T02:33:57.098Z',
              __typename: 'AirParam',
            },
            {
              value: '15',
              timeStamp: '2022-10-11T02:34:35.280Z',
              __typename: 'AirParam',
            },
          ],
          __typename: 'AirDashboardItem',
        },
        {
          name: 'vti',
          value: [
            {
              value: '18',
              timeStamp: '2022-10-11T02:05:56.922Z',
              __typename: 'AirParam',
            },
            {
              value: '15',
              timeStamp: '2022-10-11T02:06:56.927Z',
              __typename: 'AirParam',
            },
            {
              value: '11',
              timeStamp: '2022-10-11T02:07:56.937Z',
              __typename: 'AirParam',
            },
            {
              value: '10',
              timeStamp: '2022-10-11T02:08:56.941Z',
              __typename: 'AirParam',
            },
            {
              value: '12',
              timeStamp: '2022-10-11T02:09:56.946Z',
              __typename: 'AirParam',
            },
            {
              value: '15',
              timeStamp: '2022-10-11T02:10:56.951Z',
              __typename: 'AirParam',
            },
            {
              value: '19',
              timeStamp: '2022-10-11T02:11:56.958Z',
              __typename: 'AirParam',
            },
            {
              value: '20',
              timeStamp: '2022-10-11T02:12:56.963Z',
              __typename: 'AirParam',
            },
            {
              value: '18',
              timeStamp: '2022-10-11T02:13:56.973Z',
              __typename: 'AirParam',
            },
            {
              value: '15',
              timeStamp: '2022-10-11T02:14:56.977Z',
              __typename: 'AirParam',
            },
            {
              value: '11',
              timeStamp: '2022-10-11T02:15:56.985Z',
              __typename: 'AirParam',
            },
            {
              value: '10',
              timeStamp: '2022-10-11T02:16:56.990Z',
              __typename: 'AirParam',
            },
            {
              value: '12',
              timeStamp: '2022-10-11T02:17:56.997Z',
              __typename: 'AirParam',
            },
            {
              value: '15',
              timeStamp: '2022-10-11T02:18:57.003Z',
              __typename: 'AirParam',
            },
            {
              value: '19',
              timeStamp: '2022-10-11T02:19:57.009Z',
              __typename: 'AirParam',
            },
            {
              value: '20',
              timeStamp: '2022-10-11T02:20:57.016Z',
              __typename: 'AirParam',
            },
            {
              value: '18',
              timeStamp: '2022-10-11T02:21:57.023Z',
              __typename: 'AirParam',
            },
            {
              value: '15',
              timeStamp: '2022-10-11T02:22:57.029Z',
              __typename: 'AirParam',
            },
            {
              value: '11',
              timeStamp: '2022-10-11T02:23:57.041Z',
              __typename: 'AirParam',
            },
            {
              value: '10',
              timeStamp: '2022-10-11T02:24:57.040Z',
              __typename: 'AirParam',
            },
            {
              value: '12',
              timeStamp: '2022-10-11T02:25:57.048Z',
              __typename: 'AirParam',
            },
            {
              value: '15',
              timeStamp: '2022-10-11T02:26:57.054Z',
              __typename: 'AirParam',
            },
            {
              value: '19',
              timeStamp: '2022-10-11T02:27:57.061Z',
              __typename: 'AirParam',
            },
            {
              value: '20',
              timeStamp: '2022-10-11T02:28:57.068Z',
              __typename: 'AirParam',
            },
            {
              value: '18',
              timeStamp: '2022-10-11T02:29:57.072Z',
              __typename: 'AirParam',
            },
            {
              value: '15',
              timeStamp: '2022-10-11T02:30:57.078Z',
              __typename: 'AirParam',
            },
            {
              value: '11',
              timeStamp: '2022-10-11T02:31:57.085Z',
              __typename: 'AirParam',
            },
            {
              value: '10',
              timeStamp: '2022-10-11T02:32:57.092Z',
              __typename: 'AirParam',
            },
            {
              value: '12',
              timeStamp: '2022-10-11T02:33:57.098Z',
              __typename: 'AirParam',
            },
            {
              value: '20',
              timeStamp: '2022-10-11T02:34:35.280Z',
              __typename: 'AirParam',
            },
          ],
          __typename: 'AirDashboardItem',
        },
      ],
      __typename: 'AirResponseToSelect',
    },
  }),
  SaveBedPreferences: (onCompleted) => [() => onCompleted(), { loading: false }],
  Air: () => {
    let callback = () => { /* */ };
    const currentUri = window.location.pathname;
    const isRealTime = currentUri.includes('/air/real-time');
    const intervalRange = isRealTime ? 17000 : 1000;

    const interval = setInterval(() => {
      callback({
        air: {
          ventMode: 'VS_PRVC',
          flowTrigger: 'ASSISTED',
          flowControl: 'VOLUME',
          automode: null,
          trigger: null,
          timeStamp: new Date().toISOString(),
          info: generateAir(30),
        },
      });
    }, intervalRange);

    return {
      onData: (func) => {
        callback = func;
      },
      unsubscribe: () => {
        clearInterval(interval);
      },
    };
  },
  GetAirLastHourStreak: () => ({
    getAirLastHourStreak: {
      __typename: 'AirWave',
      airPressureWave: [
        {
          __typename: 'Points',
          x: 0,
          y: 5.493194580078125,
        },
        {
          __typename: 'Points',
          x: 20,
          y: 5.818695068359375,
        },
        {
          __typename: 'Points',
          x: 40,
          y: 6.469696044921875,
        },
        {
          __typename: 'Points',
          x: 60,
          y: 7.3159942626953125,
        },
        {
          __typename: 'Points',
          x: 80,
          y: 8.422698974609375,
        },
        {
          __typename: 'Points',
          x: 100,
          y: 9.789794921875,
        },
        {
          __typename: 'Points',
          x: 120,
          y: 11.41729736328125,
        },
        {
          __typename: 'Points',
          x: 140,
          y: 13.17498779296875,
        },
        {
          __typename: 'Points',
          x: 160,
          y: 14.411895751953125,
        },
        {
          __typename: 'Points',
          x: 180,
          y: 15.193099975585938,
        },
        {
          __typename: 'Points',
          x: 200,
          y: 15.974288940429688,
        },
        {
          __typename: 'Points',
          x: 220,
          y: 16.625289916992188,
        },
        {
          __typename: 'Points',
          x: 240,
          y: 17.211196899414062,
        },
        {
          __typename: 'Points',
          x: 260,
          y: 17.797088623046875,
        },
        {
          __typename: 'Points',
          x: 280,
          y: 18.317901611328125,
        },
        {
          __typename: 'Points',
          x: 300,
          y: 18.903793334960938,
        },
        {
          __typename: 'Points',
          x: 320,
          y: 19.424591064453125,
        },
        {
          __typename: 'Points',
          x: 340,
          y: 19.945388793945312,
        },
        {
          __typename: 'Points',
          x: 360,
          y: 20.401092529296875,
        },
        {
          __typename: 'Points',
          x: 380,
          y: 20.791702270507812,
        },
        {
          __typename: 'Points',
          x: 400,
          y: 21.377593994140625,
        },
        {
          __typename: 'Points',
          x: 420,
          y: 21.7681884765625,
        },
        {
          __typename: 'Points',
          x: 440,
          y: 22.28900146484375,
        },
        {
          __typename: 'Points',
          x: 460,
          y: 22.614501953125,
        },
        {
          __typename: 'Points',
          x: 480,
          y: 22.94000244140625,
        },
        {
          __typename: 'Points',
          x: 500,
          y: 23.460800170898438,
        },
        {
          __typename: 'Points',
          x: 520,
          y: 23.851394653320312,
        },
        {
          __typename: 'Points',
          x: 540,
          y: 24.241989135742188,
        },
        {
          __typename: 'Points',
          x: 560,
          y: 24.69769287109375,
        },
        {
          __typename: 'Points',
          x: 580,
          y: 25.023193359375,
        },
        {
          __typename: 'Points',
          x: 600,
          y: 25.413787841796875,
        },
        {
          __typename: 'Points',
          x: 620,
          y: 25.609100341796875,
        },
        {
          __typename: 'Points',
          x: 640,
          y: 26.064788818359375,
        },
        {
          __typename: 'Points',
          x: 660,
          y: 26.520492553710938,
        },
        {
          __typename: 'Points',
          x: 680,
          y: 26.780899047851562,
        },
        {
          __typename: 'Points',
          x: 700,
          y: 27.106399536132812,
        },
        {
          __typename: 'Points',
          x: 720,
          y: 27.431900024414062,
        },
        {
          __typename: 'Points',
          x: 740,
          y: 27.822494506835938,
        },
        {
          __typename: 'Points',
          x: 760,
          y: 28.147994995117188,
        },
        {
          __typename: 'Points',
          x: 780,
          y: 28.538589477539062,
        },
        {
          __typename: 'Points',
          x: 800,
          y: 28.864089965820312,
        },
        {
          __typename: 'Points',
          x: 820,
          y: 29.189590454101562,
        },
        {
          __typename: 'Points',
          x: 840,
          y: 29.3848876953125,
        },
        {
          __typename: 'Points',
          x: 860,
          y: 29.5802001953125,
        },
        {
          __typename: 'Points',
          x: 880,
          y: 26.911102294921875,
        },
        {
          __typename: 'Points',
          x: 900,
          y: 23.200393676757812,
        },
        {
          __typename: 'Points',
          x: 920,
          y: 22.09368896484375,
        },
        {
          __typename: 'Points',
          x: 940,
          y: 22.09368896484375,
        },
        {
          __typename: 'Points',
          x: 960,
          y: 22.419189453125,
        },
        {
          __typename: 'Points',
          x: 980,
          y: 22.484298706054688,
        },
        {
          __typename: 'Points',
          x: 1000,
          y: 22.28900146484375,
        },
        {
          __typename: 'Points',
          x: 1020,
          y: 22.09368896484375,
        },
        {
          __typename: 'Points',
          x: 1040,
          y: 22.028594970703125,
        },
        {
          __typename: 'Points',
          x: 1060,
          y: 21.9635009765625,
        },
        {
          __typename: 'Points',
          x: 1080,
          y: 21.9635009765625,
        },
        {
          __typename: 'Points',
          x: 1120,
          y: 21.9635009765625,
        },
        {
          __typename: 'Points',
          x: 1140,
          y: 21.898391723632812,
        },
        {
          __typename: 'Points',
          x: 1160,
          y: 21.833297729492188,
        },
        {
          __typename: 'Points',
          x: 1180,
          y: 21.7681884765625,
        },
        {
          __typename: 'Points',
          x: 1200,
          y: 21.7681884765625,
        },
        {
          __typename: 'Points',
          x: 1220,
          y: 21.7681884765625,
        },
        {
          __typename: 'Points',
          x: 1240,
          y: 21.703094482421875,
        },
        {
          __typename: 'Points',
          x: 1260,
          y: 21.703094482421875,
        },
        {
          __typename: 'Points',
          x: 1280,
          y: 21.63800048828125,
        },
        {
          __typename: 'Points',
          x: 1300,
          y: 14.867599487304688,
        },
        {
          __typename: 'Points',
          x: 1320,
          y: 6.7301025390625,
        },
        {
          __typename: 'Points',
          x: 1340,
          y: 4.9723968505859375,
        },
        {
          __typename: 'Points',
          x: 1360,
          y: 4.3864898681640625,
        },
        {
          __typename: 'Points',
          x: 1380,
          y: 4.1260986328125,
        },
        {
          __typename: 'Points',
          x: 1400,
          y: 4.516693115234375,
        },
        {
          __typename: 'Points',
          x: 1420,
          y: 4.777099609375,
        },
        {
          __typename: 'Points',
          x: 1440,
          y: 5.2978973388671875,
        },
        {
          __typename: 'Points',
          x: 1460,
          y: 5.9488983154296875,
        },
        {
          __typename: 'Points',
          x: 1480,
          y: 6.469696044921875,
        },
        {
          __typename: 'Points',
          x: 1500,
          y: 6.40460205078125,
        },
        {
          __typename: 'Points',
          x: 1520,
          y: 6.3394927978515625,
        },
        {
          __typename: 'Points',
          x: 1540,
          y: 6.20928955078125,
        },
        {
          __typename: 'Points',
          x: 1560,
          y: 6.144195556640625,
        },
        {
          __typename: 'Points',
          x: 1580,
          y: 6.0139923095703125,
        },
        {
          __typename: 'Points',
          x: 1600,
          y: 5.9488983154296875,
        },
        {
          __typename: 'Points',
          x: 1620,
          y: 5.9488983154296875,
        },
        {
          __typename: 'Points',
          x: 1660,
          y: 5.9488983154296875,
        },
        {
          __typename: 'Points',
          x: 1680,
          y: 5.8837890625,
        },
        {
          __typename: 'Points',
          x: 1700,
          y: 5.818695068359375,
        },
        {
          __typename: 'Points',
          x: 1720,
          y: 5.75360107421875,
        },
        {
          __typename: 'Points',
          x: 1740,
          y: 5.75360107421875,
        },
        {
          __typename: 'Points',
          x: 1760,
          y: 5.6233978271484375,
        },
        {
          __typename: 'Points',
          x: 1780,
          y: 5.6233978271484375,
        },
        {
          __typename: 'Points',
          x: 1800,
          y: 5.6233978271484375,
        },
        {
          __typename: 'Points',
          x: 1820,
          y: 5.55828857421875,
        },
        {
          __typename: 'Points',
          x: 1840,
          y: 5.55828857421875,
        },
        {
          __typename: 'Points',
          x: 1860,
          y: 5.493194580078125,
        },
        {
          __typename: 'Points',
          x: 1880,
          y: 5.493194580078125,
        },
        {
          __typename: 'Points',
          x: 1900,
          y: 5.493194580078125,
        },
        {
          __typename: 'Points',
          x: 1920,
          y: 5.4281005859375,
        },
        {
          __typename: 'Points',
          x: 1940,
          y: 5.4281005859375,
        },
        {
          __typename: 'Points',
          x: 1960,
          y: 5.3629913330078125,
        },
        {
          __typename: 'Points',
          x: 1980,
          y: 5.2978973388671875,
        },
        {
          __typename: 'Points',
          x: 2000,
          y: 5.2978973388671875,
        },
        {
          __typename: 'Points',
          x: 2020,
          y: 5.2327880859375,
        },
        {
          __typename: 'Points',
          x: 2040,
          y: 5.167694091796875,
        },
        {
          __typename: 'Points',
          x: 2060,
          y: 5.167694091796875,
        },
        {
          __typename: 'Points',
          x: 2100,
          y: 5.167694091796875,
        },
        {
          __typename: 'Points',
          x: 2120,
          y: 5.10260009765625,
        },
        {
          __typename: 'Points',
          x: 2140,
          y: 5.167694091796875,
        },
        {
          __typename: 'Points',
          x: 2160,
          y: 5.10260009765625,
        },
        {
          __typename: 'Points',
          x: 2180,
          y: 5.10260009765625,
        },
        {
          __typename: 'Points',
          x: 2220,
          y: 5.10260009765625,
        },
        {
          __typename: 'Points',
          x: 2240,
          y: 5.0374908447265625,
        },
        {
          __typename: 'Points',
          x: 2260,
          y: 5.0374908447265625,
        },
        {
          __typename: 'Points',
          x: 2420,
          y: 5.0374908447265625,
        },
        {
          __typename: 'Points',
          x: 2440,
          y: 5.10260009765625,
        },
        {
          __typename: 'Points',
          x: 2460,
          y: 5.10260009765625,
        },
        {
          __typename: 'Points',
          x: 2540,
          y: 5.10260009765625,
        },
        {
          __typename: 'Points',
          x: 2560,
          y: 5.167694091796875,
        },
        {
          __typename: 'Points',
          x: 2580,
          y: 5.167694091796875,
        },
        {
          __typename: 'Points',
          x: 2660,
          y: 5.167694091796875,
        },
        {
          __typename: 'Points',
          x: 2680,
          y: 5.2327880859375,
        },
        {
          __typename: 'Points',
          x: 2700,
          y: 5.2327880859375,
        },
        {
          __typename: 'Points',
          x: 2760,
          y: 5.2327880859375,
        },
        {
          __typename: 'Points',
          x: 2780,
          y: 5.2978973388671875,
        },
        {
          __typename: 'Points',
          x: 2800,
          y: 5.2978973388671875,
        },
        {
          __typename: 'Points',
          x: 3960,
          y: 5.2978973388671875,
        },
        {
          __typename: 'Points',
          x: 3980,
          y: 5.3629913330078125,
        },
        {
          __typename: 'Points',
          x: 4000,
          y: 5.4281005859375,
        },
        {
          __typename: 'Points',
          x: 4020,
          y: 5.818695068359375,
        },
        {
          __typename: 'Points',
          x: 4040,
          y: 6.3394927978515625,
        },
        {
          __typename: 'Points',
          x: 4060,
          y: 7.185791015625,
        },
        {
          __typename: 'Points',
          x: 4080,
          y: 8.227401733398438,
        },
        {
          __typename: 'Points',
          x: 4100,
          y: 9.529388427734375,
        },
        {
          __typename: 'Points',
          x: 4120,
          y: 11.156890869140625,
        },
        {
          __typename: 'Points',
          x: 4140,
          y: 12.914596557617188,
        },
        {
          __typename: 'Points',
          x: 4160,
          y: 14.1514892578125,
        },
        {
          __typename: 'Points',
          x: 4180,
          y: 15.062896728515625,
        },
        {
          __typename: 'Points',
          x: 4200,
          y: 15.909194946289062,
        },
        {
          __typename: 'Points',
          x: 4220,
          y: 16.560195922851562,
        },
        {
          __typename: 'Points',
          x: 4240,
          y: 17.211196899414062,
        },
        {
          __typename: 'Points',
          x: 4260,
          y: 17.666900634765625,
        },
        {
          __typename: 'Points',
          x: 4280,
          y: 18.252792358398438,
        },
        {
          __typename: 'Points',
          x: 4300,
          y: 18.838699340820312,
        },
        {
          __typename: 'Points',
          x: 4320,
          y: 19.294387817382812,
        },
        {
          __typename: 'Points',
          x: 4340,
          y: 19.815200805664062,
        },
        {
          __typename: 'Points',
          x: 4360,
          y: 20.33599853515625,
        },
        {
          __typename: 'Points',
          x: 4380,
          y: 20.726593017578125,
        },
        {
          __typename: 'Points',
          x: 4400,
          y: 21.247390747070312,
        },
        {
          __typename: 'Points',
          x: 4420,
          y: 21.703094482421875,
        },
        {
          __typename: 'Points',
          x: 4440,
          y: 22.158798217773438,
        },
        {
          __typename: 'Points',
          x: 4460,
          y: 22.549392700195312,
        },
        {
          __typename: 'Points',
          x: 4480,
          y: 23.005096435546875,
        },
        {
          __typename: 'Points',
          x: 4500,
          y: 23.39569091796875,
        },
        {
          __typename: 'Points',
          x: 4520,
          y: 23.72119140625,
        },
        {
          __typename: 'Points',
          x: 4540,
          y: 24.176895141601562,
        },
        {
          __typename: 'Points',
          x: 4560,
          y: 24.632598876953125,
        },
        {
          __typename: 'Points',
          x: 4580,
          y: 24.958099365234375,
        },
        {
          __typename: 'Points',
          x: 4600,
          y: 25.34869384765625,
        },
        {
          __typename: 'Points',
          x: 4620,
          y: 25.739288330078125,
        },
        {
          __typename: 'Points',
          x: 4640,
          y: 26.064788818359375,
        },
        {
          __typename: 'Points',
          x: 4720,
          y: 27.366790771484375,
        },
        {
          __typename: 'Points',
          x: 4740,
          y: 27.822494506835938,
        },
        {
          __typename: 'Points',
          x: 4760,
          y: 28.147994995117188,
        },
        {
          __typename: 'Points',
          x: 4800,
          y: 28.798995971679688,
        },
        {
          __typename: 'Points',
          x: 4820,
          y: 29.059402465820312,
        },
        {
          __typename: 'Points',
          x: 4840,
          y: 29.3848876953125,
        },
        {
          __typename: 'Points',
          x: 4860,
          y: 29.645294189453125,
        },
        {
          __typename: 'Points',
          x: 4880,
          y: 26.260101318359375,
        },
        {
          __typename: 'Points',
          x: 4900,
          y: 22.809799194335938,
        },
        {
          __typename: 'Points',
          x: 4920,
          y: 22.028594970703125,
        },
        {
          __typename: 'Points',
          x: 4940,
          y: 22.419189453125,
        },
        {
          __typename: 'Points',
          x: 4960,
          y: 22.614501953125,
        },
        {
          __typename: 'Points',
          x: 4980,
          y: 22.484298706054688,
        },
        {
          __typename: 'Points',
          x: 5000,
          y: 22.223892211914062,
        },
        {
          __typename: 'Points',
          x: 5020,
          y: 22.028594970703125,
        },
        {
          __typename: 'Points',
          x: 5040,
          y: 22.028594970703125,
        },
        {
          __typename: 'Points',
          x: 5060,
          y: 21.9635009765625,
        },
        {
          __typename: 'Points',
          x: 5080,
          y: 21.9635009765625,
        },
        {
          __typename: 'Points',
          x: 5100,
          y: 21.9635009765625,
        },
        {
          __typename: 'Points',
          x: 5120,
          y: 21.898391723632812,
        },
        {
          __typename: 'Points',
          x: 5140,
          y: 21.833297729492188,
        },
        {
          __typename: 'Points',
          x: 5160,
          y: 21.7681884765625,
        },
        {
          __typename: 'Points',
          x: 5180,
          y: 21.7681884765625,
        },
        {
          __typename: 'Points',
          x: 5200,
          y: 21.7681884765625,
        },
        {
          __typename: 'Points',
          x: 5220,
          y: 21.703094482421875,
        },
        {
          __typename: 'Points',
          x: 5240,
          y: 21.703094482421875,
        },
        {
          __typename: 'Points',
          x: 5260,
          y: 21.703094482421875,
        },
        {
          __typename: 'Points',
          x: 5280,
          y: 21.63800048828125,
        },
        {
          __typename: 'Points',
          x: 5300,
          y: 15.974288940429688,
        },
        {
          __typename: 'Points',
          x: 5320,
          y: 7.3159942626953125,
        },
        {
          __typename: 'Points',
          x: 5340,
          y: 4.9723968505859375,
        },
        {
          __typename: 'Points',
          x: 5360,
          y: 5.167694091796875,
        },
        {
          __typename: 'Points',
          x: 5380,
          y: 4.2563018798828125,
        },
        {
          __typename: 'Points',
          x: 5400,
          y: 4.6468963623046875,
        },
        {
          __typename: 'Points',
          x: 5420,
          y: 4.7119903564453125,
        },
        {
          __typename: 'Points',
          x: 5440,
          y: 5.2978973388671875,
        },
        {
          __typename: 'Points',
          x: 5460,
          y: 5.8837890625,
        },
        {
          __typename: 'Points',
          x: 5480,
          y: 6.3394927978515625,
        },
        {
          __typename: 'Points',
          x: 5500,
          y: 6.469696044921875,
        },
        {
          __typename: 'Points',
          x: 5520,
          y: 6.40460205078125,
        },
        {
          __typename: 'Points',
          x: 5540,
          y: 6.20928955078125,
        },
        {
          __typename: 'Points',
          x: 5560,
          y: 6.0791015625,
        },
        {
          __typename: 'Points',
          x: 5580,
          y: 6.0791015625,
        },
        {
          __typename: 'Points',
          x: 5600,
          y: 6.0139923095703125,
        },
        {
          __typename: 'Points',
          x: 5620,
          y: 5.9488983154296875,
        },
        {
          __typename: 'Points',
          x: 5640,
          y: 5.9488983154296875,
        },
        {
          __typename: 'Points',
          x: 5660,
          y: 5.8837890625,
        },
        {
          __typename: 'Points',
          x: 5680,
          y: 5.75360107421875,
        },
        {
          __typename: 'Points',
          x: 5700,
          y: 5.8837890625,
        },
        {
          __typename: 'Points',
          x: 5720,
          y: 5.818695068359375,
        },
        {
          __typename: 'Points',
          x: 5740,
          y: 5.818695068359375,
        },
        {
          __typename: 'Points',
          x: 5760,
          y: 5.6884918212890625,
        },
        {
          __typename: 'Points',
          x: 5780,
          y: 5.6884918212890625,
        },
        {
          __typename: 'Points',
          x: 5800,
          y: 5.6233978271484375,
        },
        {
          __typename: 'Points',
          x: 5820,
          y: 5.55828857421875,
        },
        {
          __typename: 'Points',
          x: 5840,
          y: 5.55828857421875,
        },
        {
          __typename: 'Points',
          x: 5860,
          y: 5.55828857421875,
        },
        {
          __typename: 'Points',
          x: 5880,
          y: 5.493194580078125,
        },
        {
          __typename: 'Points',
          x: 5900,
          y: 5.4281005859375,
        },
        {
          __typename: 'Points',
          x: 5920,
          y: 5.4281005859375,
        },
        {
          __typename: 'Points',
          x: 5940,
          y: 5.3629913330078125,
        },
        {
          __typename: 'Points',
          x: 5960,
          y: 5.2978973388671875,
        },
        {
          __typename: 'Points',
          x: 5980,
          y: 5.2978973388671875,
        },
        {
          __typename: 'Points',
          x: 6000,
          y: 5.2327880859375,
        },
        {
          __typename: 'Points',
          x: 6020,
          y: 5.2327880859375,
        },
        {
          __typename: 'Points',
          x: 6040,
          y: 5.167694091796875,
        },
        {
          __typename: 'Points',
          x: 6060,
          y: 5.2327880859375,
        },
        {
          __typename: 'Points',
          x: 6080,
          y: 5.167694091796875,
        },
        {
          __typename: 'Points',
          x: 6100,
          y: 5.10260009765625,
        },
        {
          __typename: 'Points',
          x: 6120,
          y: 5.10260009765625,
        },
        {
          __typename: 'Points',
          x: 6180,
          y: 5.10260009765625,
        },
        {
          __typename: 'Points',
          x: 6200,
          y: 5.0374908447265625,
        },
        {
          __typename: 'Points',
          x: 6220,
          y: 5.10260009765625,
        },
        {
          __typename: 'Points',
          x: 6240,
          y: 5.0374908447265625,
        },
        {
          __typename: 'Points',
          x: 6260,
          y: 5.0374908447265625,
        },
        {
          __typename: 'Points',
          x: 6400,
          y: 5.0374908447265625,
        },
        {
          __typename: 'Points',
          x: 6420,
          y: 5.10260009765625,
        },
        {
          __typename: 'Points',
          x: 6440,
          y: 5.10260009765625,
        },
        {
          __typename: 'Points',
          x: 6500,
          y: 5.10260009765625,
        },
        {
          __typename: 'Points',
          x: 6520,
          y: 5.167694091796875,
        },
        {
          __typename: 'Points',
          x: 6540,
          y: 5.167694091796875,
        },
        {
          __typename: 'Points',
          x: 6640,
          y: 5.167694091796875,
        },
        {
          __typename: 'Points',
          x: 6660,
          y: 5.2327880859375,
        },
        {
          __typename: 'Points',
          x: 6680,
          y: 5.2327880859375,
        },
        {
          __typename: 'Points',
          x: 6780,
          y: 5.2327880859375,
        },
        {
          __typename: 'Points',
          x: 6800,
          y: 5.2978973388671875,
        },
        {
          __typename: 'Points',
          x: 6820,
          y: 5.2978973388671875,
        },
        {
          __typename: 'Points',
          x: 7720,
          y: 5.2978973388671875,
        },
        {
          __typename: 'Points',
          x: 7740,
          y: 5.2327880859375,
        },
        {
          __typename: 'Points',
          x: 7760,
          y: 5.2327880859375,
        },
        {
          __typename: 'Points',
          x: 7960,
          y: 5.2327880859375,
        },
        {
          __typename: 'Points',
          x: 7980,
          y: 5.2978973388671875,
        },
        {
          __typename: 'Points',
          x: 8000,
          y: 5.3629913330078125,
        },
        {
          __typename: 'Points',
          x: 8020,
          y: 5.75360107421875,
        },
        {
          __typename: 'Points',
          x: 8040,
          y: 6.20928955078125,
        },
        {
          __typename: 'Points',
          x: 8060,
          y: 7.05560302734375,
        },
        {
          __typename: 'Points',
          x: 8080,
          y: 8.16229248046875,
        },
        {
          __typename: 'Points',
          x: 8100,
          y: 9.46429443359375,
        },
        {
          __typename: 'Points',
          x: 8120,
          y: 11.026702880859375,
        },
        {
          __typename: 'Points',
          x: 8140,
          y: 12.914596557617188,
        },
        {
          __typename: 'Points',
          x: 8160,
          y: 14.086395263671875,
        },
        {
          __typename: 'Points',
          x: 8180,
          y: 15.062896728515625,
        },
        {
          __typename: 'Points',
          x: 8200,
          y: 15.909194946289062,
        },
        {
          __typename: 'Points',
          x: 8220,
          y: 16.625289916992188,
        },
        {
          __typename: 'Points',
          x: 8240,
          y: 17.146102905273438,
        },
        {
          __typename: 'Points',
          x: 8260,
          y: 17.73199462890625,
        },
        {
          __typename: 'Points',
          x: 8280,
          y: 18.317901611328125,
        },
        {
          __typename: 'Points',
          x: 8300,
          y: 18.838699340820312,
        },
        {
          __typename: 'Points',
          x: 8320,
          y: 19.294387817382812,
        },
        {
          __typename: 'Points',
          x: 8340,
          y: 19.750091552734375,
        },
        {
          __typename: 'Points',
          x: 8360,
          y: 20.270889282226562,
        },
        {
          __typename: 'Points',
          x: 8380,
          y: 20.791702270507812,
        },
        {
          __typename: 'Points',
          x: 8400,
          y: 21.247390747070312,
        },
        {
          __typename: 'Points',
          x: 8420,
          y: 21.7681884765625,
        },
        {
          __typename: 'Points',
          x: 8440,
          y: 22.09368896484375,
        },
        {
          __typename: 'Points',
          x: 8460,
          y: 22.484298706054688,
        },
        {
          __typename: 'Points',
          x: 8480,
          y: 22.874893188476562,
        },
        {
          __typename: 'Points',
          x: 8500,
          y: 23.330596923828125,
        },
        {
          __typename: 'Points',
          x: 8520,
          y: 23.786300659179688,
        },
        {
          __typename: 'Points',
          x: 8540,
          y: 24.176895141601562,
        },
        {
          __typename: 'Points',
          x: 8560,
          y: 24.567489624023438,
        },
        {
          __typename: 'Points',
          x: 8580,
          y: 24.892990112304688,
        },
        {
          __typename: 'Points',
          x: 8600,
          y: 25.283599853515625,
        },
        {
          __typename: 'Points',
          x: 8620,
          y: 25.609100341796875,
        },
        {
          __typename: 'Points',
          x: 8640,
          y: 25.934600830078125,
        },
        {
          __typename: 'Points',
          x: 8660,
          y: 26.3251953125,
        },
        {
          __typename: 'Points',
          x: 8680,
          y: 26.715789794921875,
        },
        {
          __typename: 'Points',
          x: 8700,
          y: 27.041290283203125,
        },
        {
          __typename: 'Points',
          x: 8740,
          y: 27.692291259765625,
        },
        {
          __typename: 'Points',
          x: 8760,
          y: 28.082901000976562,
        },
        {
          __typename: 'Points',
          x: 8780,
          y: 28.473495483398438,
        },
        {
          __typename: 'Points',
          x: 8800,
          y: 28.798995971679688,
        },
        {
          __typename: 'Points',
          x: 8820,
          y: 29.124496459960938,
        },
        {
          __typename: 'Points',
          x: 8840,
          y: 29.319793701171875,
        },
        {
          __typename: 'Points',
          x: 8860,
          y: 29.515090942382812,
        },
        {
          __typename: 'Points',
          x: 8880,
          y: 26.3251953125,
        },
        {
          __typename: 'Points',
          x: 8900,
          y: 22.874893188476562,
        },
        {
          __typename: 'Points',
          x: 8920,
          y: 22.158798217773438,
        },
        {
          __typename: 'Points',
          x: 8940,
          y: 22.614501953125,
        },
        {
          __typename: 'Points',
          x: 8960,
          y: 22.679595947265625,
        },
        {
          __typename: 'Points',
          x: 8980,
          y: 22.419189453125,
        },
        {
          __typename: 'Points',
          x: 9000,
          y: 22.158798217773438,
        },
        {
          __typename: 'Points',
          x: 9020,
          y: 22.028594970703125,
        },
        {
          __typename: 'Points',
          x: 9040,
          y: 22.028594970703125,
        },
        {
          __typename: 'Points',
          x: 9080,
          y: 22.028594970703125,
        },
        {
          __typename: 'Points',
          x: 9100,
          y: 21.9635009765625,
        },
        {
          __typename: 'Points',
          x: 9120,
          y: 21.898391723632812,
        },
        {
          __typename: 'Points',
          x: 9140,
          y: 21.833297729492188,
        },
        {
          __typename: 'Points',
          x: 9160,
          y: 21.7681884765625,
        },
        {
          __typename: 'Points',
          x: 9180,
          y: 21.7681884765625,
        },
        {
          __typename: 'Points',
          x: 9200,
          y: 21.7681884765625,
        },
        {
          __typename: 'Points',
          x: 9220,
          y: 21.703094482421875,
        },
        {
          __typename: 'Points',
          x: 9240,
          y: 21.703094482421875,
        },
        {
          __typename: 'Points',
          x: 9260,
          y: 21.63800048828125,
        },
        {
          __typename: 'Points',
          x: 9280,
          y: 21.63800048828125,
        },
        {
          __typename: 'Points',
          x: 9300,
          y: 16.950790405273438,
        },
        {
          __typename: 'Points',
          x: 9320,
          y: 7.771697998046875,
        },
        {
          __typename: 'Points',
          x: 9340,
          y: 5.2327880859375,
        },
        {
          __typename: 'Points',
          x: 9360,
          y: 4.9723968505859375,
        },
        {
          __typename: 'Points',
          x: 9380,
          y: 4.0609893798828125,
        },
        {
          __typename: 'Points',
          x: 9400,
          y: 4.3213958740234375,
        },
        {
          __typename: 'Points',
          x: 9420,
          y: 4.777099609375,
        },
        {
          __typename: 'Points',
          x: 9440,
          y: 5.167694091796875,
        },
        {
          __typename: 'Points',
          x: 9460,
          y: 5.8837890625,
        },
        {
          __typename: 'Points',
          x: 9480,
          y: 6.40460205078125,
        },
        {
          __typename: 'Points',
          x: 9500,
          y: 6.469696044921875,
        },
        {
          __typename: 'Points',
          x: 9520,
          y: 6.3394927978515625,
        },
        {
          __typename: 'Points',
          x: 9540,
          y: 6.144195556640625,
        },
        {
          __typename: 'Points',
          x: 9560,
          y: 6.0791015625,
        },
        {
          __typename: 'Points',
          x: 9580,
          y: 6.0791015625,
        },
        {
          __typename: 'Points',
          x: 9600,
          y: 5.9488983154296875,
        },
        {
          __typename: 'Points',
          x: 9620,
          y: 5.8837890625,
        },
        {
          __typename: 'Points',
          x: 9640,
          y: 5.8837890625,
        },
        {
          __typename: 'Points',
          x: 9660,
          y: 5.9488983154296875,
        },
        {
          __typename: 'Points',
          x: 9680,
          y: 5.818695068359375,
        },
        {
          __typename: 'Points',
          x: 9700,
          y: 5.818695068359375,
        },
        {
          __typename: 'Points',
          x: 9720,
          y: 5.818695068359375,
        },
        {
          __typename: 'Points',
          x: 9740,
          y: 5.75360107421875,
        },
        {
          __typename: 'Points',
          x: 9760,
          y: 5.6884918212890625,
        },
        {
          __typename: 'Points',
          x: 9780,
          y: 5.6233978271484375,
        },
        {
          __typename: 'Points',
          x: 9800,
          y: 5.6233978271484375,
        },
        {
          __typename: 'Points',
          x: 9820,
          y: 5.55828857421875,
        },
        {
          __typename: 'Points',
          x: 9840,
          y: 5.55828857421875,
        },
        {
          __typename: 'Points',
          x: 9860,
          y: 5.493194580078125,
        },
        {
          __typename: 'Points',
          x: 9880,
          y: 5.493194580078125,
        },
        {
          __typename: 'Points',
          x: 9900,
          y: 5.4281005859375,
        },
        {
          __typename: 'Points',
          x: 9920,
          y: 5.4281005859375,
        },
        {
          __typename: 'Points',
          x: 9940,
          y: 5.3629913330078125,
        },
        {
          __typename: 'Points',
          x: 9960,
          y: 5.3629913330078125,
        },
        {
          __typename: 'Points',
          x: 9980,
          y: 5.3629913330078125,
        },
        {
          __typename: 'Points',
          x: 10000,
          y: 5.2327880859375,
        },
        {
          __typename: 'Points',
          x: 10020,
          y: 5.2327880859375,
        },
        {
          __typename: 'Points',
          x: 10060,
          y: 5.2327880859375,
        },
        {
          __typename: 'Points',
          x: 10080,
          y: 5.167694091796875,
        },
        {
          __typename: 'Points',
          x: 10100,
          y: 5.167694091796875,
        },
        {
          __typename: 'Points',
          x: 10120,
          y: 5.10260009765625,
        },
        {
          __typename: 'Points',
          x: 10140,
          y: 5.10260009765625,
        },
        {
          __typename: 'Points',
          x: 10220,
          y: 5.10260009765625,
        },
        {
          __typename: 'Points',
          x: 10240,
          y: 5.0374908447265625,
        },
        {
          __typename: 'Points',
          x: 10260,
          y: 5.0374908447265625,
        },
        {
          __typename: 'Points',
          x: 10400,
          y: 5.0374908447265625,
        },
        {
          __typename: 'Points',
          x: 10420,
          y: 5.10260009765625,
        },
        {
          __typename: 'Points',
          x: 10440,
          y: 5.10260009765625,
        },
        {
          __typename: 'Points',
          x: 10520,
          y: 5.10260009765625,
        },
        {
          __typename: 'Points',
          x: 10540,
          y: 5.167694091796875,
        },
        {
          __typename: 'Points',
          x: 10560,
          y: 5.167694091796875,
        },
        {
          __typename: 'Points',
          x: 10660,
          y: 5.167694091796875,
        },
        {
          __typename: 'Points',
          x: 10680,
          y: 5.2327880859375,
        },
        {
          __typename: 'Points',
          x: 10700,
          y: 5.2327880859375,
        },
        {
          __typename: 'Points',
          x: 10760,
          y: 5.2327880859375,
        },
        {
          __typename: 'Points',
          x: 10780,
          y: 5.2978973388671875,
        },
        {
          __typename: 'Points',
          x: 10800,
          y: 5.2978973388671875,
        },
        {
          __typename: 'Points',
          x: 11740,
          y: 5.2978973388671875,
        },
        {
          __typename: 'Points',
          x: 11760,
          y: 5.2327880859375,
        },
        {
          __typename: 'Points',
          x: 11780,
          y: 5.2327880859375,
        },
        {
          __typename: 'Points',
          x: 11800,
          y: 5.2978973388671875,
        },
        {
          __typename: 'Points',
          x: 11820,
          y: 5.2978973388671875,
        },
        {
          __typename: 'Points',
          x: 11840,
          y: 5.2978973388671875,
        },
        {
          __typename: 'Points',
          x: 11860,
          y: 5.2327880859375,
        },
        {
          __typename: 'Points',
          x: 11880,
          y: 5.2327880859375,
        },
        {
          __typename: 'Points',
          x: 11960,
          y: 5.2327880859375,
        },
        {
          __typename: 'Points',
          x: 11980,
          y: 5.3629913330078125,
        },
        {
          __typename: 'Points',
          x: 12000,
          y: 5.2978973388671875,
        },
        {
          __typename: 'Points',
          x: 12020,
          y: 5.493194580078125,
        },
        {
          __typename: 'Points',
          x: 12040,
          y: 6.144195556640625,
        },
        {
          __typename: 'Points',
          x: 12060,
          y: 6.9904937744140625,
        },
        {
          __typename: 'Points',
          x: 12080,
          y: 8.032089233398438,
        },
        {
          __typename: 'Points',
          x: 12100,
          y: 9.334091186523438,
        },
        {
          __typename: 'Points',
          x: 12120,
          y: 10.831390380859375,
        },
        {
          __typename: 'Points',
          x: 12140,
          y: 12.654190063476562,
        },
        {
          __typename: 'Points',
          x: 12160,
          y: 13.891098022460938,
        },
        {
          __typename: 'Points',
          x: 12180,
          y: 14.932693481445312,
        },
        {
          __typename: 'Points',
          x: 12200,
          y: 15.77899169921875,
        },
        {
          __typename: 'Points',
          x: 12220,
          y: 16.42999267578125,
        },
        {
          __typename: 'Points',
          x: 12240,
          y: 16.950790405273438,
        },
        {
          __typename: 'Points',
          x: 12260,
          y: 17.536697387695312,
        },
        {
          __typename: 'Points',
          x: 12280,
          y: 18.187698364257812,
        },
        {
          __typename: 'Points',
          x: 12300,
          y: 18.643402099609375,
        },
        {
          __typename: 'Points',
          x: 12320,
          y: 19.229293823242188,
        },
        {
          __typename: 'Points',
          x: 12340,
          y: 19.68499755859375,
        },
        {
          __typename: 'Points',
          x: 12360,
          y: 20.270889282226562,
        },
        {
          __typename: 'Points',
          x: 12380,
          y: 20.6614990234375,
        },
        {
          __typename: 'Points',
          x: 12400,
          y: 21.117202758789062,
        },
        {
          __typename: 'Points',
          x: 12420,
          y: 21.572891235351562,
        },
        {
          __typename: 'Points',
          x: 12440,
          y: 22.028594970703125,
        },
        {
          __typename: 'Points',
          x: 12480,
          y: 22.94000244140625,
        },
        {
          __typename: 'Points',
          x: 12500,
          y: 23.330596923828125,
        },
        {
          __typename: 'Points',
          x: 12520,
          y: 23.656097412109375,
        },
        {
          __typename: 'Points',
          x: 12540,
          y: 24.111801147460938,
        },
        {
          __typename: 'Points',
          x: 12560,
          y: 24.502395629882812,
        },
        {
          __typename: 'Points',
          x: 12580,
          y: 24.958099365234375,
        },
        {
          __typename: 'Points',
          x: 12600,
          y: 25.283599853515625,
        },
        {
          __typename: 'Points',
          x: 12620,
          y: 25.609100341796875,
        },
        {
          __typename: 'Points',
          x: 12640,
          y: 25.99969482421875,
        },
        {
          __typename: 'Points',
          x: 12660,
          y: 26.3251953125,
        },
        {
          __typename: 'Points',
          x: 12680,
          y: 26.65069580078125,
        },
        {
          __typename: 'Points',
          x: 12700,
          y: 26.911102294921875,
        },
        {
          __typename: 'Points',
          x: 12720,
          y: 27.366790771484375,
        },
        {
          __typename: 'Points',
          x: 12740,
          y: 27.692291259765625,
        },
        {
          __typename: 'Points',
          x: 12760,
          y: 28.017791748046875,
        },
        {
          __typename: 'Points',
          x: 12780,
          y: 28.408401489257812,
        },
        {
          __typename: 'Points',
          x: 12800,
          y: 28.733901977539062,
        },
        {
          __typename: 'Points',
          x: 12820,
          y: 29.059402465820312,
        },
        {
          __typename: 'Points',
          x: 12840,
          y: 29.319793701171875,
        },
        {
          __typename: 'Points',
          x: 12860,
          y: 29.5802001953125,
        },
        {
          __typename: 'Points',
          x: 12880,
          y: 25.6741943359375,
        },
        {
          __typename: 'Points',
          x: 12900,
          y: 22.614501953125,
        },
        {
          __typename: 'Points',
          x: 12920,
          y: 22.614501953125,
        },
        {
          __typename: 'Points',
          x: 12940,
          y: 22.809799194335938,
        },
        {
          __typename: 'Points',
          x: 12960,
          y: 22.679595947265625,
        },
        {
          __typename: 'Points',
          x: 12980,
          y: 22.28900146484375,
        },
        {
          __typename: 'Points',
          x: 13000,
          y: 22.028594970703125,
        },
        {
          __typename: 'Points',
          x: 13020,
          y: 22.028594970703125,
        },
        {
          __typename: 'Points',
          x: 13040,
          y: 22.09368896484375,
        },
        {
          __typename: 'Points',
          x: 13060,
          y: 22.028594970703125,
        },
        {
          __typename: 'Points',
          x: 13080,
          y: 22.028594970703125,
        },
        {
          __typename: 'Points',
          x: 13100,
          y: 21.9635009765625,
        },
        {
          __typename: 'Points',
          x: 13120,
          y: 21.898391723632812,
        },
        {
          __typename: 'Points',
          x: 13140,
          y: 21.7681884765625,
        },
        {
          __typename: 'Points',
          x: 13160,
          y: 21.7681884765625,
        },
        {
          __typename: 'Points',
          x: 13200,
          y: 21.7681884765625,
        },
        {
          __typename: 'Points',
          x: 13220,
          y: 21.703094482421875,
        },
        {
          __typename: 'Points',
          x: 13240,
          y: 21.63800048828125,
        },
        {
          __typename: 'Points',
          x: 13260,
          y: 21.63800048828125,
        },
        {
          __typename: 'Points',
          x: 13280,
          y: 21.63800048828125,
        },
        {
          __typename: 'Points',
          x: 13300,
          y: 18.252792358398438,
        },
        {
          __typename: 'Points',
          x: 13320,
          y: 8.227401733398438,
        },
        {
          __typename: 'Points',
          x: 13340,
          y: 5.167694091796875,
        },
        {
          __typename: 'Points',
          x: 13360,
          y: 5.493194580078125,
        },
        {
          __typename: 'Points',
          x: 13380,
          y: 4.1260986328125,
        },
        {
          __typename: 'Points',
          x: 13400,
          y: 4.3864898681640625,
        },
        {
          __typename: 'Points',
          x: 13420,
          y: 4.5818023681640625,
        },
        {
          __typename: 'Points',
          x: 13440,
          y: 5.167694091796875,
        },
        {
          __typename: 'Points',
          x: 13460,
          y: 5.75360107421875,
        },
        {
          __typename: 'Points',
          x: 13480,
          y: 6.2743988037109375,
        },
        {
          __typename: 'Points',
          x: 13500,
          y: 6.40460205078125,
        },
        {
          __typename: 'Points',
          x: 13520,
          y: 6.3394927978515625,
        },
        {
          __typename: 'Points',
          x: 13540,
          y: 6.20928955078125,
        },
        {
          __typename: 'Points',
          x: 13560,
          y: 6.0791015625,
        },
        {
          __typename: 'Points',
          x: 13580,
          y: 6.0791015625,
        },
        {
          __typename: 'Points',
          x: 13600,
          y: 6.0139923095703125,
        },
        {
          __typename: 'Points',
          x: 13620,
          y: 5.9488983154296875,
        },
        {
          __typename: 'Points',
          x: 13640,
          y: 6.0139923095703125,
        },
        {
          __typename: 'Points',
          x: 13660,
          y: 5.9488983154296875,
        },
        {
          __typename: 'Points',
          x: 13680,
          y: 5.818695068359375,
        },
        {
          __typename: 'Points',
          x: 13700,
          y: 5.75360107421875,
        },
        {
          __typename: 'Points',
          x: 13720,
          y: 5.75360107421875,
        },
        {
          __typename: 'Points',
          x: 13740,
          y: 5.6884918212890625,
        },
        {
          __typename: 'Points',
          x: 13760,
          y: 5.6884918212890625,
        },
        {
          __typename: 'Points',
          x: 13780,
          y: 5.6884918212890625,
        },
        {
          __typename: 'Points',
          x: 13800,
          y: 5.6233978271484375,
        },
        {
          __typename: 'Points',
          x: 13820,
          y: 5.6233978271484375,
        },
        {
          __typename: 'Points',
          x: 13840,
          y: 5.55828857421875,
        },
        {
          __typename: 'Points',
          x: 13860,
          y: 5.55828857421875,
        },
        {
          __typename: 'Points',
          x: 13880,
          y: 5.493194580078125,
        },
        {
          __typename: 'Points',
          x: 13900,
          y: 5.4281005859375,
        },
        {
          __typename: 'Points',
          x: 13920,
          y: 5.4281005859375,
        },
        {
          __typename: 'Points',
          x: 13940,
          y: 5.4281005859375,
        },
        {
          __typename: 'Points',
          x: 13960,
          y: 5.3629913330078125,
        },
        {
          __typename: 'Points',
          x: 13980,
          y: 5.2978973388671875,
        },
        {
          __typename: 'Points',
          x: 14000,
          y: 5.2978973388671875,
        },
        {
          __typename: 'Points',
          x: 14020,
          y: 5.2978973388671875,
        },
        {
          __typename: 'Points',
          x: 14040,
          y: 5.2327880859375,
        },
        {
          __typename: 'Points',
          x: 14060,
          y: 5.2327880859375,
        },
        {
          __typename: 'Points',
          x: 14080,
          y: 5.167694091796875,
        },
        {
          __typename: 'Points',
          x: 14100,
          y: 5.167694091796875,
        },
        {
          __typename: 'Points',
          x: 14120,
          y: 5.167694091796875,
        },
        {
          __typename: 'Points',
          x: 14140,
          y: 5.10260009765625,
        },
        {
          __typename: 'Points',
          x: 14160,
          y: 5.10260009765625,
        },
        {
          __typename: 'Points',
          x: 14280,
          y: 5.10260009765625,
        },
        {
          __typename: 'Points',
          x: 14300,
          y: 5.0374908447265625,
        },
        {
          __typename: 'Points',
          x: 14320,
          y: 5.0374908447265625,
        },
        {
          __typename: 'Points',
          x: 14380,
          y: 5.0374908447265625,
        },
        {
          __typename: 'Points',
          x: 14400,
          y: 5.10260009765625,
        },
        {
          __typename: 'Points',
          x: 14420,
          y: 5.10260009765625,
        },
        {
          __typename: 'Points',
          x: 14500,
          y: 5.10260009765625,
        },
        {
          __typename: 'Points',
          x: 14520,
          y: 5.167694091796875,
        },
        {
          __typename: 'Points',
          x: 14540,
          y: 5.167694091796875,
        },
        {
          __typename: 'Points',
          x: 14640,
          y: 5.167694091796875,
        },
        {
          __typename: 'Points',
          x: 14660,
          y: 5.2327880859375,
        },
        {
          __typename: 'Points',
          x: 14680,
          y: 5.2327880859375,
        },
        {
          __typename: 'Points',
          x: 14740,
          y: 5.2327880859375,
        },
        {
          __typename: 'Points',
          x: 14760,
          y: 5.2978973388671875,
        },
        {
          __typename: 'Points',
          x: 14780,
          y: 5.2978973388671875,
        },
        {
          __typename: 'Points',
          x: 15960,
          y: 5.2978973388671875,
        },
        {
          __typename: 'Points',
          x: 15980,
          y: 5.3629913330078125,
        },
        {
          __typename: 'Points',
          x: 16000,
          y: 5.3629913330078125,
        },
      ],
      airFlowWave: [
        {
          __typename: 'Points',
          x: 0,
          y: 138.5546875,
        },
        {
          __typename: 'Points',
          x: 20,
          y: 212.076904296875,
        },
        {
          __typename: 'Points',
          x: 40,
          y: 287.76953125,
        },
        {
          __typename: 'Points',
          x: 60,
          y: 360.47802734375,
        },
        {
          __typename: 'Points',
          x: 80,
          y: 434.814208984375,
        },
        {
          __typename: 'Points',
          x: 100,
          y: 510.5068359375,
        },
        {
          __typename: 'Points',
          x: 120,
          y: 580.773681640625,
        },
        {
          __typename: 'Points',
          x: 140,
          y: 607.903564453125,
        },
        {
          __typename: 'Points',
          x: 160,
          y: 607.08984375,
        },
        {
          __typename: 'Points',
          x: 180,
          y: 611.430419921875,
        },
        {
          __typename: 'Points',
          x: 200,
          y: 609.531494140625,
        },
        {
          __typename: 'Points',
          x: 220,
          y: 608.1748046875,
        },
        {
          __typename: 'Points',
          x: 240,
          y: 607.08984375,
        },
        {
          __typename: 'Points',
          x: 260,
          y: 607.08984375,
        },
        {
          __typename: 'Points',
          x: 280,
          y: 604.64794921875,
        },
        {
          __typename: 'Points',
          x: 300,
          y: 607.361083984375,
        },
        {
          __typename: 'Points',
          x: 320,
          y: 606.27587890625,
        },
        {
          __typename: 'Points',
          x: 340,
          y: 610.61669921875,
        },
        {
          __typename: 'Points',
          x: 360,
          y: 608.98876953125,
        },
        {
          __typename: 'Points',
          x: 380,
          y: 605.4619140625,
        },
        {
          __typename: 'Points',
          x: 400,
          y: 606.27587890625,
        },
        {
          __typename: 'Points',
          x: 420,
          y: 605.733154296875,
        },
        {
          __typename: 'Points',
          x: 440,
          y: 607.08984375,
        },
        {
          __typename: 'Points',
          x: 460,
          y: 609.531494140625,
        },
        {
          __typename: 'Points',
          x: 480,
          y: 610.34521484375,
        },
        {
          __typename: 'Points',
          x: 500,
          y: 607.903564453125,
        },
        {
          __typename: 'Points',
          x: 520,
          y: 603.834228515625,
        },
        {
          __typename: 'Points',
          x: 540,
          y: 606.27587890625,
        },
        {
          __typename: 'Points',
          x: 560,
          y: 604.376708984375,
        },
        {
          __typename: 'Points',
          x: 580,
          y: 607.08984375,
        },
        {
          __typename: 'Points',
          x: 600,
          y: 607.08984375,
        },
        {
          __typename: 'Points',
          x: 620,
          y: 607.903564453125,
        },
        {
          __typename: 'Points',
          x: 640,
          y: 607.08984375,
        },
        {
          __typename: 'Points',
          x: 660,
          y: 610.61669921875,
        },
        {
          __typename: 'Points',
          x: 680,
          y: 607.08984375,
        },
        {
          __typename: 'Points',
          x: 700,
          y: 607.08984375,
        },
        {
          __typename: 'Points',
          x: 720,
          y: 607.903564453125,
        },
        {
          __typename: 'Points',
          x: 740,
          y: 604.64794921875,
        },
        {
          __typename: 'Points',
          x: 760,
          y: 607.903564453125,
        },
        {
          __typename: 'Points',
          x: 780,
          y: 607.903564453125,
        },
        {
          __typename: 'Points',
          x: 800,
          y: 606.27587890625,
        },
        {
          __typename: 'Points',
          x: 820,
          y: 608.717529296875,
        },
        {
          __typename: 'Points',
          x: 840,
          y: 607.08984375,
        },
        {
          __typename: 'Points',
          x: 860,
          y: 585.656982421875,
        },
        {
          __typename: 'Points',
          x: 880,
          y: 5.61767578125,
        },
        {
          __typename: 'Points',
          x: 900,
          y: 4.8037109375,
        },
        {
          __typename: 'Points',
          x: 920,
          y: -0.07958984375,
        },
        {
          __typename: 'Points',
          x: 940,
          y: -0.07958984375,
        },
        {
          __typename: 'Points',
          x: 960,
          y: 1.005615234375,
        },
        {
          __typename: 'Points',
          x: 980,
          y: 1.005615234375,
        },
        {
          __typename: 'Points',
          x: 1000,
          y: 1.005615234375,
        },
        {
          __typename: 'Points',
          x: 1020,
          y: 1.8193359375,
        },
        {
          __typename: 'Points',
          x: 1040,
          y: 1.005615234375,
        },
        {
          __typename: 'Points',
          x: 1060,
          y: 1.005615234375,
        },
        {
          __typename: 'Points',
          x: 1260,
          y: 1.005615234375,
        },
        {
          __typename: 'Points',
          x: 1280,
          y: -0.622314453125,
        },
        {
          __typename: 'Points',
          x: 1300,
          y: -711.156982421875,
        },
        {
          __typename: 'Points',
          x: 1320,
          y: -1107.526123046875,
        },
        {
          __typename: 'Points',
          x: 1340,
          y: -841.380859375,
        },
        {
          __typename: 'Points',
          x: 1360,
          y: -873.66552734375,
        },
        {
          __typename: 'Points',
          x: 1380,
          y: -867.697021484375,
        },
        {
          __typename: 'Points',
          x: 1400,
          y: -821.033447265625,
        },
        {
          __typename: 'Points',
          x: 1420,
          y: -780.609619140625,
        },
        {
          __typename: 'Points',
          x: 1440,
          y: -751.58056640625,
        },
        {
          __typename: 'Points',
          x: 1460,
          y: -702.475341796875,
        },
        {
          __typename: 'Points',
          x: 1480,
          y: -684.8408203125,
        },
        {
          __typename: 'Points',
          x: 1500,
          y: -685.38330078125,
        },
        {
          __typename: 'Points',
          x: 1520,
          y: -665.30712890625,
        },
        {
          __typename: 'Points',
          x: 1540,
          y: -663.13671875,
        },
        {
          __typename: 'Points',
          x: 1560,
          y: -644.6884765625,
        },
        {
          __typename: 'Points',
          x: 1580,
          y: -631.12353515625,
        },
        {
          __typename: 'Points',
          x: 1600,
          y: -614.031494140625,
        },
        {
          __typename: 'Points',
          x: 1620,
          y: -600.73779296875,
        },
        {
          __typename: 'Points',
          x: 1640,
          y: -579.30517578125,
        },
        {
          __typename: 'Points',
          x: 1660,
          y: -571.708740234375,
        },
        {
          __typename: 'Points',
          x: 1680,
          y: -550.818603515625,
        },
        {
          __typename: 'Points',
          x: 1700,
          y: -544.85009765625,
        },
        {
          __typename: 'Points',
          x: 1720,
          y: -524.77392578125,
        },
        {
          __typename: 'Points',
          x: 1740,
          y: -505.511474609375,
        },
        {
          __typename: 'Points',
          x: 1760,
          y: -496.55859375,
        },
        {
          __typename: 'Points',
          x: 1780,
          y: -475.1259765625,
        },
        {
          __typename: 'Points',
          x: 1800,
          y: -463.188720703125,
        },
        {
          __typename: 'Points',
          x: 1820,
          y: -441.484619140625,
        },
        {
          __typename: 'Points',
          x: 1840,
          y: -426.0205078125,
        },
        {
          __typename: 'Points',
          x: 1860,
          y: -415.43994140625,
        },
        {
          __typename: 'Points',
          x: 1880,
          y: -394.00732421875,
        },
        {
          __typename: 'Points',
          x: 1900,
          y: -379.899658203125,
        },
        {
          __typename: 'Points',
          x: 1920,
          y: -364.164306640625,
        },
        {
          __typename: 'Points',
          x: 1940,
          y: -352.22705078125,
        },
        {
          __typename: 'Points',
          x: 1960,
          y: -337.305419921875,
        },
        {
          __typename: 'Points',
          x: 1980,
          y: -314.2451171875,
        },
        {
          __typename: 'Points',
          x: 2000,
          y: -289.828125,
        },
        {
          __typename: 'Points',
          x: 2020,
          y: -282.231689453125,
        },
        {
          __typename: 'Points',
          x: 2040,
          y: -256.186767578125,
        },
        {
          __typename: 'Points',
          x: 2060,
          y: -245.0634765625,
        },
        {
          __typename: 'Points',
          x: 2080,
          y: -222.0029296875,
        },
        {
          __typename: 'Points',
          x: 2100,
          y: -208.709228515625,
        },
        {
          __typename: 'Points',
          x: 2120,
          y: -184.292236328125,
        },
        {
          __typename: 'Points',
          x: 2140,
          y: -162.58837890625,
        },
        {
          __typename: 'Points',
          x: 2160,
          y: -147.666748046875,
        },
        {
          __typename: 'Points',
          x: 2180,
          y: -128.404541015625,
        },
        {
          __typename: 'Points',
          x: 2200,
          y: -114.296875,
        },
        {
          __typename: 'Points',
          x: 2220,
          y: -94.220703125,
        },
        {
          __typename: 'Points',
          x: 2240,
          y: -76.31494140625,
        },
        {
          __typename: 'Points',
          x: 2260,
          y: -58.4091796875,
        },
        {
          __typename: 'Points',
          x: 2280,
          y: -46.471923828125,
        },
        {
          __typename: 'Points',
          x: 2300,
          y: -32.3642578125,
        },
        {
          __typename: 'Points',
          x: 2320,
          y: -31.0078125,
        },
        {
          __typename: 'Points',
          x: 2340,
          y: -22.59765625,
        },
        {
          __typename: 'Points',
          x: 2360,
          y: -14.45849609375,
        },
        {
          __typename: 'Points',
          x: 2380,
          y: -11.474365234375,
        },
        {
          __typename: 'Points',
          x: 2400,
          y: -11.474365234375,
        },
        {
          __typename: 'Points',
          x: 2420,
          y: -4.149169921875,
        },
        {
          __typename: 'Points',
          x: 2440,
          y: -3.335205078125,
        },
        {
          __typename: 'Points',
          x: 2460,
          y: -9.303955078125,
        },
        {
          __typename: 'Points',
          x: 2480,
          y: -1.164794921875,
        },
        {
          __typename: 'Points',
          x: 2500,
          y: -1.70751953125,
        },
        {
          __typename: 'Points',
          x: 2520,
          y: -2.521240234375,
        },
        {
          __typename: 'Points',
          x: 2540,
          y: -1.70751953125,
        },
        {
          __typename: 'Points',
          x: 2560,
          y: 3.176025390625,
        },
        {
          __typename: 'Points',
          x: 2580,
          y: -1.164794921875,
        },
        {
          __typename: 'Points',
          x: 2600,
          y: 2.63330078125,
        },
        {
          __typename: 'Points',
          x: 2620,
          y: 1.005615234375,
        },
        {
          __typename: 'Points',
          x: 2640,
          y: 1.005615234375,
        },
        {
          __typename: 'Points',
          x: 2660,
          y: -3.335205078125,
        },
        {
          __typename: 'Points',
          x: 2680,
          y: 0.462890625,
        },
        {
          __typename: 'Points',
          x: 2700,
          y: 0.462890625,
        },
        {
          __typename: 'Points',
          x: 2720,
          y: -1.70751953125,
        },
        {
          __typename: 'Points',
          x: 2740,
          y: 1.005615234375,
        },
        {
          __typename: 'Points',
          x: 2760,
          y: -1.70751953125,
        },
        {
          __typename: 'Points',
          x: 2780,
          y: -2.521240234375,
        },
        {
          __typename: 'Points',
          x: 2800,
          y: -2.521240234375,
        },
        {
          __typename: 'Points',
          x: 2820,
          y: -4.149169921875,
        },
        {
          __typename: 'Points',
          x: 2840,
          y: 0.462890625,
        },
        {
          __typename: 'Points',
          x: 2860,
          y: -4.149169921875,
        },
        {
          __typename: 'Points',
          x: 2880,
          y: 0.462890625,
        },
        {
          __typename: 'Points',
          x: 2900,
          y: -2.521240234375,
        },
        {
          __typename: 'Points',
          x: 2920,
          y: -5.505615234375,
        },
        {
          __typename: 'Points',
          x: 2940,
          y: -6.319580078125,
        },
        {
          __typename: 'Points',
          x: 2960,
          y: -4.149169921875,
        },
        {
          __typename: 'Points',
          x: 2980,
          y: -1.164794921875,
        },
        {
          __typename: 'Points',
          x: 3000,
          y: -6.319580078125,
        },
        {
          __typename: 'Points',
          x: 3020,
          y: -3.335205078125,
        },
        {
          __typename: 'Points',
          x: 3040,
          y: -3.335205078125,
        },
        {
          __typename: 'Points',
          x: 3060,
          y: -7.133544921875,
        },
        {
          __typename: 'Points',
          x: 3080,
          y: -1.70751953125,
        },
        {
          __typename: 'Points',
          x: 3100,
          y: -4.149169921875,
        },
        {
          __typename: 'Points',
          x: 3120,
          y: -4.149169921875,
        },
        {
          __typename: 'Points',
          x: 3140,
          y: -6.319580078125,
        },
        {
          __typename: 'Points',
          x: 3160,
          y: -3.335205078125,
        },
        {
          __typename: 'Points',
          x: 3180,
          y: -6.319580078125,
        },
        {
          __typename: 'Points',
          x: 3200,
          y: -7.133544921875,
        },
        {
          __typename: 'Points',
          x: 3220,
          y: -6.319580078125,
        },
        {
          __typename: 'Points',
          x: 3240,
          y: -4.149169921875,
        },
        {
          __typename: 'Points',
          x: 3260,
          y: -6.319580078125,
        },
        {
          __typename: 'Points',
          x: 3280,
          y: -4.149169921875,
        },
        {
          __typename: 'Points',
          x: 3300,
          y: -5.505615234375,
        },
        {
          __typename: 'Points',
          x: 3320,
          y: -3.335205078125,
        },
        {
          __typename: 'Points',
          x: 3340,
          y: -7.133544921875,
        },
        {
          __typename: 'Points',
          x: 3360,
          y: -4.149169921875,
        },
        {
          __typename: 'Points',
          x: 3380,
          y: -1.70751953125,
        },
        {
          __typename: 'Points',
          x: 3400,
          y: -4.149169921875,
        },
        {
          __typename: 'Points',
          x: 3420,
          y: -7.133544921875,
        },
        {
          __typename: 'Points',
          x: 3440,
          y: -4.149169921875,
        },
        {
          __typename: 'Points',
          x: 3460,
          y: -7.676025390625,
        },
        {
          __typename: 'Points',
          x: 3480,
          y: -2.521240234375,
        },
        {
          __typename: 'Points',
          x: 3500,
          y: -10.11767578125,
        },
        {
          __typename: 'Points',
          x: 3520,
          y: -2.521240234375,
        },
        {
          __typename: 'Points',
          x: 3540,
          y: -6.319580078125,
        },
        {
          __typename: 'Points',
          x: 3560,
          y: -4.149169921875,
        },
        {
          __typename: 'Points',
          x: 3580,
          y: -7.133544921875,
        },
        {
          __typename: 'Points',
          x: 3600,
          y: -4.149169921875,
        },
        {
          __typename: 'Points',
          x: 3620,
          y: -6.319580078125,
        },
        {
          __typename: 'Points',
          x: 3640,
          y: -3.335205078125,
        },
        {
          __typename: 'Points',
          x: 3660,
          y: -1.70751953125,
        },
        {
          __typename: 'Points',
          x: 3680,
          y: -4.149169921875,
        },
        {
          __typename: 'Points',
          x: 3700,
          y: -5.505615234375,
        },
        {
          __typename: 'Points',
          x: 3720,
          y: -6.319580078125,
        },
        {
          __typename: 'Points',
          x: 3740,
          y: -4.149169921875,
        },
        {
          __typename: 'Points',
          x: 3760,
          y: -5.505615234375,
        },
        {
          __typename: 'Points',
          x: 3780,
          y: -6.319580078125,
        },
        {
          __typename: 'Points',
          x: 3800,
          y: -7.133544921875,
        },
        {
          __typename: 'Points',
          x: 3820,
          y: -3.335205078125,
        },
        {
          __typename: 'Points',
          x: 3840,
          y: -4.149169921875,
        },
        {
          __typename: 'Points',
          x: 3860,
          y: -3.335205078125,
        },
        {
          __typename: 'Points',
          x: 3880,
          y: -2.521240234375,
        },
        {
          __typename: 'Points',
          x: 3900,
          y: -7.133544921875,
        },
        {
          __typename: 'Points',
          x: 3920,
          y: -4.149169921875,
        },
        {
          __typename: 'Points',
          x: 3940,
          y: -3.335205078125,
        },
        {
          __typename: 'Points',
          x: 3960,
          y: -3.335205078125,
        },
        {
          __typename: 'Points',
          x: 3980,
          y: 27.05029296875,
        },
        {
          __typename: 'Points',
          x: 4000,
          y: 128.787841796875,
        },
        {
          __typename: 'Points',
          x: 4020,
          y: 203.666748046875,
        },
        {
          __typename: 'Points',
          x: 4040,
          y: 279.359375,
        },
        {
          __typename: 'Points',
          x: 4060,
          y: 353.42431640625,
        },
        {
          __typename: 'Points',
          x: 4080,
          y: 426.132568359375,
        },
        {
          __typename: 'Points',
          x: 4100,
          y: 501.825439453125,
        },
        {
          __typename: 'Points',
          x: 4120,
          y: 575.89013671875,
        },
        {
          __typename: 'Points',
          x: 4140,
          y: 630.964111328125,
        },
        {
          __typename: 'Points',
          x: 4160,
          y: 607.903564453125,
        },
        {
          __typename: 'Points',
          x: 4180,
          y: 608.717529296875,
        },
        {
          __typename: 'Points',
          x: 4200,
          y: 610.61669921875,
        },
        {
          __typename: 'Points',
          x: 4220,
          y: 607.903564453125,
        },
        {
          __typename: 'Points',
          x: 4240,
          y: 604.64794921875,
        },
        {
          __typename: 'Points',
          x: 4260,
          y: 605.4619140625,
        },
        {
          __typename: 'Points',
          x: 4280,
          y: 609.531494140625,
        },
        {
          __typename: 'Points',
          x: 4300,
          y: 607.903564453125,
        },
        {
          __typename: 'Points',
          x: 4320,
          y: 606.27587890625,
        },
        {
          __typename: 'Points',
          x: 4340,
          y: 610.61669921875,
        },
        {
          __typename: 'Points',
          x: 4360,
          y: 612.244384765625,
        },
        {
          __typename: 'Points',
          x: 4380,
          y: 610.34521484375,
        },
        {
          __typename: 'Points',
          x: 4400,
          y: 613.058349609375,
        },
        {
          __typename: 'Points',
          x: 4420,
          y: 606.27587890625,
        },
        {
          __typename: 'Points',
          x: 4440,
          y: 606.27587890625,
        },
        {
          __typename: 'Points',
          x: 4460,
          y: 603.020263671875,
        },
        {
          __typename: 'Points',
          x: 4480,
          y: 606.27587890625,
        },
        {
          __typename: 'Points',
          x: 4500,
          y: 607.08984375,
        },
        {
          __typename: 'Points',
          x: 4520,
          y: 610.34521484375,
        },
        {
          __typename: 'Points',
          x: 4540,
          y: 605.4619140625,
        },
        {
          __typename: 'Points',
          x: 4560,
          y: 606.27587890625,
        },
        {
          __typename: 'Points',
          x: 4600,
          y: 606.27587890625,
        },
        {
          __typename: 'Points',
          x: 4620,
          y: 607.08984375,
        },
        {
          __typename: 'Points',
          x: 4640,
          y: 606.27587890625,
        },
        {
          __typename: 'Points',
          x: 4660,
          y: 607.903564453125,
        },
        {
          __typename: 'Points',
          x: 4680,
          y: 606.27587890625,
        },
        {
          __typename: 'Points',
          x: 4700,
          y: 606.27587890625,
        },
        {
          __typename: 'Points',
          x: 4720,
          y: 605.4619140625,
        },
        {
          __typename: 'Points',
          x: 4740,
          y: 608.1748046875,
        },
        {
          __typename: 'Points',
          x: 4760,
          y: 607.903564453125,
        },
        {
          __typename: 'Points',
          x: 4780,
          y: 608.717529296875,
        },
        {
          __typename: 'Points',
          x: 4800,
          y: 607.903564453125,
        },
        {
          __typename: 'Points',
          x: 4820,
          y: 605.4619140625,
        },
        {
          __typename: 'Points',
          x: 4840,
          y: 606.27587890625,
        },
        {
          __typename: 'Points',
          x: 4860,
          y: 606.27587890625,
        },
        {
          __typename: 'Points',
          x: 4880,
          y: 6.431640625,
        },
        {
          __typename: 'Points',
          x: 4900,
          y: 5.61767578125,
        },
        {
          __typename: 'Points',
          x: 4920,
          y: -0.07958984375,
        },
        {
          __typename: 'Points',
          x: 4940,
          y: -0.07958984375,
        },
        {
          __typename: 'Points',
          x: 4960,
          y: 1.005615234375,
        },
        {
          __typename: 'Points',
          x: 4980,
          y: 1.005615234375,
        },
        {
          __typename: 'Points',
          x: 5000,
          y: 1.005615234375,
        },
        {
          __typename: 'Points',
          x: 5020,
          y: 1.8193359375,
        },
        {
          __typename: 'Points',
          x: 5040,
          y: 1.005615234375,
        },
        {
          __typename: 'Points',
          x: 5060,
          y: 1.005615234375,
        },
        {
          __typename: 'Points',
          x: 5260,
          y: 1.005615234375,
        },
        {
          __typename: 'Points',
          x: 5280,
          y: 0.191650390625,
        },
        {
          __typename: 'Points',
          x: 5300,
          y: -596.39697265625,
        },
        {
          __typename: 'Points',
          x: 5320,
          y: -1154.189697265625,
        },
        {
          __typename: 'Points',
          x: 5340,
          y: -879.905517578125,
        },
        {
          __typename: 'Points',
          x: 5360,
          y: -884.246337890625,
        },
        {
          __typename: 'Points',
          x: 5380,
          y: -901.880859375,
        },
        {
          __typename: 'Points',
          x: 5400,
          y: -821.033447265625,
        },
        {
          __typename: 'Points',
          x: 5420,
          y: -796.34521484375,
        },
        {
          __typename: 'Points',
          x: 5440,
          y: -760.533447265625,
        },
        {
          __typename: 'Points',
          x: 5460,
          y: -717.396728515625,
        },
        {
          __typename: 'Points',
          x: 5480,
          y: -698.677001953125,
        },
        {
          __typename: 'Points',
          x: 5500,
          y: -696.5068359375,
        },
        {
          __typename: 'Points',
          x: 5520,
          y: -680.228759765625,
        },
        {
          __typename: 'Points',
          x: 5540,
          y: -664.7646484375,
        },
        {
          __typename: 'Points',
          x: 5560,
          y: -647.672607421875,
        },
        {
          __typename: 'Points',
          x: 5580,
          y: -638.7197265625,
        },
        {
          __typename: 'Points',
          x: 5600,
          y: -628.953125,
        },
        {
          __typename: 'Points',
          x: 5620,
          y: -608.06298828125,
        },
        {
          __typename: 'Points',
          x: 5640,
          y: -602.908203125,
        },
        {
          __typename: 'Points',
          x: 5660,
          y: -587.1728515625,
        },
        {
          __typename: 'Points',
          x: 5680,
          y: -568.724365234375,
        },
        {
          __typename: 'Points',
          x: 5700,
          y: -555.4306640625,
        },
        {
          __typename: 'Points',
          x: 5720,
          y: -549.462158203125,
        },
        {
          __typename: 'Points',
          x: 5740,
          y: -517.44873046875,
        },
        {
          __typename: 'Points',
          x: 5760,
          y: -501.71337890625,
        },
        {
          __typename: 'Points',
          x: 5780,
          y: -480.280517578125,
        },
        {
          __typename: 'Points',
          x: 5800,
          y: -470.513916015625,
        },
        {
          __typename: 'Points',
          x: 5820,
          y: -453.964599609375,
        },
        {
          __typename: 'Points',
          x: 5840,
          y: -435.51611328125,
        },
        {
          __typename: 'Points',
          x: 5860,
          y: -420.5947265625,
        },
        {
          __typename: 'Points',
          x: 5880,
          y: -399.161865234375,
        },
        {
          __typename: 'Points',
          x: 5900,
          y: -376.64404296875,
        },
        {
          __typename: 'Points',
          x: 5920,
          y: -379.899658203125,
        },
        {
          __typename: 'Points',
          x: 5940,
          y: -349.24267578125,
        },
        {
          __typename: 'Points',
          x: 5960,
          y: -339.475830078125,
        },
        {
          __typename: 'Points',
          x: 5980,
          y: -326.18212890625,
        },
        {
          __typename: 'Points',
          x: 6000,
          y: -303.121826171875,
        },
        {
          __typename: 'Points',
          x: 6020,
          y: -286.572509765625,
        },
        {
          __typename: 'Points',
          x: 6040,
          y: -271.1083984375,
        },
        {
          __typename: 'Points',
          x: 6060,
          y: -245.87744140625,
        },
        {
          __typename: 'Points',
          x: 6080,
          y: -229.599365234375,
        },
        {
          __typename: 'Points',
          x: 6100,
          y: -213.050048828125,
        },
        {
          __typename: 'Points',
          x: 6120,
          y: -194.601806640625,
        },
        {
          __typename: 'Points',
          x: 6140,
          y: -173.711669921875,
        },
        {
          __typename: 'Points',
          x: 6160,
          y: -154.44921875,
        },
        {
          __typename: 'Points',
          x: 6180,
          y: -134.915771484375,
        },
        {
          __typename: 'Points',
          x: 6200,
          y: -117.82373046875,
        },
        {
          __typename: 'Points',
          x: 6220,
          y: -100.73193359375,
        },
        {
          __typename: 'Points',
          x: 6240,
          y: -80.65576171875,
        },
        {
          __typename: 'Points',
          x: 6260,
          y: -61.3935546875,
        },
        {
          __typename: 'Points',
          x: 6280,
          y: -45.115478515625,
        },
        {
          __typename: 'Points',
          x: 6300,
          y: -36.705078125,
        },
        {
          __typename: 'Points',
          x: 6320,
          y: -28.0234375,
        },
        {
          __typename: 'Points',
          x: 6340,
          y: -22.054931640625,
        },
        {
          __typename: 'Points',
          x: 6360,
          y: -19.61328125,
        },
        {
          __typename: 'Points',
          x: 6380,
          y: -16.08642578125,
        },
        {
          __typename: 'Points',
          x: 6400,
          y: -4.149169921875,
        },
        {
          __typename: 'Points',
          x: 6420,
          y: -9.303955078125,
        },
        {
          __typename: 'Points',
          x: 6440,
          y: -6.319580078125,
        },
        {
          __typename: 'Points',
          x: 6460,
          y: -6.319580078125,
        },
        {
          __typename: 'Points',
          x: 6480,
          y: -2.521240234375,
        },
        {
          __typename: 'Points',
          x: 6500,
          y: -1.70751953125,
        },
        {
          __typename: 'Points',
          x: 6520,
          y: -1.70751953125,
        },
        {
          __typename: 'Points',
          x: 6540,
          y: 0.462890625,
        },
        {
          __typename: 'Points',
          x: 6560,
          y: -2.521240234375,
        },
        {
          __typename: 'Points',
          x: 6580,
          y: 0.462890625,
        },
        {
          __typename: 'Points',
          x: 6600,
          y: 1.8193359375,
        },
        {
          __typename: 'Points',
          x: 6620,
          y: -4.149169921875,
        },
        {
          __typename: 'Points',
          x: 6640,
          y: -2.521240234375,
        },
        {
          __typename: 'Points',
          x: 6660,
          y: -1.70751953125,
        },
        {
          __typename: 'Points',
          x: 6680,
          y: 1.005615234375,
        },
        {
          __typename: 'Points',
          x: 6700,
          y: -2.521240234375,
        },
        {
          __typename: 'Points',
          x: 6720,
          y: 0.462890625,
        },
        {
          __typename: 'Points',
          x: 6740,
          y: -1.70751953125,
        },
        {
          __typename: 'Points',
          x: 6760,
          y: -1.164794921875,
        },
        {
          __typename: 'Points',
          x: 6780,
          y: -1.164794921875,
        },
        {
          __typename: 'Points',
          x: 6800,
          y: -2.521240234375,
        },
        {
          __typename: 'Points',
          x: 6820,
          y: -4.149169921875,
        },
        {
          __typename: 'Points',
          x: 6840,
          y: -4.149169921875,
        },
        {
          __typename: 'Points',
          x: 6860,
          y: -1.70751953125,
        },
        {
          __typename: 'Points',
          x: 6880,
          y: 0.462890625,
        },
        {
          __typename: 'Points',
          x: 6900,
          y: -5.505615234375,
        },
        {
          __typename: 'Points',
          x: 6920,
          y: -6.319580078125,
        },
        {
          __typename: 'Points',
          x: 6940,
          y: -2.521240234375,
        },
        {
          __typename: 'Points',
          x: 6960,
          y: -2.521240234375,
        },
        {
          __typename: 'Points',
          x: 6980,
          y: -3.335205078125,
        },
        {
          __typename: 'Points',
          x: 7000,
          y: -4.149169921875,
        },
        {
          __typename: 'Points',
          x: 7020,
          y: -7.133544921875,
        },
        {
          __typename: 'Points',
          x: 7040,
          y: -6.319580078125,
        },
        {
          __typename: 'Points',
          x: 7060,
          y: -4.149169921875,
        },
        {
          __typename: 'Points',
          x: 7080,
          y: -4.149169921875,
        },
        {
          __typename: 'Points',
          x: 7100,
          y: -1.70751953125,
        },
        {
          __typename: 'Points',
          x: 7120,
          y: -4.149169921875,
        },
        {
          __typename: 'Points',
          x: 7140,
          y: -4.149169921875,
        },
        {
          __typename: 'Points',
          x: 7160,
          y: -10.11767578125,
        },
        {
          __typename: 'Points',
          x: 7180,
          y: -5.505615234375,
        },
        {
          __typename: 'Points',
          x: 7200,
          y: -2.521240234375,
        },
        {
          __typename: 'Points',
          x: 7220,
          y: -4.149169921875,
        },
        {
          __typename: 'Points',
          x: 7240,
          y: -2.521240234375,
        },
        {
          __typename: 'Points',
          x: 7260,
          y: -4.149169921875,
        },
        {
          __typename: 'Points',
          x: 7280,
          y: -5.505615234375,
        },
        {
          __typename: 'Points',
          x: 7300,
          y: -7.133544921875,
        },
        {
          __typename: 'Points',
          x: 7320,
          y: -1.164794921875,
        },
        {
          __typename: 'Points',
          x: 7340,
          y: -7.133544921875,
        },
        {
          __typename: 'Points',
          x: 7360,
          y: -5.505615234375,
        },
        {
          __typename: 'Points',
          x: 7380,
          y: -5.505615234375,
        },
        {
          __typename: 'Points',
          x: 7400,
          y: -4.149169921875,
        },
        {
          __typename: 'Points',
          x: 7420,
          y: -5.505615234375,
        },
        {
          __typename: 'Points',
          x: 7440,
          y: -4.149169921875,
        },
        {
          __typename: 'Points',
          x: 7460,
          y: -7.676025390625,
        },
        {
          __typename: 'Points',
          x: 7480,
          y: -4.149169921875,
        },
        {
          __typename: 'Points',
          x: 7500,
          y: -3.335205078125,
        },
        {
          __typename: 'Points',
          x: 7520,
          y: -3.335205078125,
        },
        {
          __typename: 'Points',
          x: 7540,
          y: -2.521240234375,
        },
        {
          __typename: 'Points',
          x: 7560,
          y: -5.505615234375,
        },
        {
          __typename: 'Points',
          x: 7580,
          y: -2.521240234375,
        },
        {
          __typename: 'Points',
          x: 7600,
          y: -2.521240234375,
        },
        {
          __typename: 'Points',
          x: 7640,
          y: -2.521240234375,
        },
        {
          __typename: 'Points',
          x: 7660,
          y: -7.133544921875,
        },
        {
          __typename: 'Points',
          x: 7680,
          y: -6.319580078125,
        },
        {
          __typename: 'Points',
          x: 7700,
          y: -2.521240234375,
        },
        {
          __typename: 'Points',
          x: 7720,
          y: -1.164794921875,
        },
        {
          __typename: 'Points',
          x: 7740,
          y: -4.149169921875,
        },
        {
          __typename: 'Points',
          x: 7760,
          y: -5.505615234375,
        },
        {
          __typename: 'Points',
          x: 7780,
          y: -4.149169921875,
        },
        {
          __typename: 'Points',
          x: 7800,
          y: -2.521240234375,
        },
        {
          __typename: 'Points',
          x: 7820,
          y: -2.521240234375,
        },
        {
          __typename: 'Points',
          x: 7840,
          y: -3.335205078125,
        },
        {
          __typename: 'Points',
          x: 7860,
          y: -2.521240234375,
        },
        {
          __typename: 'Points',
          x: 7880,
          y: -2.521240234375,
        },
        {
          __typename: 'Points',
          x: 7900,
          y: -1.70751953125,
        },
        {
          __typename: 'Points',
          x: 7920,
          y: -5.505615234375,
        },
        {
          __typename: 'Points',
          x: 7940,
          y: -2.521240234375,
        },
        {
          __typename: 'Points',
          x: 7960,
          y: -3.335205078125,
        },
        {
          __typename: 'Points',
          x: 7980,
          y: 18.097412109375,
        },
        {
          __typename: 'Points',
          x: 8000,
          y: 123.090576171875,
        },
        {
          __typename: 'Points',
          x: 8020,
          y: 197.96923828125,
        },
        {
          __typename: 'Points',
          x: 8040,
          y: 271.49169921875,
        },
        {
          __typename: 'Points',
          x: 8060,
          y: 347.998291015625,
        },
        {
          __typename: 'Points',
          x: 8080,
          y: 420.70654296875,
        },
        {
          __typename: 'Points',
          x: 8100,
          y: 493.4150390625,
        },
        {
          __typename: 'Points',
          x: 8120,
          y: 566.666015625,
        },
        {
          __typename: 'Points',
          x: 8140,
          y: 649.14111328125,
        },
        {
          __typename: 'Points',
          x: 8160,
          y: 607.08984375,
        },
        {
          __typename: 'Points',
          x: 8180,
          y: 607.08984375,
        },
        {
          __typename: 'Points',
          x: 8240,
          y: 607.08984375,
        },
        {
          __typename: 'Points',
          x: 8260,
          y: 607.903564453125,
        },
        {
          __typename: 'Points',
          x: 8280,
          y: 607.08984375,
        },
        {
          __typename: 'Points',
          x: 8300,
          y: 610.61669921875,
        },
        {
          __typename: 'Points',
          x: 8320,
          y: 610.34521484375,
        },
        {
          __typename: 'Points',
          x: 8340,
          y: 611.97314453125,
        },
        {
          __typename: 'Points',
          x: 8360,
          y: 606.27587890625,
        },
        {
          __typename: 'Points',
          x: 8380,
          y: 607.08984375,
        },
        {
          __typename: 'Points',
          x: 8400,
          y: 607.08984375,
        },
        {
          __typename: 'Points',
          x: 8420,
          y: 604.64794921875,
        },
        {
          __typename: 'Points',
          x: 8440,
          y: 604.376708984375,
        },
        {
          __typename: 'Points',
          x: 8460,
          y: 607.08984375,
        },
        {
          __typename: 'Points',
          x: 8480,
          y: 606.27587890625,
        },
        {
          __typename: 'Points',
          x: 8500,
          y: 606.27587890625,
        },
        {
          __typename: 'Points',
          x: 8520,
          y: 607.903564453125,
        },
        {
          __typename: 'Points',
          x: 8540,
          y: 609.531494140625,
        },
        {
          __typename: 'Points',
          x: 8560,
          y: 607.903564453125,
        },
        {
          __typename: 'Points',
          x: 8580,
          y: 607.903564453125,
        },
        {
          __typename: 'Points',
          x: 8600,
          y: 606.27587890625,
        },
        {
          __typename: 'Points',
          x: 8620,
          y: 610.61669921875,
        },
        {
          __typename: 'Points',
          x: 8640,
          y: 608.717529296875,
        },
        {
          __typename: 'Points',
          x: 8660,
          y: 607.903564453125,
        },
        {
          __typename: 'Points',
          x: 8680,
          y: 608.1748046875,
        },
        {
          __typename: 'Points',
          x: 8700,
          y: 606.27587890625,
        },
        {
          __typename: 'Points',
          x: 8720,
          y: 607.08984375,
        },
        {
          __typename: 'Points',
          x: 8740,
          y: 607.08984375,
        },
        {
          __typename: 'Points',
          x: 8760,
          y: 607.08984375,
        },
        {
          __typename: 'Points',
          x: 8780,
          y: 606.27587890625,
        },
        {
          __typename: 'Points',
          x: 8800,
          y: 606.27587890625,
        },
        {
          __typename: 'Points',
          x: 8820,
          y: 606.27587890625,
        },
        {
          __typename: 'Points',
          x: 8840,
          y: 607.08984375,
        },
        {
          __typename: 'Points',
          x: 8860,
          y: 607.903564453125,
        },
        {
          __typename: 'Points',
          x: 8880,
          y: 6.431640625,
        },
        {
          __typename: 'Points',
          x: 8900,
          y: 5.61767578125,
        },
        {
          __typename: 'Points',
          x: 8920,
          y: -0.07958984375,
        },
        {
          __typename: 'Points',
          x: 8940,
          y: -0.07958984375,
        },
        {
          __typename: 'Points',
          x: 8960,
          y: 1.005615234375,
        },
        {
          __typename: 'Points',
          x: 8980,
          y: -0.07958984375,
        },
        {
          __typename: 'Points',
          x: 9000,
          y: 1.005615234375,
        },
        {
          __typename: 'Points',
          x: 9020,
          y: 1.8193359375,
        },
        {
          __typename: 'Points',
          x: 9040,
          y: 1.005615234375,
        },
        {
          __typename: 'Points',
          x: 9060,
          y: 1.005615234375,
        },
        {
          __typename: 'Points',
          x: 9260,
          y: 1.005615234375,
        },
        {
          __typename: 'Points',
          x: 9280,
          y: -0.622314453125,
        },
        {
          __typename: 'Points',
          x: 9300,
          y: -514.73583984375,
        },
        {
          __typename: 'Points',
          x: 9320,
          y: -1163.4140625,
        },
        {
          __typename: 'Points',
          x: 9340,
          y: -884.517578125,
        },
        {
          __typename: 'Points',
          x: 9360,
          y: -848.163330078125,
        },
        {
          __typename: 'Points',
          x: 9380,
          y: -916.80224609375,
        },
        {
          __typename: 'Points',
          x: 9400,
          y: -830.52880859375,
        },
        {
          __typename: 'Points',
          x: 9420,
          y: -807.468505859375,
        },
        {
          __typename: 'Points',
          x: 9440,
          y: -764.331787109375,
        },
        {
          __typename: 'Points',
          x: 9460,
          y: -722.009033203125,
        },
        {
          __typename: 'Points',
          x: 9480,
          y: -682.399169921875,
        },
        {
          __typename: 'Points',
          x: 9500,
          y: -684.8408203125,
        },
        {
          __typename: 'Points',
          x: 9520,
          y: -688.36767578125,
        },
        {
          __typename: 'Points',
          x: 9540,
          y: -678.058349609375,
        },
        {
          __typename: 'Points',
          x: 9560,
          y: -641.7041015625,
        },
        {
          __typename: 'Points',
          x: 9580,
          y: -648.21533203125,
        },
        {
          __typename: 'Points',
          x: 9600,
          y: -631.12353515625,
        },
        {
          __typename: 'Points',
          x: 9620,
          y: -611.861083984375,
        },
        {
          __typename: 'Points',
          x: 9640,
          y: -590.428466796875,
        },
        {
          __typename: 'Points',
          x: 9660,
          y: -582.01806640625,
        },
        {
          __typename: 'Points',
          x: 9680,
          y: -568.724365234375,
        },
        {
          __typename: 'Points',
          x: 9700,
          y: -553.802978515625,
        },
        {
          __typename: 'Points',
          x: 9720,
          y: -538.067626953125,
        },
        {
          __typename: 'Points',
          x: 9740,
          y: -519.619140625,
        },
        {
          __typename: 'Points',
          x: 9760,
          y: -501.71337890625,
        },
        {
          __typename: 'Points',
          x: 9780,
          y: -492.2177734375,
        },
        {
          __typename: 'Points',
          x: 9800,
          y: -469.1572265625,
        },
        {
          __typename: 'Points',
          x: 9820,
          y: -463.188720703125,
        },
        {
          __typename: 'Points',
          x: 9840,
          y: -428.733642578125,
        },
        {
          __typename: 'Points',
          x: 9860,
          y: -417.6103515625,
        },
        {
          __typename: 'Points',
          x: 9880,
          y: -405.673095703125,
        },
        {
          __typename: 'Points',
          x: 9900,
          y: -385.596923828125,
        },
        {
          __typename: 'Points',
          x: 9920,
          y: -365.520751953125,
        },
        {
          __typename: 'Points',
          x: 9940,
          y: -350.59912109375,
        },
        {
          __typename: 'Points',
          x: 9960,
          y: -329.98046875,
        },
        {
          __typename: 'Points',
          x: 9980,
          y: -323.197998046875,
        },
        {
          __typename: 'Points',
          x: 10000,
          y: -298.781005859375,
        },
        {
          __typename: 'Points',
          x: 10020,
          y: -287.38623046875,
        },
        {
          __typename: 'Points',
          x: 10040,
          y: -261.341552734375,
        },
        {
          __typename: 'Points',
          x: 10060,
          y: -246.69140625,
        },
        {
          __typename: 'Points',
          x: 10080,
          y: -236.924560546875,
        },
        {
          __typename: 'Points',
          x: 10100,
          y: -211.693603515625,
        },
        {
          __typename: 'Points',
          x: 10120,
          y: -189.98974609375,
        },
        {
          __typename: 'Points',
          x: 10140,
          y: -176.696044921875,
        },
        {
          __typename: 'Points',
          x: 10160,
          y: -163.130859375,
        },
        {
          __typename: 'Points',
          x: 10180,
          y: -137.357421875,
        },
        {
          __typename: 'Points',
          x: 10200,
          y: -117.010009765625,
        },
        {
          __typename: 'Points',
          x: 10220,
          y: -94.220703125,
        },
        {
          __typename: 'Points',
          x: 10240,
          y: -82.283447265625,
        },
        {
          __typename: 'Points',
          x: 10260,
          y: -59.765625,
        },
        {
          __typename: 'Points',
          x: 10280,
          y: -48.099853515625,
        },
        {
          __typename: 'Points',
          x: 10300,
          y: -31.0078125,
        },
        {
          __typename: 'Points',
          x: 10320,
          y: -25.581787109375,
        },
        {
          __typename: 'Points',
          x: 10340,
          y: -27.209716796875,
        },
        {
          __typename: 'Points',
          x: 10360,
          y: -14.45849609375,
        },
        {
          __typename: 'Points',
          x: 10380,
          y: -10.660400390625,
        },
        {
          __typename: 'Points',
          x: 10400,
          y: -15.2724609375,
        },
        {
          __typename: 'Points',
          x: 10420,
          y: -1.70751953125,
        },
        {
          __typename: 'Points',
          x: 10440,
          y: -7.133544921875,
        },
        {
          __typename: 'Points',
          x: 10460,
          y: -5.505615234375,
        },
        {
          __typename: 'Points',
          x: 10480,
          y: -1.70751953125,
        },
        {
          __typename: 'Points',
          x: 10500,
          y: -4.149169921875,
        },
        {
          __typename: 'Points',
          x: 10520,
          y: -3.335205078125,
        },
        {
          __typename: 'Points',
          x: 10540,
          y: -1.164794921875,
        },
        {
          __typename: 'Points',
          x: 10560,
          y: 0.462890625,
        },
        {
          __typename: 'Points',
          x: 10580,
          y: -2.521240234375,
        },
        {
          __typename: 'Points',
          x: 10600,
          y: -1.70751953125,
        },
        {
          __typename: 'Points',
          x: 10620,
          y: -4.149169921875,
        },
        {
          __typename: 'Points',
          x: 10640,
          y: -1.70751953125,
        },
        {
          __typename: 'Points',
          x: 10660,
          y: 1.005615234375,
        },
        {
          __typename: 'Points',
          x: 10680,
          y: 0.462890625,
        },
        {
          __typename: 'Points',
          x: 10700,
          y: 0.462890625,
        },
        {
          __typename: 'Points',
          x: 10720,
          y: -1.164794921875,
        },
        {
          __typename: 'Points',
          x: 10740,
          y: -1.70751953125,
        },
        {
          __typename: 'Points',
          x: 10760,
          y: 0.462890625,
        },
        {
          __typename: 'Points',
          x: 10780,
          y: -1.164794921875,
        },
        {
          __typename: 'Points',
          x: 10800,
          y: -4.149169921875,
        },
        {
          __typename: 'Points',
          x: 10820,
          y: -4.149169921875,
        },
        {
          __typename: 'Points',
          x: 10840,
          y: -6.319580078125,
        },
        {
          __typename: 'Points',
          x: 10860,
          y: -3.335205078125,
        },
        {
          __typename: 'Points',
          x: 10880,
          y: 0.462890625,
        },
        {
          __typename: 'Points',
          x: 10900,
          y: -2.521240234375,
        },
        {
          __typename: 'Points',
          x: 10920,
          y: -3.335205078125,
        },
        {
          __typename: 'Points',
          x: 10940,
          y: -5.505615234375,
        },
        {
          __typename: 'Points',
          x: 10960,
          y: -2.521240234375,
        },
        {
          __typename: 'Points',
          x: 10980,
          y: -4.149169921875,
        },
        {
          __typename: 'Points',
          x: 11000,
          y: -6.319580078125,
        },
        {
          __typename: 'Points',
          x: 11020,
          y: -2.521240234375,
        },
        {
          __typename: 'Points',
          x: 11040,
          y: -5.505615234375,
        },
        {
          __typename: 'Points',
          x: 11060,
          y: -1.164794921875,
        },
        {
          __typename: 'Points',
          x: 11080,
          y: -7.133544921875,
        },
        {
          __typename: 'Points',
          x: 11100,
          y: -10.11767578125,
        },
        {
          __typename: 'Points',
          x: 11120,
          y: -4.149169921875,
        },
        {
          __typename: 'Points',
          x: 11140,
          y: -1.70751953125,
        },
        {
          __typename: 'Points',
          x: 11160,
          y: -2.521240234375,
        },
        {
          __typename: 'Points',
          x: 11180,
          y: -6.319580078125,
        },
        {
          __typename: 'Points',
          x: 11200,
          y: -6.319580078125,
        },
        {
          __typename: 'Points',
          x: 11220,
          y: -6.319580078125,
        },
        {
          __typename: 'Points',
          x: 11240,
          y: -5.505615234375,
        },
        {
          __typename: 'Points',
          x: 11260,
          y: -4.149169921875,
        },
        {
          __typename: 'Points',
          x: 11280,
          y: -6.319580078125,
        },
        {
          __typename: 'Points',
          x: 11300,
          y: -7.133544921875,
        },
        {
          __typename: 'Points',
          x: 11320,
          y: -1.70751953125,
        },
        {
          __typename: 'Points',
          x: 11340,
          y: -4.149169921875,
        },
        {
          __typename: 'Points',
          x: 11360,
          y: -4.149169921875,
        },
        {
          __typename: 'Points',
          x: 11380,
          y: -1.70751953125,
        },
        {
          __typename: 'Points',
          x: 11400,
          y: -9.303955078125,
        },
        {
          __typename: 'Points',
          x: 11420,
          y: -3.335205078125,
        },
        {
          __typename: 'Points',
          x: 11440,
          y: -2.521240234375,
        },
        {
          __typename: 'Points',
          x: 11460,
          y: -7.676025390625,
        },
        {
          __typename: 'Points',
          x: 11480,
          y: -5.505615234375,
        },
        {
          __typename: 'Points',
          x: 11500,
          y: -3.335205078125,
        },
        {
          __typename: 'Points',
          x: 11520,
          y: -1.70751953125,
        },
        {
          __typename: 'Points',
          x: 11540,
          y: -4.149169921875,
        },
        {
          __typename: 'Points',
          x: 11560,
          y: -4.149169921875,
        },
        {
          __typename: 'Points',
          x: 11580,
          y: -4.42041015625,
        },
        {
          __typename: 'Points',
          x: 11600,
          y: -3.335205078125,
        },
        {
          __typename: 'Points',
          x: 11620,
          y: -5.505615234375,
        },
        {
          __typename: 'Points',
          x: 11640,
          y: -4.149169921875,
        },
        {
          __typename: 'Points',
          x: 11660,
          y: -4.149169921875,
        },
        {
          __typename: 'Points',
          x: 11680,
          y: -3.335205078125,
        },
        {
          __typename: 'Points',
          x: 11700,
          y: -6.319580078125,
        },
        {
          __typename: 'Points',
          x: 11720,
          y: -1.70751953125,
        },
        {
          __typename: 'Points',
          x: 11740,
          y: -6.319580078125,
        },
        {
          __typename: 'Points',
          x: 11760,
          y: -7.133544921875,
        },
        {
          __typename: 'Points',
          x: 11780,
          y: -4.149169921875,
        },
        {
          __typename: 'Points',
          x: 11800,
          y: -3.335205078125,
        },
        {
          __typename: 'Points',
          x: 11820,
          y: -6.319580078125,
        },
        {
          __typename: 'Points',
          x: 11840,
          y: -2.521240234375,
        },
        {
          __typename: 'Points',
          x: 11860,
          y: -1.70751953125,
        },
        {
          __typename: 'Points',
          x: 11880,
          y: -4.149169921875,
        },
        {
          __typename: 'Points',
          x: 11900,
          y: -3.335205078125,
        },
        {
          __typename: 'Points',
          x: 11920,
          y: -5.505615234375,
        },
        {
          __typename: 'Points',
          x: 11940,
          y: -5.505615234375,
        },
        {
          __typename: 'Points',
          x: 11960,
          y: -7.133544921875,
        },
        {
          __typename: 'Points',
          x: 11980,
          y: 8.33056640625,
        },
        {
          __typename: 'Points',
          x: 12000,
          y: 113.866455078125,
        },
        {
          __typename: 'Points',
          x: 12020,
          y: 189.830322265625,
        },
        {
          __typename: 'Points',
          x: 12040,
          y: 264.709228515625,
        },
        {
          __typename: 'Points',
          x: 12060,
          y: 339.04541015625,
        },
        {
          __typename: 'Points',
          x: 12080,
          y: 415.00927734375,
        },
        {
          __typename: 'Points',
          x: 12100,
          y: 486.632568359375,
        },
        {
          __typename: 'Points',
          x: 12120,
          y: 561.78271484375,
        },
        {
          __typename: 'Points',
          x: 12140,
          y: 632.04931640625,
        },
        {
          __typename: 'Points',
          x: 12160,
          y: 606.27587890625,
        },
        {
          __typename: 'Points',
          x: 12180,
          y: 606.27587890625,
        },
        {
          __typename: 'Points',
          x: 12200,
          y: 608.1748046875,
        },
        {
          __typename: 'Points',
          x: 12220,
          y: 612.244384765625,
        },
        {
          __typename: 'Points',
          x: 12240,
          y: 606.27587890625,
        },
        {
          __typename: 'Points',
          x: 12260,
          y: 611.97314453125,
        },
        {
          __typename: 'Points',
          x: 12280,
          y: 609.802734375,
        },
        {
          __typename: 'Points',
          x: 12300,
          y: 607.08984375,
        },
        {
          __typename: 'Points',
          x: 12320,
          y: 606.27587890625,
        },
        {
          __typename: 'Points',
          x: 12340,
          y: 605.733154296875,
        },
        {
          __typename: 'Points',
          x: 12360,
          y: 608.717529296875,
        },
        {
          __typename: 'Points',
          x: 12380,
          y: 606.27587890625,
        },
        {
          __typename: 'Points',
          x: 12400,
          y: 605.4619140625,
        },
        {
          __typename: 'Points',
          x: 12420,
          y: 605.4619140625,
        },
        {
          __typename: 'Points',
          x: 12440,
          y: 606.27587890625,
        },
        {
          __typename: 'Points',
          x: 12460,
          y: 608.1748046875,
        },
        {
          __typename: 'Points',
          x: 12480,
          y: 607.08984375,
        },
        {
          __typename: 'Points',
          x: 12500,
          y: 606.27587890625,
        },
        {
          __typename: 'Points',
          x: 12520,
          y: 607.903564453125,
        },
        {
          __typename: 'Points',
          x: 12540,
          y: 607.08984375,
        },
        {
          __typename: 'Points',
          x: 12560,
          y: 607.08984375,
        },
        {
          __typename: 'Points',
          x: 12580,
          y: 607.08984375,
        },
        {
          __typename: 'Points',
          x: 12600,
          y: 608.717529296875,
        },
        {
          __typename: 'Points',
          x: 12620,
          y: 605.4619140625,
        },
        {
          __typename: 'Points',
          x: 12640,
          y: 607.08984375,
        },
        {
          __typename: 'Points',
          x: 12660,
          y: 607.08984375,
        },
        {
          __typename: 'Points',
          x: 12680,
          y: 604.64794921875,
        },
        {
          __typename: 'Points',
          x: 12700,
          y: 605.733154296875,
        },
        {
          __typename: 'Points',
          x: 12720,
          y: 605.733154296875,
        },
        {
          __typename: 'Points',
          x: 12740,
          y: 607.08984375,
        },
        {
          __typename: 'Points',
          x: 12760,
          y: 608.717529296875,
        },
        {
          __typename: 'Points',
          x: 12780,
          y: 606.27587890625,
        },
        {
          __typename: 'Points',
          x: 12800,
          y: 605.4619140625,
        },
        {
          __typename: 'Points',
          x: 12820,
          y: 607.08984375,
        },
        {
          __typename: 'Points',
          x: 12840,
          y: 608.717529296875,
        },
        {
          __typename: 'Points',
          x: 12860,
          y: 608.717529296875,
        },
        {
          __typename: 'Points',
          x: 12880,
          y: 9.14453125,
        },
        {
          __typename: 'Points',
          x: 12900,
          y: 5.61767578125,
        },
        {
          __typename: 'Points',
          x: 12920,
          y: -0.07958984375,
        },
        {
          __typename: 'Points',
          x: 12940,
          y: -0.07958984375,
        },
        {
          __typename: 'Points',
          x: 12960,
          y: 1.005615234375,
        },
        {
          __typename: 'Points',
          x: 12980,
          y: 1.005615234375,
        },
        {
          __typename: 'Points',
          x: 13260,
          y: 1.005615234375,
        },
        {
          __typename: 'Points',
          x: 13280,
          y: -1.978759765625,
        },
        {
          __typename: 'Points',
          x: 13300,
          y: -380.713623046875,
        },
        {
          __typename: 'Points',
          x: 13320,
          y: -1172.909423828125,
        },
        {
          __typename: 'Points',
          x: 13340,
          y: -904.322509765625,
        },
        {
          __typename: 'Points',
          x: 13360,
          y: -886.1455078125,
        },
        {
          __typename: 'Points',
          x: 13380,
          y: -942.033203125,
        },
        {
          __typename: 'Points',
          x: 13400,
          y: -825.374267578125,
        },
        {
          __typename: 'Points',
          x: 13420,
          y: -813.43701171875,
        },
        {
          __typename: 'Points',
          x: 13440,
          y: -765.1455078125,
        },
        {
          __typename: 'Points',
          x: 13460,
          y: -727.16357421875,
        },
        {
          __typename: 'Points',
          x: 13480,
          y: -689.181640625,
        },
        {
          __typename: 'Points',
          x: 13500,
          y: -693.793701171875,
        },
        {
          __typename: 'Points',
          x: 13520,
          y: -688.36767578125,
        },
        {
          __typename: 'Points',
          x: 13540,
          y: -672.089599609375,
        },
        {
          __typename: 'Points',
          x: 13560,
          y: -654.997802734375,
        },
        {
          __typename: 'Points',
          x: 13580,
          y: -643.87451171875,
        },
        {
          __typename: 'Points',
          x: 13600,
          y: -631.12353515625,
        },
        {
          __typename: 'Points',
          x: 13620,
          y: -615.659423828125,
        },
        {
          __typename: 'Points',
          x: 13640,
          y: -602.09423828125,
        },
        {
          __typename: 'Points',
          x: 13660,
          y: -579.30517578125,
        },
        {
          __typename: 'Points',
          x: 13680,
          y: -570.894775390625,
        },
        {
          __typename: 'Points',
          x: 13700,
          y: -550.004638671875,
        },
        {
          __typename: 'Points',
          x: 13720,
          y: -534.54052734375,
        },
        {
          __typename: 'Points',
          x: 13740,
          y: -520.43310546875,
        },
        {
          __typename: 'Points',
          x: 13760,
          y: -505.511474609375,
        },
        {
          __typename: 'Points',
          x: 13780,
          y: -488.419677734375,
        },
        {
          __typename: 'Points',
          x: 13800,
          y: -469.1572265625,
        },
        {
          __typename: 'Points',
          x: 13820,
          y: -455.59228515625,
        },
        {
          __typename: 'Points',
          x: 13840,
          y: -438.50048828125,
        },
        {
          __typename: 'Points',
          x: 13860,
          y: -417.6103515625,
        },
        {
          __typename: 'Points',
          x: 13880,
          y: -404.316650390625,
        },
        {
          __typename: 'Points',
          x: 13900,
          y: -389.39501953125,
        },
        {
          __typename: 'Points',
          x: 13920,
          y: -369.31884765625,
        },
        {
          __typename: 'Points',
          x: 13940,
          y: -355.21142578125,
        },
        {
          __typename: 'Points',
          x: 13960,
          y: -337.305419921875,
        },
        {
          __typename: 'Points',
          x: 13980,
          y: -320.213623046875,
        },
        {
          __typename: 'Points',
          x: 14000,
          y: -298.781005859375,
        },
        {
          __typename: 'Points',
          x: 14020,
          y: -286.02978515625,
        },
        {
          __typename: 'Points',
          x: 14040,
          y: -266.767578125,
        },
        {
          __typename: 'Points',
          x: 14060,
          y: -252.388671875,
        },
        {
          __typename: 'Points',
          x: 14080,
          y: -233.940185546875,
        },
        {
          __typename: 'Points',
          x: 14100,
          y: -217.662353515625,
        },
        {
          __typename: 'Points',
          x: 14120,
          y: -192.973876953125,
        },
        {
          __typename: 'Points',
          x: 14140,
          y: -175.882080078125,
        },
        {
          __typename: 'Points',
          x: 14160,
          y: -160.41796875,
        },
        {
          __typename: 'Points',
          x: 14180,
          y: -140.88427734375,
        },
        {
          __typename: 'Points',
          x: 14200,
          y: -121.6220703125,
        },
        {
          __typename: 'Points',
          x: 14220,
          y: -108.328369140625,
        },
        {
          __typename: 'Points',
          x: 14240,
          y: -81.4697265625,
        },
        {
          __typename: 'Points',
          x: 14260,
          y: -59.765625,
        },
        {
          __typename: 'Points',
          x: 14280,
          y: -50.270263671875,
        },
        {
          __typename: 'Points',
          x: 14300,
          y: -34.53466796875,
        },
        {
          __typename: 'Points',
          x: 14320,
          y: -38.3330078125,
        },
        {
          __typename: 'Points',
          x: 14340,
          y: -17.44287109375,
        },
        {
          __typename: 'Points',
          x: 14360,
          y: -13.916015625,
        },
        {
          __typename: 'Points',
          x: 14380,
          y: -22.054931640625,
        },
        {
          __typename: 'Points',
          x: 14400,
          y: -7.133544921875,
        },
        {
          __typename: 'Points',
          x: 14420,
          y: -9.303955078125,
        },
        {
          __typename: 'Points',
          x: 14440,
          y: -6.319580078125,
        },
        {
          __typename: 'Points',
          x: 14460,
          y: -9.303955078125,
        },
        {
          __typename: 'Points',
          x: 14480,
          y: -3.335205078125,
        },
        {
          __typename: 'Points',
          x: 14500,
          y: -3.335205078125,
        },
        {
          __typename: 'Points',
          x: 14520,
          y: -1.164794921875,
        },
        {
          __typename: 'Points',
          x: 14540,
          y: 1.005615234375,
        },
        {
          __typename: 'Points',
          x: 14560,
          y: -1.70751953125,
        },
        {
          __typename: 'Points',
          x: 14580,
          y: -4.149169921875,
        },
        {
          __typename: 'Points',
          x: 14600,
          y: 2.63330078125,
        },
        {
          __typename: 'Points',
          x: 14620,
          y: 1.005615234375,
        },
        {
          __typename: 'Points',
          x: 14640,
          y: -2.521240234375,
        },
        {
          __typename: 'Points',
          x: 14660,
          y: -2.521240234375,
        },
        {
          __typename: 'Points',
          x: 14680,
          y: 0.462890625,
        },
        {
          __typename: 'Points',
          x: 14700,
          y: -2.521240234375,
        },
        {
          __typename: 'Points',
          x: 14720,
          y: 0.462890625,
        },
        {
          __typename: 'Points',
          x: 14740,
          y: 0.462890625,
        },
        {
          __typename: 'Points',
          x: 14760,
          y: 1.8193359375,
        },
        {
          __typename: 'Points',
          x: 14780,
          y: -1.70751953125,
        },
        {
          __typename: 'Points',
          x: 14800,
          y: -4.149169921875,
        },
        {
          __typename: 'Points',
          x: 14820,
          y: -1.70751953125,
        },
        {
          __typename: 'Points',
          x: 14840,
          y: -2.521240234375,
        },
        {
          __typename: 'Points',
          x: 14860,
          y: -1.164794921875,
        },
        {
          __typename: 'Points',
          x: 14880,
          y: -3.335205078125,
        },
        {
          __typename: 'Points',
          x: 14900,
          y: -3.335205078125,
        },
        {
          __typename: 'Points',
          x: 14920,
          y: -5.505615234375,
        },
        {
          __typename: 'Points',
          x: 14940,
          y: -4.149169921875,
        },
        {
          __typename: 'Points',
          x: 14960,
          y: -1.164794921875,
        },
        {
          __typename: 'Points',
          x: 14980,
          y: -4.149169921875,
        },
        {
          __typename: 'Points',
          x: 15000,
          y: -7.676025390625,
        },
        {
          __typename: 'Points',
          x: 15020,
          y: -2.521240234375,
        },
        {
          __typename: 'Points',
          x: 15040,
          y: -3.335205078125,
        },
        {
          __typename: 'Points',
          x: 15060,
          y: -4.149169921875,
        },
        {
          __typename: 'Points',
          x: 15080,
          y: -4.149169921875,
        },
        {
          __typename: 'Points',
          x: 15100,
          y: -3.335205078125,
        },
        {
          __typename: 'Points',
          x: 15120,
          y: -1.70751953125,
        },
        {
          __typename: 'Points',
          x: 15140,
          y: -4.149169921875,
        },
        {
          __typename: 'Points',
          x: 15160,
          y: -3.335205078125,
        },
        {
          __typename: 'Points',
          x: 15180,
          y: -5.505615234375,
        },
        {
          __typename: 'Points',
          x: 15200,
          y: -5.505615234375,
        },
        {
          __typename: 'Points',
          x: 15220,
          y: -7.133544921875,
        },
        {
          __typename: 'Points',
          x: 15240,
          y: -1.70751953125,
        },
        {
          __typename: 'Points',
          x: 15260,
          y: -7.133544921875,
        },
        {
          __typename: 'Points',
          x: 15280,
          y: -2.521240234375,
        },
        {
          __typename: 'Points',
          x: 15300,
          y: -1.164794921875,
        },
        {
          __typename: 'Points',
          x: 15320,
          y: -7.133544921875,
        },
        {
          __typename: 'Points',
          x: 15340,
          y: -3.335205078125,
        },
        {
          __typename: 'Points',
          x: 15360,
          y: -1.70751953125,
        },
        {
          __typename: 'Points',
          x: 15380,
          y: -2.521240234375,
        },
        {
          __typename: 'Points',
          x: 15400,
          y: -6.319580078125,
        },
        {
          __typename: 'Points',
          x: 15420,
          y: -1.70751953125,
        },
        {
          __typename: 'Points',
          x: 15440,
          y: -1.70751953125,
        },
        {
          __typename: 'Points',
          x: 15460,
          y: -3.335205078125,
        },
        {
          __typename: 'Points',
          x: 15480,
          y: -5.505615234375,
        },
        {
          __typename: 'Points',
          x: 15500,
          y: -5.505615234375,
        },
        {
          __typename: 'Points',
          x: 15520,
          y: -5.505615234375,
        },
        {
          __typename: 'Points',
          x: 15540,
          y: -3.335205078125,
        },
        {
          __typename: 'Points',
          x: 15560,
          y: -3.335205078125,
        },
        {
          __typename: 'Points',
          x: 15580,
          y: -2.521240234375,
        },
        {
          __typename: 'Points',
          x: 15600,
          y: -5.505615234375,
        },
        {
          __typename: 'Points',
          x: 15620,
          y: -1.164794921875,
        },
        {
          __typename: 'Points',
          x: 15640,
          y: -4.149169921875,
        },
        {
          __typename: 'Points',
          x: 15660,
          y: -4.149169921875,
        },
        {
          __typename: 'Points',
          x: 15680,
          y: -2.521240234375,
        },
        {
          __typename: 'Points',
          x: 15700,
          y: -3.335205078125,
        },
        {
          __typename: 'Points',
          x: 15720,
          y: -1.164794921875,
        },
        {
          __typename: 'Points',
          x: 15740,
          y: -6.319580078125,
        },
        {
          __typename: 'Points',
          x: 15760,
          y: -3.335205078125,
        },
        {
          __typename: 'Points',
          x: 15780,
          y: -5.505615234375,
        },
        {
          __typename: 'Points',
          x: 15800,
          y: -3.335205078125,
        },
        {
          __typename: 'Points',
          x: 15820,
          y: -4.149169921875,
        },
        {
          __typename: 'Points',
          x: 15840,
          y: -2.521240234375,
        },
        {
          __typename: 'Points',
          x: 15860,
          y: -5.505615234375,
        },
        {
          __typename: 'Points',
          x: 15880,
          y: -2.521240234375,
        },
        {
          __typename: 'Points',
          x: 15900,
          y: -5.505615234375,
        },
        {
          __typename: 'Points',
          x: 15920,
          y: -2.521240234375,
        },
        {
          __typename: 'Points',
          x: 15940,
          y: -3.335205078125,
        },
        {
          __typename: 'Points',
          x: 15960,
          y: -2.521240234375,
        },
        {
          __typename: 'Points',
          x: 15980,
          y: 3.718505859375,
        },
        {
          __typename: 'Points',
          x: 16000,
          y: 3.718505859375,
        },
      ],
      airVolumeWave: [
        {
          __typename: 'Points',
          x: 0,
          y: 3.200000047683716,
        },
        {
          __typename: 'Points',
          x: 20,
          y: 6.800000190734863,
        },
        {
          __typename: 'Points',
          x: 40,
          y: 12.40000057220459,
        },
        {
          __typename: 'Points',
          x: 60,
          y: 19.200000762939453,
        },
        {
          __typename: 'Points',
          x: 80,
          y: 27.600000381469727,
        },
        {
          __typename: 'Points',
          x: 100,
          y: 37.60000228881836,
        },
        {
          __typename: 'Points',
          x: 120,
          y: 48.79999923706055,
        },
        {
          __typename: 'Points',
          x: 140,
          y: 61.20000076293945,
        },
        {
          __typename: 'Points',
          x: 160,
          y: 73.20000457763672,
        },
        {
          __typename: 'Points',
          x: 180,
          y: 85.5999984741211,
        },
        {
          __typename: 'Points',
          x: 200,
          y: 97.5999984741211,
        },
        {
          __typename: 'Points',
          x: 220,
          y: 110,
        },
        {
          __typename: 'Points',
          x: 240,
          y: 122,
        },
        {
          __typename: 'Points',
          x: 260,
          y: 134,
        },
        {
          __typename: 'Points',
          x: 280,
          y: 146.40000915527344,
        },
        {
          __typename: 'Points',
          x: 300,
          y: 158.40000915527344,
        },
        {
          __typename: 'Points',
          x: 320,
          y: 170.40000915527344,
        },
        {
          __typename: 'Points',
          x: 340,
          y: 182.8000030517578,
        },
        {
          __typename: 'Points',
          x: 360,
          y: 194.8000030517578,
        },
        {
          __typename: 'Points',
          x: 380,
          y: 206.8000030517578,
        },
        {
          __typename: 'Points',
          x: 400,
          y: 219.1999969482422,
        },
        {
          __typename: 'Points',
          x: 420,
          y: 231.1999969482422,
        },
        {
          __typename: 'Points',
          x: 440,
          y: 243.1999969482422,
        },
        {
          __typename: 'Points',
          x: 460,
          y: 255.60000610351562,
        },
        {
          __typename: 'Points',
          x: 480,
          y: 267.6000061035156,
        },
        {
          __typename: 'Points',
          x: 500,
          y: 279.6000061035156,
        },
        {
          __typename: 'Points',
          x: 520,
          y: 292,
        },
        {
          __typename: 'Points',
          x: 540,
          y: 304,
        },
        {
          __typename: 'Points',
          x: 560,
          y: 316,
        },
        {
          __typename: 'Points',
          x: 580,
          y: 328.3999938964844,
        },
        {
          __typename: 'Points',
          x: 600,
          y: 340.3999938964844,
        },
        {
          __typename: 'Points',
          x: 620,
          y: 352.3999938964844,
        },
        {
          __typename: 'Points',
          x: 640,
          y: 364.8000183105469,
        },
        {
          __typename: 'Points',
          x: 660,
          y: 376.8000183105469,
        },
        {
          __typename: 'Points',
          x: 680,
          y: 389.20001220703125,
        },
        {
          __typename: 'Points',
          x: 700,
          y: 401.20001220703125,
        },
        {
          __typename: 'Points',
          x: 720,
          y: 413.20001220703125,
        },
        {
          __typename: 'Points',
          x: 740,
          y: 425.6000061035156,
        },
        {
          __typename: 'Points',
          x: 760,
          y: 437.6000061035156,
        },
        {
          __typename: 'Points',
          x: 780,
          y: 449.6000061035156,
        },
        {
          __typename: 'Points',
          x: 800,
          y: 462,
        },
        {
          __typename: 'Points',
          x: 820,
          y: 474,
        },
        {
          __typename: 'Points',
          x: 840,
          y: 486.3999938964844,
        },
        {
          __typename: 'Points',
          x: 860,
          y: 498,
        },
        {
          __typename: 'Points',
          x: 880,
          y: 498.3999938964844,
        },
        {
          __typename: 'Points',
          x: 900,
          y: 498.3999938964844,
        },
        {
          __typename: 'Points',
          x: 1080,
          y: 498.3999938964844,
        },
        {
          __typename: 'Points',
          x: 1100,
          y: 498.8000183105469,
        },
        {
          __typename: 'Points',
          x: 1120,
          y: 498.8000183105469,
        },
        {
          __typename: 'Points',
          x: 1280,
          y: 498.8000183105469,
        },
        {
          __typename: 'Points',
          x: 1300,
          y: 488.8000183105469,
        },
        {
          __typename: 'Points',
          x: 1320,
          y: 466,
        },
        {
          __typename: 'Points',
          x: 1340,
          y: 448.8000183105469,
        },
        {
          __typename: 'Points',
          x: 1360,
          y: 431.6000061035156,
        },
        {
          __typename: 'Points',
          x: 1380,
          y: 413.20001220703125,
        },
        {
          __typename: 'Points',
          x: 1400,
          y: 396.8000183105469,
        },
        {
          __typename: 'Points',
          x: 1420,
          y: 381.20001220703125,
        },
        {
          __typename: 'Points',
          x: 1440,
          y: 366,
        },
        {
          __typename: 'Points',
          x: 1460,
          y: 351.6000061035156,
        },
        {
          __typename: 'Points',
          x: 1480,
          y: 338,
        },
        {
          __typename: 'Points',
          x: 1500,
          y: 324.3999938964844,
        },
        {
          __typename: 'Points',
          x: 1520,
          y: 310.8000183105469,
        },
        {
          __typename: 'Points',
          x: 1540,
          y: 297.6000061035156,
        },
        {
          __typename: 'Points',
          x: 1560,
          y: 284.8000183105469,
        },
        {
          __typename: 'Points',
          x: 1580,
          y: 272,
        },
        {
          __typename: 'Points',
          x: 1600,
          y: 259.6000061035156,
        },
        {
          __typename: 'Points',
          x: 1620,
          y: 247.60000610351562,
        },
        {
          __typename: 'Points',
          x: 1640,
          y: 235.60000610351562,
        },
        {
          __typename: 'Points',
          x: 1660,
          y: 224.40000915527344,
        },
        {
          __typename: 'Points',
          x: 1680,
          y: 213.1999969482422,
        },
        {
          __typename: 'Points',
          x: 1700,
          y: 202.40000915527344,
        },
        {
          __typename: 'Points',
          x: 1720,
          y: 191.60000610351562,
        },
        {
          __typename: 'Points',
          x: 1740,
          y: 181.1999969482422,
        },
        {
          __typename: 'Points',
          x: 1760,
          y: 171.60000610351562,
        },
        {
          __typename: 'Points',
          x: 1780,
          y: 162,
        },
        {
          __typename: 'Points',
          x: 1800,
          y: 152.40000915527344,
        },
        {
          __typename: 'Points',
          x: 1820,
          y: 143.60000610351562,
        },
        {
          __typename: 'Points',
          x: 1840,
          y: 134.8000030517578,
        },
        {
          __typename: 'Points',
          x: 1860,
          y: 126.80000305175781,
        },
        {
          __typename: 'Points',
          x: 1880,
          y: 118.80000305175781,
        },
        {
          __typename: 'Points',
          x: 1900,
          y: 111.20000457763672,
        },
        {
          __typename: 'Points',
          x: 1920,
          y: 103.5999984741211,
        },
        {
          __typename: 'Points',
          x: 1940,
          y: 96.80000305175781,
        },
        {
          __typename: 'Points',
          x: 1960,
          y: 89.5999984741211,
        },
        {
          __typename: 'Points',
          x: 1980,
          y: 83.20000457763672,
        },
        {
          __typename: 'Points',
          x: 2000,
          y: 77.5999984741211,
        },
        {
          __typename: 'Points',
          x: 2020,
          y: 71.5999984741211,
        },
        {
          __typename: 'Points',
          x: 2040,
          y: 66.4000015258789,
        },
        {
          __typename: 'Points',
          x: 2060,
          y: 61.60000228881836,
        },
        {
          __typename: 'Points',
          x: 2080,
          y: 57.20000076293945,
        },
        {
          __typename: 'Points',
          x: 2100,
          y: 52.79999923706055,
        },
        {
          __typename: 'Points',
          x: 2120,
          y: 49.20000076293945,
        },
        {
          __typename: 'Points',
          x: 2140,
          y: 45.60000228881836,
        },
        {
          __typename: 'Points',
          x: 2160,
          y: 42.79999923706055,
        },
        {
          __typename: 'Points',
          x: 2180,
          y: 40,
        },
        {
          __typename: 'Points',
          x: 2200,
          y: 37.60000228881836,
        },
        {
          __typename: 'Points',
          x: 2220,
          y: 35.60000228881836,
        },
        {
          __typename: 'Points',
          x: 2240,
          y: 34,
        },
        {
          __typename: 'Points',
          x: 2260,
          y: 32.79999923706055,
        },
        {
          __typename: 'Points',
          x: 2280,
          y: 32,
        },
        {
          __typename: 'Points',
          x: 2300,
          y: 31.200000762939453,
        },
        {
          __typename: 'Points',
          x: 2320,
          y: 30.80000114440918,
        },
        {
          __typename: 'Points',
          x: 2340,
          y: 30,
        },
        {
          __typename: 'Points',
          x: 2360,
          y: 30,
        },
        {
          __typename: 'Points',
          x: 2380,
          y: 29.600000381469727,
        },
        {
          __typename: 'Points',
          x: 2400,
          y: 29.200000762939453,
        },
        {
          __typename: 'Points',
          x: 2420,
          y: 29.200000762939453,
        },
        {
          __typename: 'Points',
          x: 2460,
          y: 29.200000762939453,
        },
        {
          __typename: 'Points',
          x: 2480,
          y: 28.80000114440918,
        },
        {
          __typename: 'Points',
          x: 2500,
          y: 28.80000114440918,
        },
        {
          __typename: 'Points',
          x: 2800,
          y: 28.80000114440918,
        },
        {
          __typename: 'Points',
          x: 2820,
          y: 28.399999618530273,
        },
        {
          __typename: 'Points',
          x: 2840,
          y: 28.399999618530273,
        },
        {
          __typename: 'Points',
          x: 2940,
          y: 28.399999618530273,
        },
        {
          __typename: 'Points',
          x: 2960,
          y: 28,
        },
        {
          __typename: 'Points',
          x: 2980,
          y: 28,
        },
        {
          __typename: 'Points',
          x: 3040,
          y: 28,
        },
        {
          __typename: 'Points',
          x: 3060,
          y: 27.600000381469727,
        },
        {
          __typename: 'Points',
          x: 3080,
          y: 27.600000381469727,
        },
        {
          __typename: 'Points',
          x: 3120,
          y: 27.600000381469727,
        },
        {
          __typename: 'Points',
          x: 3140,
          y: 27.200000762939453,
        },
        {
          __typename: 'Points',
          x: 3160,
          y: 27.200000762939453,
        },
        {
          __typename: 'Points',
          x: 3200,
          y: 27.200000762939453,
        },
        {
          __typename: 'Points',
          x: 3220,
          y: 26.80000114440918,
        },
        {
          __typename: 'Points',
          x: 3240,
          y: 26.80000114440918,
        },
        {
          __typename: 'Points',
          x: 3280,
          y: 26.80000114440918,
        },
        {
          __typename: 'Points',
          x: 3300,
          y: 26.399999618530273,
        },
        {
          __typename: 'Points',
          x: 3320,
          y: 26.399999618530273,
        },
        {
          __typename: 'Points',
          x: 3340,
          y: 26.399999618530273,
        },
        {
          __typename: 'Points',
          x: 3360,
          y: 26,
        },
        {
          __typename: 'Points',
          x: 3380,
          y: 26,
        },
        {
          __typename: 'Points',
          x: 3440,
          y: 26,
        },
        {
          __typename: 'Points',
          x: 3460,
          y: 25.600000381469727,
        },
        {
          __typename: 'Points',
          x: 3480,
          y: 25.600000381469727,
        },
        {
          __typename: 'Points',
          x: 3500,
          y: 25.600000381469727,
        },
        {
          __typename: 'Points',
          x: 3520,
          y: 25.200000762939453,
        },
        {
          __typename: 'Points',
          x: 3540,
          y: 25.200000762939453,
        },
        {
          __typename: 'Points',
          x: 3580,
          y: 25.200000762939453,
        },
        {
          __typename: 'Points',
          x: 3600,
          y: 24.80000114440918,
        },
        {
          __typename: 'Points',
          x: 3620,
          y: 24.80000114440918,
        },
        {
          __typename: 'Points',
          x: 3680,
          y: 24.80000114440918,
        },
        {
          __typename: 'Points',
          x: 3700,
          y: 24.399999618530273,
        },
        {
          __typename: 'Points',
          x: 3720,
          y: 24.399999618530273,
        },
        {
          __typename: 'Points',
          x: 3760,
          y: 24.399999618530273,
        },
        {
          __typename: 'Points',
          x: 3780,
          y: 24,
        },
        {
          __typename: 'Points',
          x: 3800,
          y: 24,
        },
        {
          __typename: 'Points',
          x: 3840,
          y: 24,
        },
        {
          __typename: 'Points',
          x: 3860,
          y: 23.600000381469727,
        },
        {
          __typename: 'Points',
          x: 3880,
          y: 23.600000381469727,
        },
        {
          __typename: 'Points',
          x: 3980,
          y: 23.600000381469727,
        },
        {
          __typename: 'Points',
          x: 4000,
          y: 2.4000000953674316,
        },
        {
          __typename: 'Points',
          x: 4020,
          y: 6,
        },
        {
          __typename: 'Points',
          x: 4040,
          y: 11.199999809265137,
        },
        {
          __typename: 'Points',
          x: 4060,
          y: 18,
        },
        {
          __typename: 'Points',
          x: 4080,
          y: 26,
        },
        {
          __typename: 'Points',
          x: 4100,
          y: 35.60000228881836,
        },
        {
          __typename: 'Points',
          x: 4120,
          y: 46.79999923706055,
        },
        {
          __typename: 'Points',
          x: 4140,
          y: 59.20000076293945,
        },
        {
          __typename: 'Points',
          x: 4160,
          y: 71.20000457763672,
        },
        {
          __typename: 'Points',
          x: 4180,
          y: 83.5999984741211,
        },
        {
          __typename: 'Points',
          x: 4200,
          y: 95.5999984741211,
        },
        {
          __typename: 'Points',
          x: 4220,
          y: 108,
        },
        {
          __typename: 'Points',
          x: 4240,
          y: 120,
        },
        {
          __typename: 'Points',
          x: 4260,
          y: 132,
        },
        {
          __typename: 'Points',
          x: 4280,
          y: 144.40000915527344,
        },
        {
          __typename: 'Points',
          x: 4300,
          y: 156.40000915527344,
        },
        {
          __typename: 'Points',
          x: 4320,
          y: 168.8000030517578,
        },
        {
          __typename: 'Points',
          x: 4340,
          y: 180.8000030517578,
        },
        {
          __typename: 'Points',
          x: 4360,
          y: 192.8000030517578,
        },
        {
          __typename: 'Points',
          x: 4380,
          y: 205.1999969482422,
        },
        {
          __typename: 'Points',
          x: 4400,
          y: 217.1999969482422,
        },
        {
          __typename: 'Points',
          x: 4420,
          y: 229.60000610351562,
        },
        {
          __typename: 'Points',
          x: 4440,
          y: 241.60000610351562,
        },
        {
          __typename: 'Points',
          x: 4460,
          y: 253.60000610351562,
        },
        {
          __typename: 'Points',
          x: 4480,
          y: 266,
        },
        {
          __typename: 'Points',
          x: 4500,
          y: 278,
        },
        {
          __typename: 'Points',
          x: 4520,
          y: 290,
        },
        {
          __typename: 'Points',
          x: 4540,
          y: 302.3999938964844,
        },
        {
          __typename: 'Points',
          x: 4560,
          y: 314.3999938964844,
        },
        {
          __typename: 'Points',
          x: 4580,
          y: 326.8000183105469,
        },
        {
          __typename: 'Points',
          x: 4600,
          y: 338.8000183105469,
        },
        {
          __typename: 'Points',
          x: 4620,
          y: 350.8000183105469,
        },
        {
          __typename: 'Points',
          x: 4640,
          y: 363.20001220703125,
        },
        {
          __typename: 'Points',
          x: 4660,
          y: 375.20001220703125,
        },
        {
          __typename: 'Points',
          x: 4680,
          y: 387.6000061035156,
        },
        {
          __typename: 'Points',
          x: 4700,
          y: 399.6000061035156,
        },
        {
          __typename: 'Points',
          x: 4720,
          y: 411.6000061035156,
        },
        {
          __typename: 'Points',
          x: 4740,
          y: 424,
        },
        {
          __typename: 'Points',
          x: 4760,
          y: 436,
        },
        {
          __typename: 'Points',
          x: 4780,
          y: 448,
        },
        {
          __typename: 'Points',
          x: 4800,
          y: 460.3999938964844,
        },
        {
          __typename: 'Points',
          x: 4820,
          y: 472.3999938964844,
        },
        {
          __typename: 'Points',
          x: 4840,
          y: 484.3999938964844,
        },
        {
          __typename: 'Points',
          x: 4860,
          y: 496.8000183105469,
        },
        {
          __typename: 'Points',
          x: 4880,
          y: 498.8000183105469,
        },
        {
          __typename: 'Points',
          x: 4900,
          y: 498.8000183105469,
        },
        {
          __typename: 'Points',
          x: 4960,
          y: 498.8000183105469,
        },
        {
          __typename: 'Points',
          x: 4980,
          y: 499.20001220703125,
        },
        {
          __typename: 'Points',
          x: 5000,
          y: 499.20001220703125,
        },
        {
          __typename: 'Points',
          x: 5280,
          y: 499.20001220703125,
        },
        {
          __typename: 'Points',
          x: 5300,
          y: 492,
        },
        {
          __typename: 'Points',
          x: 5320,
          y: 469.6000061035156,
        },
        {
          __typename: 'Points',
          x: 5340,
          y: 451.20001220703125,
        },
        {
          __typename: 'Points',
          x: 5360,
          y: 433.6000061035156,
        },
        {
          __typename: 'Points',
          x: 5380,
          y: 414.8000183105469,
        },
        {
          __typename: 'Points',
          x: 5400,
          y: 398.3999938964844,
        },
        {
          __typename: 'Points',
          x: 5420,
          y: 382,
        },
        {
          __typename: 'Points',
          x: 5440,
          y: 366.8000183105469,
        },
        {
          __typename: 'Points',
          x: 5460,
          y: 352.3999938964844,
        },
        {
          __typename: 'Points',
          x: 5480,
          y: 338.3999938964844,
        },
        {
          __typename: 'Points',
          x: 5500,
          y: 324.3999938964844,
        },
        {
          __typename: 'Points',
          x: 5520,
          y: 310.8000183105469,
        },
        {
          __typename: 'Points',
          x: 5540,
          y: 297.20001220703125,
        },
        {
          __typename: 'Points',
          x: 5560,
          y: 284.3999938964844,
        },
        {
          __typename: 'Points',
          x: 5580,
          y: 271.20001220703125,
        },
        {
          __typename: 'Points',
          x: 5600,
          y: 258.8000183105469,
        },
        {
          __typename: 'Points',
          x: 5620,
          y: 246.40000915527344,
        },
        {
          __typename: 'Points',
          x: 5640,
          y: 234.40000915527344,
        },
        {
          __typename: 'Points',
          x: 5660,
          y: 222.8000030517578,
        },
        {
          __typename: 'Points',
          x: 5680,
          y: 211.1999969482422,
        },
        {
          __typename: 'Points',
          x: 5700,
          y: 200,
        },
        {
          __typename: 'Points',
          x: 5720,
          y: 189.1999969482422,
        },
        {
          __typename: 'Points',
          x: 5740,
          y: 178.8000030517578,
        },
        {
          __typename: 'Points',
          x: 5760,
          y: 168.40000915527344,
        },
        {
          __typename: 'Points',
          x: 5780,
          y: 158.8000030517578,
        },
        {
          __typename: 'Points',
          x: 5800,
          y: 149.1999969482422,
        },
        {
          __typename: 'Points',
          x: 5820,
          y: 140,
        },
        {
          __typename: 'Points',
          x: 5840,
          y: 131.1999969482422,
        },
        {
          __typename: 'Points',
          x: 5860,
          y: 122.80000305175781,
        },
        {
          __typename: 'Points',
          x: 5880,
          y: 114.80000305175781,
        },
        {
          __typename: 'Points',
          x: 5900,
          y: 107.20000457763672,
        },
        {
          __typename: 'Points',
          x: 5920,
          y: 99.5999984741211,
        },
        {
          __typename: 'Points',
          x: 5940,
          y: 92.4000015258789,
        },
        {
          __typename: 'Points',
          x: 5960,
          y: 85.5999984741211,
        },
        {
          __typename: 'Points',
          x: 5980,
          y: 79.20000457763672,
        },
        {
          __typename: 'Points',
          x: 6000,
          y: 73.20000457763672,
        },
        {
          __typename: 'Points',
          x: 6020,
          y: 67.20000457763672,
        },
        {
          __typename: 'Points',
          x: 6040,
          y: 62,
        },
        {
          __typename: 'Points',
          x: 6060,
          y: 56.79999923706055,
        },
        {
          __typename: 'Points',
          x: 6080,
          y: 52,
        },
        {
          __typename: 'Points',
          x: 6100,
          y: 48,
        },
        {
          __typename: 'Points',
          x: 6120,
          y: 44,
        },
        {
          __typename: 'Points',
          x: 6140,
          y: 40.400001525878906,
        },
        {
          __typename: 'Points',
          x: 6160,
          y: 37.20000076293945,
        },
        {
          __typename: 'Points',
          x: 6180,
          y: 34.400001525878906,
        },
        {
          __typename: 'Points',
          x: 6200,
          y: 32,
        },
        {
          __typename: 'Points',
          x: 6220,
          y: 30,
        },
        {
          __typename: 'Points',
          x: 6240,
          y: 28,
        },
        {
          __typename: 'Points',
          x: 6260,
          y: 26.80000114440918,
        },
        {
          __typename: 'Points',
          x: 6280,
          y: 26,
        },
        {
          __typename: 'Points',
          x: 6300,
          y: 25.200000762939453,
        },
        {
          __typename: 'Points',
          x: 6320,
          y: 24.399999618530273,
        },
        {
          __typename: 'Points',
          x: 6340,
          y: 24,
        },
        {
          __typename: 'Points',
          x: 6380,
          y: 23.200000762939453,
        },
        {
          __typename: 'Points',
          x: 6400,
          y: 23.200000762939453,
        },
        {
          __typename: 'Points',
          x: 6420,
          y: 22.80000114440918,
        },
        {
          __typename: 'Points',
          x: 6440,
          y: 22.80000114440918,
        },
        {
          __typename: 'Points',
          x: 6520,
          y: 22.80000114440918,
        },
        {
          __typename: 'Points',
          x: 6540,
          y: 22.399999618530273,
        },
        {
          __typename: 'Points',
          x: 6560,
          y: 22.399999618530273,
        },
        {
          __typename: 'Points',
          x: 6780,
          y: 22.399999618530273,
        },
        {
          __typename: 'Points',
          x: 6800,
          y: 22,
        },
        {
          __typename: 'Points',
          x: 6820,
          y: 22,
        },
        {
          __typename: 'Points',
          x: 6900,
          y: 22,
        },
        {
          __typename: 'Points',
          x: 6920,
          y: 21.600000381469727,
        },
        {
          __typename: 'Points',
          x: 6940,
          y: 21.600000381469727,
        },
        {
          __typename: 'Points',
          x: 7000,
          y: 21.600000381469727,
        },
        {
          __typename: 'Points',
          x: 7020,
          y: 21.200000762939453,
        },
        {
          __typename: 'Points',
          x: 7040,
          y: 21.200000762939453,
        },
        {
          __typename: 'Points',
          x: 7100,
          y: 21.200000762939453,
        },
        {
          __typename: 'Points',
          x: 7120,
          y: 20.80000114440918,
        },
        {
          __typename: 'Points',
          x: 7140,
          y: 20.80000114440918,
        },
        {
          __typename: 'Points',
          x: 7160,
          y: 20.80000114440918,
        },
        {
          __typename: 'Points',
          x: 7180,
          y: 20.399999618530273,
        },
        {
          __typename: 'Points',
          x: 7200,
          y: 20.399999618530273,
        },
        {
          __typename: 'Points',
          x: 7280,
          y: 20.399999618530273,
        },
        {
          __typename: 'Points',
          x: 7300,
          y: 20,
        },
        {
          __typename: 'Points',
          x: 7320,
          y: 20,
        },
        {
          __typename: 'Points',
          x: 7360,
          y: 20,
        },
        {
          __typename: 'Points',
          x: 7380,
          y: 19.600000381469727,
        },
        {
          __typename: 'Points',
          x: 7400,
          y: 19.600000381469727,
        },
        {
          __typename: 'Points',
          x: 7440,
          y: 19.600000381469727,
        },
        {
          __typename: 'Points',
          x: 7460,
          y: 19.200000762939453,
        },
        {
          __typename: 'Points',
          x: 7480,
          y: 19.200000762939453,
        },
        {
          __typename: 'Points',
          x: 7520,
          y: 19.200000762939453,
        },
        {
          __typename: 'Points',
          x: 7540,
          y: 18.80000114440918,
        },
        {
          __typename: 'Points',
          x: 7560,
          y: 18.80000114440918,
        },
        {
          __typename: 'Points',
          x: 7620,
          y: 18.80000114440918,
        },
        {
          __typename: 'Points',
          x: 7640,
          y: 18.399999618530273,
        },
        {
          __typename: 'Points',
          x: 7660,
          y: 18.399999618530273,
        },
        {
          __typename: 'Points',
          x: 7720,
          y: 18.399999618530273,
        },
        {
          __typename: 'Points',
          x: 7740,
          y: 18,
        },
        {
          __typename: 'Points',
          x: 7760,
          y: 18,
        },
        {
          __typename: 'Points',
          x: 7820,
          y: 18,
        },
        {
          __typename: 'Points',
          x: 7840,
          y: 17.600000381469727,
        },
        {
          __typename: 'Points',
          x: 7860,
          y: 17.600000381469727,
        },
        {
          __typename: 'Points',
          x: 7920,
          y: 17.600000381469727,
        },
        {
          __typename: 'Points',
          x: 7940,
          y: 17.200000762939453,
        },
        {
          __typename: 'Points',
          x: 7960,
          y: 17.200000762939453,
        },
        {
          __typename: 'Points',
          x: 7980,
          y: 17.600000381469727,
        },
        {
          __typename: 'Points',
          x: 8000,
          y: 2,
        },
        {
          __typename: 'Points',
          x: 8020,
          y: 5.599999904632568,
        },
        {
          __typename: 'Points',
          x: 8040,
          y: 10.800000190734863,
        },
        {
          __typename: 'Points',
          x: 8060,
          y: 17.600000381469727,
        },
        {
          __typename: 'Points',
          x: 8080,
          y: 25.600000381469727,
        },
        {
          __typename: 'Points',
          x: 8100,
          y: 34.79999923706055,
        },
        {
          __typename: 'Points',
          x: 8120,
          y: 46,
        },
        {
          __typename: 'Points',
          x: 8140,
          y: 58.79999923706055,
        },
        {
          __typename: 'Points',
          x: 8160,
          y: 70.80000305175781,
        },
        {
          __typename: 'Points',
          x: 8180,
          y: 82.80000305175781,
        },
        {
          __typename: 'Points',
          x: 8200,
          y: 95.20000457763672,
        },
        {
          __typename: 'Points',
          x: 8220,
          y: 107.20000457763672,
        },
        {
          __typename: 'Points',
          x: 8240,
          y: 119.20000457763672,
        },
        {
          __typename: 'Points',
          x: 8260,
          y: 131.60000610351562,
        },
        {
          __typename: 'Points',
          x: 8280,
          y: 143.60000610351562,
        },
        {
          __typename: 'Points',
          x: 8300,
          y: 156,
        },
        {
          __typename: 'Points',
          x: 8320,
          y: 168,
        },
        {
          __typename: 'Points',
          x: 8340,
          y: 180.40000915527344,
        },
        {
          __typename: 'Points',
          x: 8360,
          y: 192.40000915527344,
        },
        {
          __typename: 'Points',
          x: 8380,
          y: 204.40000915527344,
        },
        {
          __typename: 'Points',
          x: 8400,
          y: 216.8000030517578,
        },
        {
          __typename: 'Points',
          x: 8420,
          y: 228.8000030517578,
        },
        {
          __typename: 'Points',
          x: 8440,
          y: 240.8000030517578,
        },
        {
          __typename: 'Points',
          x: 8460,
          y: 253.1999969482422,
        },
        {
          __typename: 'Points',
          x: 8480,
          y: 265.20001220703125,
        },
        {
          __typename: 'Points',
          x: 8500,
          y: 277.6000061035156,
        },
        {
          __typename: 'Points',
          x: 8520,
          y: 289.6000061035156,
        },
        {
          __typename: 'Points',
          x: 8540,
          y: 301.6000061035156,
        },
        {
          __typename: 'Points',
          x: 8560,
          y: 314,
        },
        {
          __typename: 'Points',
          x: 8580,
          y: 326,
        },
        {
          __typename: 'Points',
          x: 8600,
          y: 338.3999938964844,
        },
        {
          __typename: 'Points',
          x: 8620,
          y: 350.3999938964844,
        },
        {
          __typename: 'Points',
          x: 8640,
          y: 362.3999938964844,
        },
        {
          __typename: 'Points',
          x: 8660,
          y: 374.8000183105469,
        },
        {
          __typename: 'Points',
          x: 8680,
          y: 386.8000183105469,
        },
        {
          __typename: 'Points',
          x: 8700,
          y: 399.20001220703125,
        },
        {
          __typename: 'Points',
          x: 8720,
          y: 411.20001220703125,
        },
        {
          __typename: 'Points',
          x: 8740,
          y: 423.20001220703125,
        },
        {
          __typename: 'Points',
          x: 8760,
          y: 435.6000061035156,
        },
        {
          __typename: 'Points',
          x: 8780,
          y: 447.6000061035156,
        },
        {
          __typename: 'Points',
          x: 8800,
          y: 459.6000061035156,
        },
        {
          __typename: 'Points',
          x: 8820,
          y: 472,
        },
        {
          __typename: 'Points',
          x: 8840,
          y: 484,
        },
        {
          __typename: 'Points',
          x: 8860,
          y: 496,
        },
        {
          __typename: 'Points',
          x: 8880,
          y: 498.8000183105469,
        },
        {
          __typename: 'Points',
          x: 8900,
          y: 498.8000183105469,
        },
        {
          __typename: 'Points',
          x: 9040,
          y: 498.8000183105469,
        },
        {
          __typename: 'Points',
          x: 9060,
          y: 499.20001220703125,
        },
        {
          __typename: 'Points',
          x: 9080,
          y: 499.20001220703125,
        },
        {
          __typename: 'Points',
          x: 9280,
          y: 499.20001220703125,
        },
        {
          __typename: 'Points',
          x: 9300,
          y: 493.20001220703125,
        },
        {
          __typename: 'Points',
          x: 9320,
          y: 471.6000061035156,
        },
        {
          __typename: 'Points',
          x: 9340,
          y: 452.8000183105469,
        },
        {
          __typename: 'Points',
          x: 9360,
          y: 436,
        },
        {
          __typename: 'Points',
          x: 9380,
          y: 417.6000061035156,
        },
        {
          __typename: 'Points',
          x: 9400,
          y: 400.8000183105469,
        },
        {
          __typename: 'Points',
          x: 9420,
          y: 384.3999938964844,
        },
        {
          __typename: 'Points',
          x: 9440,
          y: 369.20001220703125,
        },
        {
          __typename: 'Points',
          x: 9460,
          y: 354.3999938964844,
        },
        {
          __typename: 'Points',
          x: 9480,
          y: 340.3999938964844,
        },
        {
          __typename: 'Points',
          x: 9500,
          y: 326.8000183105469,
        },
        {
          __typename: 'Points',
          x: 9520,
          y: 313.20001220703125,
        },
        {
          __typename: 'Points',
          x: 9540,
          y: 299.6000061035156,
        },
        {
          __typename: 'Points',
          x: 9560,
          y: 286.3999938964844,
        },
        {
          __typename: 'Points',
          x: 9580,
          y: 273.6000061035156,
        },
        {
          __typename: 'Points',
          x: 9600,
          y: 260.8000183105469,
        },
        {
          __typename: 'Points',
          x: 9620,
          y: 248.8000030517578,
        },
        {
          __typename: 'Points',
          x: 9640,
          y: 236.8000030517578,
        },
        {
          __typename: 'Points',
          x: 9660,
          y: 225.1999969482422,
        },
        {
          __typename: 'Points',
          x: 9680,
          y: 213.60000610351562,
        },
        {
          __typename: 'Points',
          x: 9700,
          y: 202.40000915527344,
        },
        {
          __typename: 'Points',
          x: 9720,
          y: 191.60000610351562,
        },
        {
          __typename: 'Points',
          x: 9740,
          y: 181.1999969482422,
        },
        {
          __typename: 'Points',
          x: 9760,
          y: 171.1999969482422,
        },
        {
          __typename: 'Points',
          x: 9780,
          y: 161.1999969482422,
        },
        {
          __typename: 'Points',
          x: 9800,
          y: 152,
        },
        {
          __typename: 'Points',
          x: 9820,
          y: 142.40000915527344,
        },
        {
          __typename: 'Points',
          x: 9840,
          y: 133.60000610351562,
        },
        {
          __typename: 'Points',
          x: 9860,
          y: 125.20000457763672,
        },
        {
          __typename: 'Points',
          x: 9880,
          y: 117.20000457763672,
        },
        {
          __typename: 'Points',
          x: 9900,
          y: 109.20000457763672,
        },
        {
          __typename: 'Points',
          x: 9920,
          y: 102,
        },
        {
          __typename: 'Points',
          x: 9940,
          y: 94.80000305175781,
        },
        {
          __typename: 'Points',
          x: 9960,
          y: 88,
        },
        {
          __typename: 'Points',
          x: 9980,
          y: 81.5999984741211,
        },
        {
          __typename: 'Points',
          x: 10000,
          y: 75.5999984741211,
        },
        {
          __typename: 'Points',
          x: 10020,
          y: 69.5999984741211,
        },
        {
          __typename: 'Points',
          x: 10040,
          y: 64.4000015258789,
        },
        {
          __typename: 'Points',
          x: 10060,
          y: 59.20000076293945,
        },
        {
          __typename: 'Points',
          x: 10080,
          y: 54.400001525878906,
        },
        {
          __typename: 'Points',
          x: 10100,
          y: 50.400001525878906,
        },
        {
          __typename: 'Points',
          x: 10120,
          y: 46.400001525878906,
        },
        {
          __typename: 'Points',
          x: 10140,
          y: 42.79999923706055,
        },
        {
          __typename: 'Points',
          x: 10160,
          y: 39.60000228881836,
        },
        {
          __typename: 'Points',
          x: 10180,
          y: 36.400001525878906,
        },
        {
          __typename: 'Points',
          x: 10200,
          y: 34,
        },
        {
          __typename: 'Points',
          x: 10220,
          y: 32,
        },
        {
          __typename: 'Points',
          x: 10240,
          y: 30.399999618530273,
        },
        {
          __typename: 'Points',
          x: 10260,
          y: 29.200000762939453,
        },
        {
          __typename: 'Points',
          x: 10280,
          y: 28,
        },
        {
          __typename: 'Points',
          x: 10300,
          y: 27.600000381469727,
        },
        {
          __typename: 'Points',
          x: 10320,
          y: 26.80000114440918,
        },
        {
          __typename: 'Points',
          x: 10340,
          y: 26.399999618530273,
        },
        {
          __typename: 'Points',
          x: 10360,
          y: 26,
        },
        {
          __typename: 'Points',
          x: 10380,
          y: 26,
        },
        {
          __typename: 'Points',
          x: 10400,
          y: 25.600000381469727,
        },
        {
          __typename: 'Points',
          x: 10420,
          y: 25.600000381469727,
        },
        {
          __typename: 'Points',
          x: 10440,
          y: 25.600000381469727,
        },
        {
          __typename: 'Points',
          x: 10460,
          y: 25.200000762939453,
        },
        {
          __typename: 'Points',
          x: 10480,
          y: 25.200000762939453,
        },
        {
          __typename: 'Points',
          x: 10580,
          y: 25.200000762939453,
        },
        {
          __typename: 'Points',
          x: 10600,
          y: 24.80000114440918,
        },
        {
          __typename: 'Points',
          x: 10620,
          y: 24.80000114440918,
        },
        {
          __typename: 'Points',
          x: 10820,
          y: 24.80000114440918,
        },
        {
          __typename: 'Points',
          x: 10840,
          y: 24.399999618530273,
        },
        {
          __typename: 'Points',
          x: 10860,
          y: 24.399999618530273,
        },
        {
          __typename: 'Points',
          x: 10960,
          y: 24.399999618530273,
        },
        {
          __typename: 'Points',
          x: 10980,
          y: 24,
        },
        {
          __typename: 'Points',
          x: 11000,
          y: 24,
        },
        {
          __typename: 'Points',
          x: 11060,
          y: 24,
        },
        {
          __typename: 'Points',
          x: 11080,
          y: 23.600000381469727,
        },
        {
          __typename: 'Points',
          x: 11100,
          y: 23.600000381469727,
        },
        {
          __typename: 'Points',
          x: 11120,
          y: 23.600000381469727,
        },
        {
          __typename: 'Points',
          x: 11140,
          y: 23.200000762939453,
        },
        {
          __typename: 'Points',
          x: 11160,
          y: 23.200000762939453,
        },
        {
          __typename: 'Points',
          x: 11200,
          y: 23.200000762939453,
        },
        {
          __typename: 'Points',
          x: 11220,
          y: 22.80000114440918,
        },
        {
          __typename: 'Points',
          x: 11240,
          y: 22.80000114440918,
        },
        {
          __typename: 'Points',
          x: 11280,
          y: 22.80000114440918,
        },
        {
          __typename: 'Points',
          x: 11300,
          y: 22.399999618530273,
        },
        {
          __typename: 'Points',
          x: 11320,
          y: 22.399999618530273,
        },
        {
          __typename: 'Points',
          x: 11380,
          y: 22.399999618530273,
        },
        {
          __typename: 'Points',
          x: 11400,
          y: 22,
        },
        {
          __typename: 'Points',
          x: 11420,
          y: 22,
        },
        {
          __typename: 'Points',
          x: 11440,
          y: 22,
        },
        {
          __typename: 'Points',
          x: 11460,
          y: 21.600000381469727,
        },
        {
          __typename: 'Points',
          x: 11480,
          y: 21.600000381469727,
        },
        {
          __typename: 'Points',
          x: 11540,
          y: 21.600000381469727,
        },
        {
          __typename: 'Points',
          x: 11560,
          y: 21.200000762939453,
        },
        {
          __typename: 'Points',
          x: 11580,
          y: 21.200000762939453,
        },
        {
          __typename: 'Points',
          x: 11640,
          y: 21.200000762939453,
        },
        {
          __typename: 'Points',
          x: 11660,
          y: 20.80000114440918,
        },
        {
          __typename: 'Points',
          x: 11680,
          y: 20.80000114440918,
        },
        {
          __typename: 'Points',
          x: 11740,
          y: 20.80000114440918,
        },
        {
          __typename: 'Points',
          x: 11760,
          y: 20.399999618530273,
        },
        {
          __typename: 'Points',
          x: 11780,
          y: 20.399999618530273,
        },
        {
          __typename: 'Points',
          x: 11840,
          y: 20.399999618530273,
        },
        {
          __typename: 'Points',
          x: 11860,
          y: 20,
        },
        {
          __typename: 'Points',
          x: 11880,
          y: 20,
        },
        {
          __typename: 'Points',
          x: 11940,
          y: 20,
        },
        {
          __typename: 'Points',
          x: 11960,
          y: 19.600000381469727,
        },
        {
          __typename: 'Points',
          x: 11980,
          y: 19.600000381469727,
        },
        {
          __typename: 'Points',
          x: 12000,
          y: 2,
        },
        {
          __typename: 'Points',
          x: 12020,
          y: 5.200000286102295,
        },
        {
          __typename: 'Points',
          x: 12040,
          y: 10.40000057220459,
        },
        {
          __typename: 'Points',
          x: 12060,
          y: 16.80000114440918,
        },
        {
          __typename: 'Points',
          x: 12080,
          y: 24.80000114440918,
        },
        {
          __typename: 'Points',
          x: 12100,
          y: 34,
        },
        {
          __typename: 'Points',
          x: 12120,
          y: 44.79999923706055,
        },
        {
          __typename: 'Points',
          x: 12140,
          y: 57.20000076293945,
        },
        {
          __typename: 'Points',
          x: 12160,
          y: 69.20000457763672,
        },
        {
          __typename: 'Points',
          x: 12180,
          y: 81.5999984741211,
        },
        {
          __typename: 'Points',
          x: 12200,
          y: 93.5999984741211,
        },
        {
          __typename: 'Points',
          x: 12220,
          y: 105.5999984741211,
        },
        {
          __typename: 'Points',
          x: 12240,
          y: 118,
        },
        {
          __typename: 'Points',
          x: 12260,
          y: 130,
        },
        {
          __typename: 'Points',
          x: 12280,
          y: 142.40000915527344,
        },
        {
          __typename: 'Points',
          x: 12300,
          y: 154.40000915527344,
        },
        {
          __typename: 'Points',
          x: 12320,
          y: 166.40000915527344,
        },
        {
          __typename: 'Points',
          x: 12340,
          y: 178.8000030517578,
        },
        {
          __typename: 'Points',
          x: 12360,
          y: 190.8000030517578,
        },
        {
          __typename: 'Points',
          x: 12380,
          y: 202.8000030517578,
        },
        {
          __typename: 'Points',
          x: 12400,
          y: 215.1999969482422,
        },
        {
          __typename: 'Points',
          x: 12420,
          y: 227.1999969482422,
        },
        {
          __typename: 'Points',
          x: 12440,
          y: 239.1999969482422,
        },
        {
          __typename: 'Points',
          x: 12460,
          y: 251.60000610351562,
        },
        {
          __typename: 'Points',
          x: 12480,
          y: 263.6000061035156,
        },
        {
          __typename: 'Points',
          x: 12500,
          y: 276,
        },
        {
          __typename: 'Points',
          x: 12520,
          y: 288,
        },
        {
          __typename: 'Points',
          x: 12540,
          y: 300,
        },
        {
          __typename: 'Points',
          x: 12560,
          y: 312.3999938964844,
        },
        {
          __typename: 'Points',
          x: 12580,
          y: 324.3999938964844,
        },
        {
          __typename: 'Points',
          x: 12600,
          y: 336.3999938964844,
        },
        {
          __typename: 'Points',
          x: 12620,
          y: 348.8000183105469,
        },
        {
          __typename: 'Points',
          x: 12640,
          y: 360.8000183105469,
        },
        {
          __typename: 'Points',
          x: 12660,
          y: 372.8000183105469,
        },
        {
          __typename: 'Points',
          x: 12680,
          y: 385.20001220703125,
        },
        {
          __typename: 'Points',
          x: 12700,
          y: 397.20001220703125,
        },
        {
          __typename: 'Points',
          x: 12720,
          y: 409.20001220703125,
        },
        {
          __typename: 'Points',
          x: 12740,
          y: 421.6000061035156,
        },
        {
          __typename: 'Points',
          x: 12760,
          y: 433.6000061035156,
        },
        {
          __typename: 'Points',
          x: 12780,
          y: 445.6000061035156,
        },
        {
          __typename: 'Points',
          x: 12800,
          y: 458,
        },
        {
          __typename: 'Points',
          x: 12820,
          y: 470,
        },
        {
          __typename: 'Points',
          x: 12840,
          y: 482,
        },
        {
          __typename: 'Points',
          x: 12860,
          y: 494.3999938964844,
        },
        {
          __typename: 'Points',
          x: 12880,
          y: 498.3999938964844,
        },
        {
          __typename: 'Points',
          x: 12900,
          y: 498.3999938964844,
        },
        {
          __typename: 'Points',
          x: 12940,
          y: 498.3999938964844,
        },
        {
          __typename: 'Points',
          x: 12960,
          y: 498.8000183105469,
        },
        {
          __typename: 'Points',
          x: 12980,
          y: 498.8000183105469,
        },
        {
          __typename: 'Points',
          x: 13280,
          y: 498.8000183105469,
        },
        {
          __typename: 'Points',
          x: 13300,
          y: 494.8000183105469,
        },
        {
          __typename: 'Points',
          x: 13320,
          y: 473.6000061035156,
        },
        {
          __typename: 'Points',
          x: 13340,
          y: 454.3999938964844,
        },
        {
          __typename: 'Points',
          x: 13360,
          y: 437.20001220703125,
        },
        {
          __typename: 'Points',
          x: 13380,
          y: 418,
        },
        {
          __typename: 'Points',
          x: 13400,
          y: 401.6000061035156,
        },
        {
          __typename: 'Points',
          x: 13420,
          y: 385.20001220703125,
        },
        {
          __typename: 'Points',
          x: 13440,
          y: 369.6000061035156,
        },
        {
          __typename: 'Points',
          x: 13460,
          y: 354.8000183105469,
        },
        {
          __typename: 'Points',
          x: 13480,
          y: 340.8000183105469,
        },
        {
          __typename: 'Points',
          x: 13500,
          y: 327.20001220703125,
        },
        {
          __typename: 'Points',
          x: 13520,
          y: 313.20001220703125,
        },
        {
          __typename: 'Points',
          x: 13540,
          y: 299.6000061035156,
        },
        {
          __typename: 'Points',
          x: 13560,
          y: 286.8000183105469,
        },
        {
          __typename: 'Points',
          x: 13580,
          y: 273.6000061035156,
        },
        {
          __typename: 'Points',
          x: 13600,
          y: 260.8000183105469,
        },
        {
          __typename: 'Points',
          x: 13620,
          y: 248.40000915527344,
        },
        {
          __typename: 'Points',
          x: 13640,
          y: 236.40000915527344,
        },
        {
          __typename: 'Points',
          x: 13660,
          y: 224.8000030517578,
        },
        {
          __typename: 'Points',
          x: 13680,
          y: 213.1999969482422,
        },
        {
          __typename: 'Points',
          x: 13700,
          y: 202.40000915527344,
        },
        {
          __typename: 'Points',
          x: 13720,
          y: 191.60000610351562,
        },
        {
          __typename: 'Points',
          x: 13740,
          y: 180.8000030517578,
        },
        {
          __typename: 'Points',
          x: 13760,
          y: 170.8000030517578,
        },
        {
          __typename: 'Points',
          x: 13780,
          y: 160.8000030517578,
        },
        {
          __typename: 'Points',
          x: 13800,
          y: 151.60000610351562,
        },
        {
          __typename: 'Points',
          x: 13820,
          y: 142.40000915527344,
        },
        {
          __typename: 'Points',
          x: 13840,
          y: 133.60000610351562,
        },
        {
          __typename: 'Points',
          x: 13860,
          y: 125.20000457763672,
        },
        {
          __typename: 'Points',
          x: 13880,
          y: 116.80000305175781,
        },
        {
          __typename: 'Points',
          x: 13900,
          y: 109.20000457763672,
        },
        {
          __typename: 'Points',
          x: 13920,
          y: 101.5999984741211,
        },
        {
          __typename: 'Points',
          x: 13940,
          y: 94.4000015258789,
        },
        {
          __typename: 'Points',
          x: 13960,
          y: 87.5999984741211,
        },
        {
          __typename: 'Points',
          x: 13980,
          y: 81.20000457763672,
        },
        {
          __typename: 'Points',
          x: 14000,
          y: 75.20000457763672,
        },
        {
          __typename: 'Points',
          x: 14020,
          y: 69.20000457763672,
        },
        {
          __typename: 'Points',
          x: 14040,
          y: 64,
        },
        {
          __typename: 'Points',
          x: 14060,
          y: 58.79999923706055,
        },
        {
          __typename: 'Points',
          x: 14080,
          y: 54,
        },
        {
          __typename: 'Points',
          x: 14100,
          y: 49.60000228881836,
        },
        {
          __typename: 'Points',
          x: 14120,
          y: 45.60000228881836,
        },
        {
          __typename: 'Points',
          x: 14140,
          y: 42,
        },
        {
          __typename: 'Points',
          x: 14160,
          y: 38.79999923706055,
        },
        {
          __typename: 'Points',
          x: 14180,
          y: 35.60000228881836,
        },
        {
          __typename: 'Points',
          x: 14200,
          y: 33.20000076293945,
        },
        {
          __typename: 'Points',
          x: 14220,
          y: 31.200000762939453,
        },
        {
          __typename: 'Points',
          x: 14240,
          y: 29.200000762939453,
        },
        {
          __typename: 'Points',
          x: 14260,
          y: 28,
        },
        {
          __typename: 'Points',
          x: 14280,
          y: 26.80000114440918,
        },
        {
          __typename: 'Points',
          x: 14300,
          y: 26.399999618530273,
        },
        {
          __typename: 'Points',
          x: 14320,
          y: 25.600000381469727,
        },
        {
          __typename: 'Points',
          x: 14340,
          y: 25.200000762939453,
        },
        {
          __typename: 'Points',
          x: 14360,
          y: 24.80000114440918,
        },
        {
          __typename: 'Points',
          x: 14380,
          y: 24.399999618530273,
        },
        {
          __typename: 'Points',
          x: 14400,
          y: 24,
        },
        {
          __typename: 'Points',
          x: 14420,
          y: 24,
        },
        {
          __typename: 'Points',
          x: 14440,
          y: 24,
        },
        {
          __typename: 'Points',
          x: 14460,
          y: 23.600000381469727,
        },
        {
          __typename: 'Points',
          x: 14480,
          y: 23.600000381469727,
        },
        {
          __typename: 'Points',
          x: 14560,
          y: 23.600000381469727,
        },
        {
          __typename: 'Points',
          x: 14580,
          y: 23.200000762939453,
        },
        {
          __typename: 'Points',
          x: 14600,
          y: 23.200000762939453,
        },
        {
          __typename: 'Points',
          x: 14820,
          y: 23.200000762939453,
        },
        {
          __typename: 'Points',
          x: 14840,
          y: 22.80000114440918,
        },
        {
          __typename: 'Points',
          x: 14860,
          y: 22.80000114440918,
        },
        {
          __typename: 'Points',
          x: 14960,
          y: 22.80000114440918,
        },
        {
          __typename: 'Points',
          x: 14980,
          y: 22.399999618530273,
        },
        {
          __typename: 'Points',
          x: 15000,
          y: 22.399999618530273,
        },
        {
          __typename: 'Points',
          x: 15060,
          y: 22.399999618530273,
        },
        {
          __typename: 'Points',
          x: 15080,
          y: 22,
        },
        {
          __typename: 'Points',
          x: 15100,
          y: 22,
        },
        {
          __typename: 'Points',
          x: 15160,
          y: 22,
        },
        {
          __typename: 'Points',
          x: 15180,
          y: 21.600000381469727,
        },
        {
          __typename: 'Points',
          x: 15200,
          y: 21.600000381469727,
        },
        {
          __typename: 'Points',
          x: 15240,
          y: 21.600000381469727,
        },
        {
          __typename: 'Points',
          x: 15260,
          y: 21.200000762939453,
        },
        {
          __typename: 'Points',
          x: 15280,
          y: 21.200000762939453,
        },
        {
          __typename: 'Points',
          x: 15360,
          y: 21.200000762939453,
        },
        {
          __typename: 'Points',
          x: 15380,
          y: 20.80000114440918,
        },
        {
          __typename: 'Points',
          x: 15400,
          y: 20.80000114440918,
        },
        {
          __typename: 'Points',
          x: 15460,
          y: 20.80000114440918,
        },
        {
          __typename: 'Points',
          x: 15480,
          y: 20.399999618530273,
        },
        {
          __typename: 'Points',
          x: 15500,
          y: 20.399999618530273,
        },
        {
          __typename: 'Points',
          x: 15540,
          y: 20.399999618530273,
        },
        {
          __typename: 'Points',
          x: 15560,
          y: 20,
        },
        {
          __typename: 'Points',
          x: 15580,
          y: 20,
        },
        {
          __typename: 'Points',
          x: 15640,
          y: 20,
        },
        {
          __typename: 'Points',
          x: 15660,
          y: 19.600000381469727,
        },
        {
          __typename: 'Points',
          x: 15680,
          y: 19.600000381469727,
        },
        {
          __typename: 'Points',
          x: 15760,
          y: 19.600000381469727,
        },
        {
          __typename: 'Points',
          x: 15780,
          y: 19.200000762939453,
        },
        {
          __typename: 'Points',
          x: 15800,
          y: 19.200000762939453,
        },
        {
          __typename: 'Points',
          x: 15880,
          y: 19.200000762939453,
        },
        {
          __typename: 'Points',
          x: 15900,
          y: 18.80000114440918,
        },
        {
          __typename: 'Points',
          x: 15920,
          y: 18.80000114440918,
        },
        {
          __typename: 'Points',
          x: 16000,
          y: 18.80000114440918,
        },
      ],
    },
  }),
  AirWaves: () => {
    let callback = () => { /* */ };

    const interval = setInterval(() => {
      callback({
        airWaves: {
          airFlowWave: renderGraph(airFlow),
          airPressureWave: renderGraph(airPressure),
          airVolumeWave: renderGraph(airVolume),
        },
      });
    }, 17000);

    return {
      onData: (func) => {
        callback = func;
      },
      unsubscribe: () => {
        clearInterval(interval);
      },
    };
  },
  GetAirLatest: () => ({
    getAirLatest: {
      ventMode: 'VS_PRVC',
      flowTrigger: 'ASSISTED',
      flowControl: 'VOLUME',
      info: airLatest,
    },
  }),
};
